
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iqENN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DashboardReadOnly", () => $f7f0a5b36aaaab3e$export$aa188e8cc04077b4);
$parcel$export(module.exports, "default", () => $f7f0a5b36aaaab3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lL5b5 = parcelRequire("lL5b5");

var $JIPqS = parcelRequire("JIPqS");

var $iyrll = parcelRequire("iyrll");

var $32Vhm = parcelRequire("32Vhm");

var $1rce7 = parcelRequire("1rce7");

var $1CEw6 = parcelRequire("1CEw6");

var $5HxxK = parcelRequire("5HxxK");

var $4kIa4 = parcelRequire("4kIa4");

var $h7J1E = parcelRequire("h7J1E");

var $beRD7 = parcelRequire("beRD7");

var $koVbs = parcelRequire("koVbs");

var $gh1hi = parcelRequire("gh1hi");

var $l8ruj = parcelRequire("l8ruj");

var $8CCTB = parcelRequire("8CCTB");

var $52i38 = parcelRequire("52i38");

var $fPA7s = parcelRequire("fPA7s");

var $cOK0t = parcelRequire("cOK0t");

var $32zIt = parcelRequire("32zIt");

var $kiq64 = parcelRequire("kiq64");
const $f7f0a5b36aaaab3e$export$aa188e8cc04077b4 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const { registerConnectGadget: registerConnectGadget, unregisterConnectGadget: unregisterConnectGadget, setCustomTitle: setCustomTitle } = (0, $h7J1E.useConnectGadgetTitles)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kIa4.DashboardContentContainer), {
        analyticsExperience: (0, $JIPqS.VIEW_DASHBOARD_READONLY_EXPERIENCE),
        resourceData: {
            data: data,
            error: error,
            loading: loading
        },
        permissionErrorFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.DashboardKnownErrorsPageAsync), {
            errorCode: (0, $8CCTB.getErrorCode)(error)
        }),
        saveCustomGadgetTitle: setCustomTitle
    }, data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32Vhm.DashboardController), {
        id: data.id,
        automaticRefreshMs: data.automaticRefreshMs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32zIt.HeaderReadOnly), {
        data: data,
        isEditLinkEnabled: data.writable,
        banners: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CEw6.EngagementBanners), {
            gadgets: data.gadgets,
            dashboardId: data.id
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HxxK.ColumnLayout), {
        data: data,
        dnd: null,
        columnPlaceholder: null,
        layoutPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fPA7s.EmptyDashboardPlaceholder), {
            hasEditPermissions: data.writable
        }),
        onLayoutReposition: null
    }, ({ dragHandleProps: _dragHandleProps, isDraggable: _isDraggable, isDragging: _isDragging, isAnyDragging: _isAnyDragging, ...gadgetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyrll.DashboardControllerContextConsumer), null, ({ refreshId: refreshId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOK0t.GadgetReadOnly), {
                dashboardId: data.id,
                refreshId: refreshId,
                unconfiguredFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kiq64.UnconfiguredGadgetFallback), {
                    id: gadgetProps.data.id,
                    hasEditPermissions: data.writable
                }),
                ...gadgetProps,
                onRegisterConnectGadget: registerConnectGadget,
                onUnregisterConnectGadget: unregisterConnectGadget
            })))) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f7f0a5b36aaaab3e$export$2e2bcd8739ae039 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "dashboard-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rce7.DashboardPageContainer), {
        analyticsSourceName: (0, $JIPqS.DASHBOARD_VIEW_SOURCENAME),
        analyticsExperience: (0, $JIPqS.VIEW_DASHBOARD_READONLY_EXPERIENCE),
        documentTitle: data?.title ?? formatMessage((0, $52i38.default).pageTitle),
        unauthenticatedFallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null),
        resourceData: {
            data: data,
            error: error,
            loading: loading
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f7f0a5b36aaaab3e$export$aa188e8cc04077b4, null)));
};

});
parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("iyrll", function(module, exports) {

$parcel$export(module.exports, "DashboardControllerContextProvider", () => $669a1fafb8f4566e$export$36eb228a17cae64d);
$parcel$export(module.exports, "DashboardControllerContextConsumer", () => $669a1fafb8f4566e$export$4ce01c0dbab5bb18);
$parcel$export(module.exports, "useDashboardRefresh", () => $669a1fafb8f4566e$export$71d14892f68b2430);
$parcel$export(module.exports, "useOnAddedGadget", () => $669a1fafb8f4566e$export$2471f3ee3e3601fe);

var $jnkfq = parcelRequire("jnkfq");
const { createUseContextField: $669a1fafb8f4566e$export$3fb47a2904db1f37, Provider: $669a1fafb8f4566e$export$36eb228a17cae64d, Consumer: $669a1fafb8f4566e$export$4ce01c0dbab5bb18 } = (0, $jnkfq.createRendererContext)();
const $669a1fafb8f4566e$export$71d14892f68b2430 = $669a1fafb8f4566e$export$3fb47a2904db1f37('onRefresh');
const $669a1fafb8f4566e$export$2471f3ee3e3601fe = $669a1fafb8f4566e$export$3fb47a2904db1f37('onAddedGadget');

});
parcelRegister("jnkfq", function(module, exports) {

$parcel$export(module.exports, "createRendererContext", () => $2cbc9584a68b4b0d$export$ac09db0e74937f7f);

var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
const $2cbc9584a68b4b0d$export$ac09db0e74937f7f = ()=>{
    const _UnmemoisedContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { Provider: UnmemoisedProvider, Consumer: Consumer } = _UnmemoisedContext;
    const Provider = /*#__PURE__*/ (0, $5uXOq.memo)(UnmemoisedProvider, ({ value: valueA, ...propsA }, { value: valueB, ...propsB })=>(0, $9pe79.default)(valueA, valueB) && (0, $9pe79.default)(propsA, propsB));
    const createRenderFunction = (children)=>(value)=>children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Provider, {
                value: value
            }, typeof children === 'function' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Consumer, null, children) : children) : null;
    const createUseContextField = (key)=>()=>{
            const value = (0, $5uXOq.useContext)(_UnmemoisedContext);
            if (value == null) throw new Error('context not found');
            return value[key];
        };
    return {
        _UnmemoisedContext: _UnmemoisedContext,
        Provider: Provider,
        Consumer: Consumer,
        createRenderFunction: createRenderFunction,
        createUseContextField: createUseContextField
    };
};

});


parcelRegister("32Vhm", function(module, exports) {

$parcel$export(module.exports, "DashboardController", () => $5e7fb5d7d6929ddb$export$b9771780c6ecf3f);

var $5uXOq = parcelRequire("5uXOq");

var $3v45P = parcelRequire("3v45P");

var $flEgL = parcelRequire("flEgL");

var $JIPqS = parcelRequire("JIPqS");

var $iyrll = parcelRequire("iyrll");
const $5e7fb5d7d6929ddb$export$d7eb50fb85f631d = ({ automaticRefreshMs: automaticRefreshMs })=>{
    const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
    const [, setMostRecentlyAddedGadgetId] = (0, $5uXOq.useState)(null);
    const onRefresh = (0, $5uXOq.useCallback)(()=>{
        (0, $3v45P.emit)((0, $JIPqS.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), {
            origin: 'dashboard'
        });
        (0, $flEgL.default)((0, $JIPqS.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {}, {
            origin: 'dashboard'
        });
        setRefreshId(Date.now());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs < 1) return ()=>undefined;
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    const onMount = (0, $5uXOq.useCallback)((gadgetId, focusCallback)=>{
        setMostRecentlyAddedGadgetId((mostRecentlyAddedGadgetId)=>{
            if (gadgetId === mostRecentlyAddedGadgetId) {
                focusCallback();
                return null;
            }
            return mostRecentlyAddedGadgetId;
        });
    }, []);
    return {
        onRefresh: onRefresh,
        refreshId: refreshId,
        onAddedGadget: setMostRecentlyAddedGadgetId,
        onMount: onMount
    };
};
const $5e7fb5d7d6929ddb$export$b9771780c6ecf3f = ({ children: children, ...props })=>{
    const value = $5e7fb5d7d6929ddb$export$d7eb50fb85f631d(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyrll.DashboardControllerContextProvider), {
        value: value
    }, children);
};

});
parcelRegister("3v45P", function(module, exports) {

$parcel$export(module.exports, "on", () => $b978cb322a482db9$export$af631764ddc44097);
$parcel$export(module.exports, "emit", () => $b978cb322a482db9$export$8f35fbd5db0f3634);
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $b978cb322a482db9$var$EVENT_PREFIX = 'forge.bridge.';
function $b978cb322a482db9$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
function $b978cb322a482db9$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$b978cb322a482db9$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
}

});

parcelRegister("flEgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28f43dbb1e0cb29$export$2e2bcd8739ae039);

var $hrlU6 = parcelRequire("hrlU6");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d28f43dbb1e0cb29$export$2e2bcd8739ae039 = (eventName, addonFilter, eventData)=>{
    (0, $hrlU6.withConnectHost)((host)=>{
        host && host.broadcastEvent(eventName, addonFilter, eventData);
    });
};

});


parcelRegister("1rce7", function(module, exports) {

$parcel$export(module.exports, "DashboardPageContainer", () => $e6660bef9b59d455$export$8aeaeff803e753cd);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2i4sA = parcelRequire("2i4sA");

var $id7K0 = parcelRequire("id7K0");

var $iXVV6 = parcelRequire("iXVV6");

var $9dbF6 = parcelRequire("9dbF6");

var $bVDE5 = parcelRequire("bVDE5");

var $9OXo1 = parcelRequire("9OXo1");

var $cRaE8 = parcelRequire("cRaE8");

var $he6UQ = parcelRequire("he6UQ");
const $e6660bef9b59d455$export$8aeaeff803e753cd = ({ children: children, analyticsSourceName: analyticsSourceName, analyticsExperience: analyticsExperience, unauthenticatedFallback: unauthenticatedFallback, unauthorisedFallback: unauthorisedFallback, documentTitle: documentTitle, resourceData: resourceData })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { data: data, loading: loading } = resourceData;
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const ref = (0, $he6UQ.useDashboardRef)();
    if (!tenantContext) return null;
    if (!tenantContext.atlassianAccountId && !loading && !data) return unauthenticatedFallback;
    if (unauthorisedFallback != null && data && !data.writable) return unauthorisedFallback;
    /**
   * we need to also mark this with the 'dashboardScreen' analytics source.
   * Otherwise, the source will default to 'navigationNextScreen'.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: analyticsSourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        containerId: data?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6660bef9b59d455$var$PageLayout, {
        ref: ref
    }, !isInitialRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cRaE8.PrefetchLinks), {
        dashboardId: data?.id ?? 'pending'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "dashboard",
        // Need className for some of some gadgets, e.g. Filter Count
        // Please always make sure the wrapper dom id and class are in the html response
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "dashboard",
        "data-testid": "dashboard-internal-common.ui.container.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: data?.id,
        experience: analyticsExperience,
        analyticsSource: "dashboard",
        edition: null,
        application: null
    }, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e6660bef9b59d455$var$PageLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw _kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cRaE8", function(module, exports) {

$parcel$export(module.exports, "PrefetchLinks", () => $956d4da8aa4ae614$export$b64797ad00b7bd3c);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");
const $956d4da8aa4ae614$export$b64797ad00b7bd3c = ({ dashboardId: dashboardId })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const { data: data } = (0, $gh1hi.useDashboardResource)();
    const prefetches = (0, $5uXOq.useMemo)(()=>data ? (0, $83oax.getPrefetches)(data) : [], [
        data
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!isInitialRender && window && window[0, $JIPqS.PRELOADED_GADGET_DATA_KEY]) // cleanup preloaded data on window, which is only used on initial load
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        delete window[0, $JIPqS.PRELOADED_GADGET_DATA_KEY];
    }, [
        isInitialRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, prefetches.map((prefetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("link", {
            key: `${dashboardId}-${prefetch.url}`,
            rel: isInitialRender ? prefetch.priority : 'prefetch',
            as: "fetch",
            href: prefetch.url
        })));
};

});

parcelRegister("he6UQ", function(module, exports) {

$parcel$export(module.exports, "useDashboardRef", () => $7859c7156387c1ba$export$a52b4118d451e93c);

var $5uXOq = parcelRequire("5uXOq");
const $7859c7156387c1ba$export$a52b4118d451e93c = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const originalGetDashboard = window.AG?.DashboardManager?.getDashboard;
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.AG = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG,
                DashboardManager: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ...window.AG?.DashboardManager,
                    getDashboard: originalGetDashboard
                }
            };
        };
    }, []);
    return (0, $5uXOq.useCallback)((node)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.AG = {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            ...window.AG,
            DashboardManager: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.AG?.DashboardManager,
                getDashboard: ()=>node
            }
        };
    }, []);
};

});


parcelRegister("1CEw6", function(module, exports) {

$parcel$export(module.exports, "EngagementBanners", () => $ea6f1e008ef29904$export$eaa8218767cf0103);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $106XW = parcelRequire("106XW");

var $7YQcX = parcelRequire("7YQcX");

var $5Q210 = parcelRequire("5Q210");

var $fqDbq = parcelRequire("fqDbq");

var $ho8bY = parcelRequire("ho8bY");

var $fEqnJ = parcelRequire("fEqnJ");

var $4R6GH = parcelRequire("4R6GH");
const $ea6f1e008ef29904$export$a38d2dae548e4826 = {
    endeavour_gadget_deprecation_banner_v1: {
        bannerDismissedId: (0, $JIPqS.DEPRECATION_BANNER_V1_DISMISS),
        component: (0, $7YQcX.DeprecationBannerV1),
        gadgetTypeMap: (0, $JIPqS.DEPRECATED_GADGETS_MAP)
    },
    endeavour_activity_streams_survey_banner: {
        bannerDismissedId: (0, $JIPqS.ACTIVITY_STREAMS_SURVEY_BANNER_DISMISS),
        component: (0, $106XW.ActivityStreamsSurveyBanner),
        gadgetTypeMap: (0, $JIPqS.ACTIVITY_STREAMS_WEB_RESOURCE)
    },
    endeavour_platform_dashboard_banner: {
        bannerDismissedId: (0, $JIPqS.PLATFORM_DASHBOARD_BANNER_DISMISS),
        component: (0, $5Q210.PlatformDashboardBanner),
        gadgetTypeMap: (0, $JIPqS.ACTIVITY_STREAMS_WEB_RESOURCE)
    }
};
const $ea6f1e008ef29904$export$eaa8218767cf0103 = ({ gadgets: gadgets, dashboardId: dashboardId })=>{
    const activityStreamsBannerState = (0, $fqDbq.useDashboardBannerState)($ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_activity_streams_survey_banner.bannerDismissedId, dashboardId, false);
    const platformDashboardBannerState = (0, $fqDbq.useDashboardBannerState)($ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_platform_dashboard_banner.bannerDismissedId, dashboardId, false);
    const gadgetDeprecationBannerV1State = (0, $fqDbq.useDashboardBannerState)($ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_gadget_deprecation_banner_v1.bannerDismissedId, dashboardId, true);
    const userIsEAPEligible = (0, $fEqnJ.usePlatformDashboardsAudience)();
    const bannerConfigs = [
        {
            id: 'endeavour_activity_streams_survey_banner',
            condition: (0, $ho8bY.useDashboardHasGadgetType)(gadgets, $ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_activity_streams_survey_banner.gadgetTypeMap) && (0, $4R6GH.fg)('endeavour_activity_streams_survey_banner'),
            isDismissed: activityStreamsBannerState.isDashboardBannerDismissed,
            onDismiss: activityStreamsBannerState.onDashboardBannerDismiss
        },
        {
            id: 'endeavour_platform_dashboard_banner',
            condition: !(0, $ho8bY.useDashboardHasGadgetType)(gadgets, $ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_platform_dashboard_banner.gadgetTypeMap) && (0, $4R6GH.fg)('endeavour_platform_dashboard_banner') && userIsEAPEligible,
            isDismissed: platformDashboardBannerState.isDashboardBannerDismissed,
            onDismiss: platformDashboardBannerState.onDashboardBannerDismiss
        },
        {
            id: 'endeavour_gadget_deprecation_banner_v1',
            condition: (0, $ho8bY.useDashboardHasGadgetType)(gadgets, $ea6f1e008ef29904$export$a38d2dae548e4826.endeavour_gadget_deprecation_banner_v1.gadgetTypeMap) && (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1'),
            isDismissed: gadgetDeprecationBannerV1State.isDashboardBannerDismissed,
            onDismiss: gadgetDeprecationBannerV1State.onDashboardBannerDismiss
        }
    ];
    const activeBannerConfig = bannerConfigs.find((config)=>config.condition && !config.isDismissed);
    if (!activeBannerConfig) return null; // No banner to show
    const BannerComponent = $ea6f1e008ef29904$export$a38d2dae548e4826[activeBannerConfig.id].component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BannerComponent, {
        onDismiss: activeBannerConfig.onDismiss
    });
};

});
parcelRegister("106XW", function(module, exports) {

$parcel$export(module.exports, "ActivityStreamsSurveyBanner", () => $93022c201b2b5b5a$export$7674bfd5708d8cc2);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $koVbs = parcelRequire("koVbs");

var $JIPqS = parcelRequire("JIPqS");

var $cOO9w = parcelRequire("cOO9w");
const $93022c201b2b5b5a$export$7674bfd5708d8cc2 = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "discovery",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: (0, $JIPqS.ACTIVITY_STREAMS_SURVEY_BANNER_DISMISS),
                onClick: onDismiss
            }, formatMessage((0, $cOO9w.default).activityStreamsSurveyBannerDismiss))
        ],
        title: formatMessage((0, $cOO9w.default).activityStreamsSurveyBannerTitle)
    }, formatMessage((0, $cOO9w.default).activityStreamsSurveyBannerMessage, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://surveys.atlassian.com/jfe/form/SV_bdRPSVFIEECKZYa"
            }, chunks)
    }));
};

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c81oud _syaz1fxt"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            role: "list",
                            children: actionsArray.map((action, id)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: "listitem",
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)($ed572e62fc5b1cd0$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        role: role,
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("414Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $452354e10b30c8d8$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $452354e10b30c8d8$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $452354e10b30c8d8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $452354e10b30c8d8$var$styles.hug, grow === 'fill' && $452354e10b30c8d8$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$452354e10b30c8d8$var$Stack.displayName = 'Stack';
var $452354e10b30c8d8$export$2e2bcd8739ae039 = $452354e10b30c8d8$var$Stack;

});

parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c81oud _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("cOO9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $263be0af7172d14a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $263be0af7172d14a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activityStreamsSurveyBannerTitle: {
        "id": "dashboard-internal-common.common.gadget.activity-streams-survey-banner.activity-streams-survey-banner-title.non-final",
        "defaultMessage": "Help us improve the Activity Stream gadget!"
    },
    activityStreamsSurveyBannerMessage: {
        "id": "dashboard-internal-common.common.gadget.activity-streams-survey-banner.activity-streams-survey-banner-message.non-final",
        "defaultMessage": "As part of our efforts to improve the dashboard experience, we're focusing on the Activity Stream gadget. If you'd like to leave feedback, please fill out <Link>this survey</Link>."
    },
    activityStreamsSurveyBannerDismiss: {
        "id": "dashboard-internal-common.common.gadget.activity-streams-survey-banner.activity-streams-survey-banner-dismiss.non-final",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("7YQcX", function(module, exports) {

$parcel$export(module.exports, "DeprecationBannerV1", () => $fb1cba861a89581f$export$b10eedc6ae25381c);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $koVbs = parcelRequire("koVbs");

var $JIPqS = parcelRequire("JIPqS");

var $2O7o7 = parcelRequire("2O7o7");
const $fb1cba861a89581f$export$b10eedc6ae25381c = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: (0, $JIPqS.DEPRECATION_BANNER_V1_DISMISS),
                onClick: onDismiss
            }, formatMessage((0, $2O7o7.default).gadgetDeprecationMessageDismissV1))
        ],
        title: formatMessage((0, $2O7o7.default).gadgetDeprecationTitleV1)
    }, formatMessage((0, $2O7o7.default).gadgetDeprecationMessageV1, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
    }));
};

});
parcelRegister("2O7o7", function(module, exports) {

$parcel$export(module.exports, "default", () => $681e6c098aed09e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $681e6c098aed09e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    gadgetDeprecationTitleV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-title.non-final",
        "defaultMessage": "Extended timeline: We're no longer supporting five of your gadgets starting May 2025"
    },
    gadgetDeprecationMessageV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message.non-final",
        "defaultMessage": "Starting May 2025, we're removing the functionality of the Jira Road Map, Bubble Chart, Heat Map, Projects, and Labels gadgets. If you don't delete them before then, they'll no longer work, and you won't be able to reference them for the available alternatives. <Link>More about the gadgets and the extended timeline</Link>"
    },
    gadgetDeprecationMessageDismissV1: {
        "id": "dashboard-internal-common.common.gadget.deprecation-banner-v1.gadget-deprecation-message-dismiss.non-final",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("5Q210", function(module, exports) {

$parcel$export(module.exports, "PlatformDashboardBanner", () => $9f215613d9d161ec$export$145b437b2fde5333);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $koVbs = parcelRequire("koVbs");

var $JIPqS = parcelRequire("JIPqS");

var $jnJLk = parcelRequire("jnJLk");
const $9f215613d9d161ec$export$145b437b2fde5333 = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "discovery",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: (0, $JIPqS.PLATFORM_DASHBOARD_BANNER_DISMISS),
                onClick: onDismiss
            }, formatMessage((0, $jnJLk.default).platformDashboardBannerDismiss))
        ],
        title: formatMessage((0, $jnJLk.default).platformDashboardBannerTitle)
    }, formatMessage((0, $jnJLk.default).platformDashboardBannerMessage, {
        EarlyTesterLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://surveys.atlassian.com/jfe/form/SV_0kAQgoYpYhnVIMu"
            }, chunks),
        LearnMoreLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://community.atlassian.com/t5/Jira-Cloud-Admins-articles/Join-our-Atlassian-Home-dashboards-alpha/ba-p/2715355"
            }, chunks)
    }));
};

});
parcelRegister("jnJLk", function(module, exports) {

$parcel$export(module.exports, "default", () => $52efef0c3dd7a14a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52efef0c3dd7a14a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    platformDashboardBannerTitle: {
        "id": "dashboard-internal-common.common.gadget.platform-dashboard-banner.platform-dashboard-banner-title.non-final",
        "defaultMessage": "Get an early look at our all new dashboards!"
    },
    platformDashboardBannerMessage: {
        "id": "dashboard-internal-common.common.gadget.platform-dashboard-banner.platform-dashboard-banner-message.non-final",
        "defaultMessage": "<EarlyTesterLink>Become an early tester</EarlyTesterLink> for our new Atlassian Home dashboards. Click <LearnMoreLink>here to learn more</LearnMoreLink> about these exciting new dashboards."
    },
    platformDashboardBannerDismiss: {
        "id": "dashboard-internal-common.common.gadget.platform-dashboard-banner.platform-dashboard-banner-dismiss.non-final",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("fqDbq", function(module, exports) {

$parcel$export(module.exports, "useDashboardBannerState", () => $4f48e547e1849b1c$export$fcf5ad86b72b3dfe);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4f48e547e1849b1c$export$fcf5ad86b72b3dfe = (dashboardBannerStorageKey, dashboardId, bannerPerDashboard)=>{
    const [isDashboardBannerDismissed, setIsDashboardBannerDismissed] = (0, $5uXOq.useState)(false);
    // Would change to 'jira-dashboard-banner-state' but then local storage
    // for previous deprecation dismissal would be ignored. Should be temporary anyways
    const store = (0, $bSSG7.createLocalStorageProvider)('jira-dashboard-deprecation-banner-state');
    (0, $5uXOq.useEffect)(()=>{
        const localDashbaordBannersState = store.get(dashboardBannerStorageKey);
        if (localDashbaordBannersState) {
            if (bannerPerDashboard) {
                const bannerIsDismissed = localDashbaordBannersState.includes(dashboardId);
                setIsDashboardBannerDismissed(bannerIsDismissed);
            } else setIsDashboardBannerDismissed(true);
        }
    }, [
        dashboardId,
        dashboardBannerStorageKey,
        store,
        bannerPerDashboard
    ]);
    const onDashboardBannerDismiss = ()=>{
        setIsDashboardBannerDismissed(true);
        const localDashbaordBannersState = store.get(dashboardBannerStorageKey);
        if (bannerPerDashboard) {
            if (localDashbaordBannersState) {
                localDashbaordBannersState.push(dashboardId);
                store.set(dashboardBannerStorageKey, localDashbaordBannersState);
            } else store.set(dashboardBannerStorageKey, [
                dashboardId
            ]);
        } else if (!localDashbaordBannersState) store.set(dashboardBannerStorageKey, true);
    };
    return {
        isDashboardBannerDismissed: isDashboardBannerDismissed,
        onDashboardBannerDismiss: onDashboardBannerDismiss
    };
};

});

parcelRegister("ho8bY", function(module, exports) {

$parcel$export(module.exports, "useDashboardHasGadgetType", () => $a5d04ee035eacf17$export$e22f1de23679f695);

var $5uXOq = parcelRequire("5uXOq");

var $b3IiT = parcelRequire("b3IiT");
const $a5d04ee035eacf17$export$e22f1de23679f695 = (gadgets, webResourceMap)=>{
    const [dashboardHasGadgetType, setDashboardHasGadgetType] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setDashboardHasGadgetType($a5d04ee035eacf17$var$checkDashboardHasGadgetType(webResourceMap, gadgets));
    }, [
        gadgets,
        webResourceMap
    ]);
    return dashboardHasGadgetType;
};
const $a5d04ee035eacf17$var$checkDashboardHasGadgetType = (webResourceMap, gadgets)=>{
    return gadgets.some((gadget)=>(0, $b3IiT.checkGadgetType)(webResourceMap, gadget.amdModule));
};

});
parcelRegister("b3IiT", function(module, exports) {

$parcel$export(module.exports, "checkGadgetType", () => $31e3249d62ee71f8$export$6834c500b0f301a7);
const $31e3249d62ee71f8$export$6834c500b0f301a7 = (webResourceMap, gadgetResource)=>{
    return gadgetResource !== undefined && (gadgetResource in webResourceMap || Object.values(webResourceMap).includes(gadgetResource));
};

});


parcelRegister("fEqnJ", function(module, exports) {

$parcel$export(module.exports, "usePlatformDashboardsAudience", () => $03833edb5f3beedc$export$3a6204d7f965f03b);

var $bNm1d = parcelRequire("bNm1d");

var $eXrJi = parcelRequire("eXrJi");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $03833edb5f3beedc$export$3a6204d7f965f03b = ()=>{
    const { isOrgAdmin: isOrgAdmin } = (0, $eXrJi.useIsOrgAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const emailDomain = (0, $bNm1d.useUserEmailDomain)(true);
    const isInternalAtlassianUser = emailDomain.data === 'atlassian.com' || emailDomain.data === 'usersinbuckets.com';
    if (!appEditions) return false;
    return (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) || appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION)) && isOrgAdmin && !isInternalAtlassianUser;
};

});
parcelRegister("eXrJi", function(module, exports) {

$parcel$export(module.exports, "useIsOrgAdmin", () => $1b04ea73291e11e0$export$8ed42372757d8b2a);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");
const $1b04ea73291e11e0$var$getUserOrgPermissions = async ({ orgId: orgId, userId: userId })=>(0, $eusud.performPostRequest)('/gateway/api/permissions/permitted', {
        body: JSON.stringify({
            resourceId: `ari:cloud:platform::org/${orgId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage-users'
        })
    }).then((resp)=>!!resp?.permitted);
const $1b04ea73291e11e0$export$8ed42372757d8b2a = ()=>{
    const userId = (0, $90yGq.useAccountId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const checkUserIsOrgAdmin = (0, $5uXOq.useCallback)(async ()=>{
        if (!userId || !orgId) return false;
        return $1b04ea73291e11e0$var$getUserOrgPermissions({
            orgId: orgId,
            userId: userId
        });
    }, [
        orgId,
        userId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchIsOrgAdmin } = (0, $ld2hZ.useService)(checkUserIsOrgAdmin, {
        data: false
    });
    (0, $5uXOq.useEffect)(()=>{
        fetchIsOrgAdmin();
    }, [
        fetchIsOrgAdmin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'checkUserIsOrgAdmin',
                packageName: 'jiraBusinessGoalPicker',
                teamName: 'jira-yurree'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: error
        });
    }, [
        error
    ]);
    return {
        isOrgAdmin: !!data,
        loading: loading,
        hasErrorOccurred: !!error,
        retry: fetchIsOrgAdmin
    };
};

});



parcelRegister("5HxxK", function(module, exports) {

$parcel$export(module.exports, "ColumnPlaceholderContextConsumer", () => $42fb06f36f97089d$export$efa1c423df3eb8d9);
$parcel$export(module.exports, "ColumnLayout", () => $42fb06f36f97089d$export$c7e5bac7049eee2a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $bbkUF = parcelRequire("bbkUF");

var $6hp8I = parcelRequire("6hp8I");

var $1oaeD = parcelRequire("1oaeD");

var $jnkfq = parcelRequire("jnkfq");

var $6fab6 = parcelRequire("6fab6");

var $bfdYn = parcelRequire("bfdYn");

var $h6EHU = parcelRequire("h6EHU");
const { createRenderFunction: $42fb06f36f97089d$var$createPlaceholderRender, Provider: $42fb06f36f97089d$export$e3a62d26c35df0c2, Consumer: $42fb06f36f97089d$export$efa1c423df3eb8d9 } = (0, $jnkfq.createRendererContext)();
const { createRenderFunction: $42fb06f36f97089d$var$createGadgetRender, Provider: $42fb06f36f97089d$export$de8f6456a7a635a7, Consumer: $42fb06f36f97089d$export$599894a5533c31ef } = (0, $jnkfq.createRendererContext)();
const $42fb06f36f97089d$export$c7e5bac7049eee2a = ({ data: data, dnd: dnd, columnPlaceholder: columnPlaceholder, layoutPlaceholder: // placeholder for a column when it is empty (no gadgets in the column)
layoutPlaceholder, onLayoutReposition: // placeholder for the whole layout when dashboard is empty (no gadgets in all columns)
onLayoutReposition, children: children })=>{
    const { layout: layout, writable: writable, gadgets: gadgets } = data;
    const { DragDropContext: DragDropContext = (0, $bfdYn.DegenerateDragDropContext), Draggable: Draggable = (0, $bfdYn.DegenerateDraggable), Droppable: Droppable = (0, $bfdYn.DegenerateDroppable) } = dnd ?? {};
    const { getPropsByGadgetId: getPropsByGadgetId, getPropsByColumnIndex: getPropsByColumnIndex } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const [isAnyDragging, setIsAnyDragging] = (0, $5uXOq.useState)(false);
    const columns = (0, $5uXOq.useMemo)(()=>(0, $6fab6.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    const width = (0, $bbkUF.useDebouncedWindowWidth)();
    const onDragEnd = (0, $5uXOq.useCallback)((result)=>{
        if (!writable || !onLayoutReposition) return;
        const { destination: destination, source: source } = result;
        if (destination && destination.droppableId != null) {
            const moved = columns[+source.droppableId].splice(source.index, 1)[0];
            columns[+destination.droppableId].splice(destination.index, 0, moved);
            moved.column = +destination.droppableId;
        }
        onLayoutReposition(layout, columns);
        setIsAnyDragging(false);
    }, [
        columns,
        layout,
        writable,
        onLayoutReposition
    ]);
    const onDragStart = (0, $5uXOq.useCallback)(()=>{
        setIsAnyDragging(true);
    }, []);
    const renderColumnPlaceholder = $42fb06f36f97089d$var$createPlaceholderRender(columnPlaceholder);
    const renderGadget = $42fb06f36f97089d$var$createGadgetRender(children);
    if (!gadgets.length && layoutPlaceholder != null) return layoutPlaceholder;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DragDropContext, {
        onDragEnd: onDragEnd,
        onDragStart: onDragStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42fb06f36f97089d$var$ContainerWrapper, {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.layout.container-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6hp8I.DimensionsProvider), {
        value: `${layout}-${width}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: "fluid"
    }, columns.map((items, columnIndex)=>{
        const columnWidth = (0, $h6EHU.getColumnWidth)(columnIndex, layout, getPropsByColumnIndex(columnIndex).display);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), {
            key: columnIndex,
            medium: columnWidth,
            testId: "dashboard-internal-common.ui.dashboard-content.layout.column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Droppable, {
            droppableId: columnIndex.toString()
        }, ({ innerRef: columnRef, droppableProps: droppableProps, placeholder: dndPlaceholder }, { isDraggingOver: isDraggingOver })=>{
            const isNonEmptyCol = items.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42fb06f36f97089d$var$ContentWrapper, {
                ...droppableProps,
                ref: columnRef,
                isDimmed: isNonEmptyCol && isDraggingOver,
                isHidden: columnWidth === 0
            }, isNonEmptyCol ? items.map((gadgetData, rowIndex)=>{
                const { isDraggable: isMaybeDraggable, ...gadgetProps } = getPropsByGadgetId(gadgetData.id);
                const isDraggable = dnd != null && isMaybeDraggable;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Draggable, {
                    key: gadgetData.id,
                    draggableId: gadgetData.id,
                    index: rowIndex,
                    isDragDisabled: !isDraggable
                }, ({ innerRef: rowRef, dragHandleProps: dragHandleProps, draggableProps: draggableProps }, { isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                        ...draggableProps,
                        ref: rowRef
                    }, renderGadget({
                        data: gadgetData,
                        dragHandleProps: dragHandleProps,
                        isDraggable: isDraggable,
                        isDragging: isDragging,
                        isAnyDragging: isAnyDragging,
                        ...gadgetProps
                    })));
            }) : renderColumnPlaceholder({
                columnIndex: columnIndex,
                isDraggingOver: isDraggingOver
            }), dndPlaceholder);
        }));
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $42fb06f36f97089d$var$ContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _otyridpf _18u0mgjw _2hwxmgjw",
            __cmplp.className
        ])
    });
});
const $42fb06f36f97089d$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDimmed: isDimmed, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _v564mfn2 _1bsb1osq",
            __cmplp.isDimmed ? "_11q7qbzx" : "_11q7vuon",
            __cmplp.isHidden && "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephoW.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itnZ9.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});


parcelRegister("bbkUF", function(module, exports) {

$parcel$export(module.exports, "useDebouncedWindowWidth", () => $c482c1c1fc6dfb26$export$4b69c5ad33ff59ee);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
const $c482c1c1fc6dfb26$export$4b69c5ad33ff59ee = (ms = 100)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const [width, setWidth] = (0, $5uXOq.useState)(window.innerWidth);
    const debounced = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((w)=>setWidth(w), ms));
    (0, $5uXOq.useEffect)(()=>{
        const handleResize = ()=>{
            const { innerWidth: innerWidth } = window;
            if (innerWidth !== width) debounced.current(innerWidth);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', handleResize);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', handleResize);
        };
    }, [
        width
    ]);
    return width;
};

});

parcelRegister("6hp8I", function(module, exports) {

$parcel$export(module.exports, "DimensionsProvider", () => $096975c907c9ee30$export$a31e22a91fd34dd9);
$parcel$export(module.exports, "useDimensions", () => $096975c907c9ee30$export$d04af0e501fb729f);

var $5uXOq = parcelRequire("5uXOq");
const $096975c907c9ee30$var$DimensionsContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $096975c907c9ee30$export$a31e22a91fd34dd9 = $096975c907c9ee30$var$DimensionsContext.Provider;
const $096975c907c9ee30$export$d04af0e501fb729f = ()=>(0, $5uXOq.useContext)($096975c907c9ee30$var$DimensionsContext);

});

parcelRegister("1oaeD", function(module, exports) {

$parcel$export(module.exports, "useMaximizedGadget", () => $3f7e0a0376bf6236$export$23a0742f39986cba);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $4oDnX = parcelRequire("4oDnX");

var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $3f7e0a0376bf6236$export$23a0742f39986cba = (gadgetsData)=>{
    const [{ location: { hash: hash } }] = (0, $doZTA.useRouter)();
    const [maximizedQueryParam, setMaximizedQueryParam] = (0, $ieDtd.useQueryParam)((0, $JIPqS.MAXIMIZED_PARAM));
    const [, { setAppReady: setAppReady }] = (0, $4oDnX.useSpaStateActions)();
    // The regex matches any character (except a newline character)
    // zero or more times .* followed by a '/'. The (?<id>\d+) part is a
    // named capturing group which matches one or more digits and assigns
    // the group to an id value accessible through .groups.id
    // We are using a backup hash decodedId for legacy URLs in case users have
    // bookmarked a legacy URL. Legacy URLs used '#' instead of '?maximized='
    // (e.g. https://.../jira/dashboards/{dashboardId}#{some-text}/{gadgetId})
    const decodedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const idFromHashOrQuery = maximizedQueryParam != null ? maximizedQueryParam : decodedId;
    const gadget = idFromHashOrQuery != null && gadgetsData?.find(({ id: id })=>id === idFromHashOrQuery) || null;
    const maximizedId = gadget?.isMaximizable ? idFromHashOrQuery : null;
    const getMaximisedGadgetId = (0, $5uXOq.useMemo)(()=>maximizedId, [
        maximizedId
    ]);
    const getPropsByColumnIndex = (0, $5uXOq.useCallback)((column)=>{
        const maximizedGadget = maximizedId !== null ? gadgetsData?.find(({ id: id })=>id === maximizedId) : null;
        const { column: maximizedColumn = null } = maximizedGadget ?? {};
        const display = maximizedColumn === null && (0, $JIPqS.GADGET_DISPLAY).NORMAL || maximizedColumn === column && (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED || (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
        return {
            display: display
        };
    }, [
        maximizedId,
        gadgetsData
    ]);
    // create curried callbacks once in the memoized scope
    const maximizedLookup = (0, $5uXOq.useMemo)(()=>Object.fromEntries(gadgetsData?.filter(({ isMaximizable: isMaximizable })=>isMaximizable).map((data)=>[
                data.id,
                (doMaximizeNotRestore)=>{
                    if (maximizedId === (doMaximizeNotRestore ? data.id : null)) return;
                    setMaximizedQueryParam(doMaximizeNotRestore ? data.id : undefined);
                    setTimeout(setAppReady);
                }
            ]) ?? []), [
        gadgetsData,
        maximizedId,
        setAppReady,
        setMaximizedQueryParam
    ]);
    const getPropsByGadgetId = (0, $5uXOq.useCallback)((id)=>{
        // Get display by gadget ID
        const display = maximizedId === null && (0, $JIPqS.GADGET_DISPLAY).NORMAL || maximizedId === id && (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED || (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
        // Get isDraggable by gadget ID
        const isDraggable = id !== maximizedId;
        // Get onMaximizeOrRestore by gadget ID
        const onMaximizeOrRestore = maximizedLookup[id] ?? (()=>undefined);
        return {
            display: display,
            isDraggable: isDraggable,
            onMaximizeOrRestore: onMaximizeOrRestore
        };
    }, [
        maximizedId,
        maximizedLookup
    ]);
    return {
        getMaximisedGadgetId: getMaximisedGadgetId,
        getPropsByGadgetId: getPropsByGadgetId,
        getPropsByColumnIndex: getPropsByColumnIndex
    };
};

});

parcelRegister("6fab6", function(module, exports) {

$parcel$export(module.exports, "toColumns", () => $78db23f50316c14c$export$755ca66aa40344da);
const $78db23f50316c14c$export$755ca66aa40344da = (gadgets, layout)=>{
    const getGadgetsForCol = (col)=>gadgets.filter((gadget)=>gadget.column === col);
    switch(layout){
        case 'A':
            return [
                getGadgetsForCol(0)
            ];
        case 'AA':
        case 'AB':
        case 'BA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1)
            ];
        case 'AAA':
            return [
                getGadgetsForCol(0),
                getGadgetsForCol(1),
                getGadgetsForCol(2)
            ];
        default:
            throw new Error('Unexpected layout was provided');
    }
};

});

parcelRegister("bfdYn", function(module, exports) {

$parcel$export(module.exports, "DegenerateDragDropContext", () => $b11313e6244f86bc$export$cc74aca994b0ed41);
$parcel$export(module.exports, "DegenerateDraggable", () => $b11313e6244f86bc$export$c114e58211833c77);
$parcel$export(module.exports, "DegenerateDroppable", () => $b11313e6244f86bc$export$50925b5bb72c3049);
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
const $b11313e6244f86bc$var$providedDraggable = {
    innerRef: ()=>undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    draggableProps: {},
    dragHandleProps: undefined
};
const $b11313e6244f86bc$var$snapshotDraggable = {
    isDragging: false,
    isDropAnimating: false,
    dropAnimation: undefined,
    draggingOver: undefined,
    combineWith: undefined,
    combineTargetFor: undefined,
    mode: undefined,
    isClone: false
};
const $b11313e6244f86bc$var$providedDroppable = {
    innerRef: ()=>undefined,
    placeholder: undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    droppableProps: {}
};
const $b11313e6244f86bc$var$snapshotDroppable = {
    isDraggingOver: false,
    draggingOverWith: undefined,
    draggingFromThisWith: undefined,
    isUsingPlaceholder: false
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $b11313e6244f86bc$var$rubricDraggable = {};
const $b11313e6244f86bc$export$cc74aca994b0ed41 = ({ children: children })=>children;
const $b11313e6244f86bc$export$c114e58211833c77 = ({ children: children })=>children($b11313e6244f86bc$var$providedDraggable, $b11313e6244f86bc$var$snapshotDraggable, $b11313e6244f86bc$var$rubricDraggable);
const $b11313e6244f86bc$export$50925b5bb72c3049 = ({ children: children })=>children($b11313e6244f86bc$var$providedDroppable, $b11313e6244f86bc$var$snapshotDroppable);

});

parcelRegister("h6EHU", function(module, exports) {

$parcel$export(module.exports, "getColumnWidth", () => $3e20f2a7b6f0ea06$export$dfa11a34ceba822);

var $JIPqS = parcelRequire("JIPqS");
const $3e20f2a7b6f0ea06$export$dfa11a34ceba822 = (index, layout, display)=>{
    if (display === (0, $JIPqS.GADGET_DISPLAY).HIDDEN) return 0;
    if (layout === 'A' || display === (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED) return 12;
    if (layout === 'AA') return 6;
    if (layout === 'AAA') return 4;
    if (layout === 'AB') return index === 0 ? 8 : 4;
    return index === 0 ? 4 : 8;
};

});


parcelRegister("4kIa4", function(module, exports) {

$parcel$export(module.exports, "DashboardContentContainer", () => $e519b350b77b4296$export$b49692a976fb3d05);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $g0Gtc = parcelRequire("g0Gtc");

var $dJl1T = parcelRequire("dJl1T");

var $beRD7 = parcelRequire("beRD7");


var $gh1hi = parcelRequire("gh1hi");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $1yBXu = parcelRequire("1yBXu");

var $i7Ldp = parcelRequire("i7Ldp");

var $bOnpg = parcelRequire("bOnpg");

var $8h45R = parcelRequire("8h45R");

var $6IxJi = parcelRequire("6IxJi");

var $h5Jym = parcelRequire("h5Jym");

var $5jJ3W = parcelRequire("5jJ3W");

var $8CCTB = parcelRequire("8CCTB");

var $1Bx5m = parcelRequire("1Bx5m");

var $7v0Ei = parcelRequire("7v0Ei");

var $fxC6K = parcelRequire("fxC6K");

var $kUwqK = parcelRequire("kUwqK");

var $hwuTz = parcelRequire("hwuTz");
const $e519b350b77b4296$var$HALF_HOUR = 1800000;
const $e519b350b77b4296$export$d3a4cb300c572c66 = ({ data: { id: id, gadgets: gadgets, layout: layout }, saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    (0, $h5Jym.useSpaStatePageReady)();
    (0, $kUwqK.usePageStatusLogger)($e519b350b77b4296$var$HALF_HOUR);
    (0, $6IxJi.useGadgetMetricsBridge)(id, gadgets, layout);
    (0, $i7Ldp.useConnectApi)({
        saveCustomGadgetTitle: saveCustomGadgetTitle
    });
    return null;
};
const $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT = 2;
const $e519b350b77b4296$export$b49692a976fb3d05 = ({ children: children, customHeight: customHeight, analyticsExperience: analyticsExperience, saveCustomGadgetTitle: saveCustomGadgetTitle = ()=>Promise.resolve(), resourceData: resourceData, permissionErrorFallback: permissionErrorFallback })=>{
    const { data: configData, error: configError, loading: configLoading } = resourceData;
    const { loading: amdLoading, data: amdData, error: amdError, refresh: amdRefresh } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const [amdResourceRetries, setAmdResourceRetries] = (0, $5uXOq.useState)(0);
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const eventSent = (0, $5uXOq.useRef)(null);
    const isAmdResourceUnhealthy = configData != null && amdData == null && amdError != null || amdData?.amdModules != null && Object.values(amdData?.amdModules).some((v)=>v == null);
    const isAmdResourceRetriesExceeded = !amdLoading && amdResourceRetries >= $e519b350b77b4296$var$AMD_RESOURCE_RETRY_LIMIT;
    (0, $5uXOq.useEffect)(()=>{
        if (false || configLoading || configData == null || eventSent.current === Number(configData.id)) return;
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            actionSubjectId: 'dashboard',
            actionSubject: 'dashboardScreen',
            action: 'viewed'
        });
        (0, $5jJ3W.addDashboardToRecents)(configData.id);
        eventSent.current = Number(configData.id);
    }, [
        configData,
        fireAnalytics,
        configLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        if (amdLoading) {
            // NOTE - reset retries when resource changes
            !isAmdResourceUnhealthy && setAmdResourceRetries(0);
            return;
        }
        if (!isAmdResourceUnhealthy) (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.content-container', `AMD resource loaded, after retries [${amdResourceRetries}]`);
        else if (isAmdResourceRetriesExceeded) {
            const [failedCount, totalCount] = Object.values(amdData?.amdModules ?? []).reduce(([f], v, i, arr)=>[
                    f + (v == null ? 1 : 0),
                    arr.length
                ], [
                0,
                0
            ]);
            (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.content-container', amdError ? `AMD resource error [${String(amdError.message)}]` : `AMD resource degraded, failed [${failedCount}] of [${totalCount}] gadgets`);
        } else {
            (0, $dJl1T.default).safeWarnWithoutCustomerData('spa-apps.dashboard.content-container', `Retrying AMD resource, retry [${amdResourceRetries + 1}]`);
            setAmdResourceRetries((n)=>n + 1);
            amdRefresh();
        }
    }, [
        amdResourceRetries,
        amdLoading,
        amdError,
        amdData,
        isAmdResourceUnhealthy,
        isAmdResourceRetriesExceeded,
        amdRefresh
    ]);
    if (false || configLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yBXu.GenericLoadingView), {
        customHeight: customHeight
    });
    if (configError != null || configData == null) {
        const errorCode = (0, $4R6GH.fg)('endeavour_view_dashboard_client_side_errors') ? (0, $8CCTB.getErrorCode)(configError) : Number(configError?.message?.substring(configError.message.length - 3));
        if (errorCode && (0, $fxC6K.DASHBOARD_PERMISSION_ERROR_CODE_LIST_OLD).includes(errorCode) || (errorCode && (0, $fxC6K.DASHBOARD_PERMISSION_ERROR_CODE_LIST_NEW).includes(errorCode) || (0, $fZneA.isClientFetchError)(configError)) && (0, $4R6GH.fg)('endeavour_view_dashboard_client_side_errors')) return permissionErrorFallback;
        (0, $dJl1T.default).unsafeErrorWithCustomerData('spa-apps.dashboard.content-container', `Server-side, unhandled-client side or unknown error: ${configError}`);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: configError ? configError.message : 'unknown error'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), null));
    }
    if (isAmdResourceRetriesExceeded && amdError != null && amdData == null) {
        (0, $dJl1T.default).unsafeErrorWithCustomerData('spa-apps.dashboard.content-container', `Amd resource retries exceeded: ${amdError}`);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: analyticsExperience,
            failureEventAttributes: {
                error: `AMD resource error [${String(amdError.message)}]`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), null));
    }
    return(// ThemeProvider will no longer be used in later versions of Atlaskit Grid
    // Remove when @atlaskit/page is updated
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: analyticsExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7v0Ei.AmdGadgetMonolithOverrideStyles), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Bx5m.AboveTheFoldContainer), {
        dashboardId: configData.id,
        layout: configData.layout,
        gadgets: configData.gadgets
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8h45R.GadgetAdditionalStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e519b350b77b4296$export$d3a4cb300c572c66, {
        data: configData,
        saveCustomGadgetTitle: saveCustomGadgetTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwuTz.RouteResourceValidator), null), children)))));
};

});
parcelRegister("1yBXu", function(module, exports) {

$parcel$export(module.exports, "GenericLoadingView", () => $1052d375f7549967$export$901c7e24ef786b0f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fNobW = parcelRequire("fNobW");

var $44v1T = parcelRequire("44v1T");
const $1052d375f7549967$export$901c7e24ef786b0f = ({ customHeight: customHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "generic-loading-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Title, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$Button, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1052d375f7549967$var$ContainerWrapper, {
        customHeight: customHeight
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1052d375f7549967$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1y6m _1e0c1txw _1n261g80 _p12f1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$ContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { customHeight: customHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6y8cer": (0, $lD23V.default)(__cmplp.customHeight),
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkn82g _1bsb1osq _1pbyb4wl",
            __cmplp.customHeight != null ? "_4t3i1hh3" : "_4t3inb68",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _1okqidpf _142fidpf _kdjlidpf _1octidpf",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1wug _bfhkn82g _4t3izwfg _1bsbclpc",
            __cmplp.className
        ])
    });
});
const $1052d375f7549967$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _bfhkn82g _4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i7Ldp", function(module, exports) {

$parcel$export(module.exports, "useConnectApi", () => $5ce347994b87c55a$export$521765443e759ceb);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $JIPqS = parcelRequire("JIPqS");

var $gh1hi = parcelRequire("gh1hi");

var $19nfo = parcelRequire("19nfo");

var $8h45R = parcelRequire("8h45R");
const $5ce347994b87c55a$export$521765443e759ceb = ({ saveCustomGadgetTitle: saveCustomGadgetTitle })=>{
    const { data: data, update: update } = (0, $gh1hi.useDashboardResource)();
    const debouncedHeightRef = (0, $5uXOq.useRef)({});
    const [, { addNonRenamable: addNonRenamable, addForcedHeight: addForcedHeight }] = (0, $8h45R.useGadgetAdditionalStateActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!data) return;
        const setGadgetTitle = async (id, title)=>{
            if (data.gadgets.some((g)=>g.id === id)) {
                saveCustomGadgetTitle(id, title);
                addNonRenamable(id);
            }
        };
        const setGadgetHeight = (id, height)=>{
            if (debouncedHeightRef.current[id] == null) debouncedHeightRef.current[id] = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((debouncedHeight)=>{
                (0, $19nfo.updateLocalStorageHeight)(data.id, id, debouncedHeight);
                addForcedHeight(id, debouncedHeight);
            }, (0, $JIPqS.GADGET_HEIGHT_UPDATE_WAIT_TIME));
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            debouncedHeightRef.current[id](height);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isGadgetConfigurable = (id)=>{
            const gadget = data.gadgets.find((g)=>g.id === id);
            const { configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl } = gadget || {};
            return data.writable && (configurable || hasNonHiddenUserPrefs || Boolean(renderedGadgetUrl));
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.dashboardSpaBridge = {
            setGadgetTitle: setGadgetTitle,
            setGadgetHeight: setGadgetHeight,
            isGadgetConfigurable: isGadgetConfigurable
        };
    }, [
        data,
        addNonRenamable,
        addForcedHeight,
        saveCustomGadgetTitle,
        update
    ]);
};

});
parcelRegister("19nfo", function(module, exports) {

$parcel$export(module.exports, "getGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$9d44840cd06e000d);
$parcel$export(module.exports, "putGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$bfbe102b0a9ddb0b);
$parcel$export(module.exports, "deleteGadgetDataFromLocalStorage", () => $bf0cad76c08ceb09$export$d0ed0cab2f2757a9);
$parcel$export(module.exports, "updateLocalStorageHeight", () => $bf0cad76c08ceb09$export$2e93c23f060e835b);
$parcel$export(module.exports, "getLocalStorageHeight", () => $bf0cad76c08ceb09$export$e31e30011965d5e7);
$parcel$export(module.exports, "getAllLocalStorageHeights", () => $bf0cad76c08ceb09$export$2590d76ae5192a56);

var $bSSG7 = parcelRequire("bSSG7");

var $JIPqS = parcelRequire("JIPqS");
const $bf0cad76c08ceb09$export$6bac6bdc21b646b4 = (cookieData)=>{
    if (!cookieData) return {};
    const cookieInfos = cookieData.split('|').filter((cookieInfo)=>cookieInfo.trim().length);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return cookieInfos.reduce((acc, cookieInfo)=>{
        const COOKIE_INFO_PATTERN = /(?<cookieKey>.*)=(?<cookieValue>.*)/;
        const matchRes = cookieInfo.match(COOKIE_INFO_PATTERN);
        if (!matchRes) return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { cookieKey: cookieKey, cookieValue: cookieValue } = matchRes.groups;
        if (cookieKey.includes(':')) {
            const [gadgetId, gadgetAttributeName] = cookieKey.split(':');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        } else if (cookieKey.includes('-')) {
            const [, gadgetId, gadgetAttributeName] = cookieKey.split('-');
            acc[gadgetId] = acc[gadgetId] || {};
            acc[gadgetId][gadgetAttributeName] = cookieValue;
        }
        return acc;
    }, {});
};
const $bf0cad76c08ceb09$export$20a3a47cb251067e = (mappedCookieInfo)=>{
    let res = '';
    if (typeof mappedCookieInfo !== 'object') return res;
    Object.keys(mappedCookieInfo).forEach((id)=>{
        const attributeNames = mappedCookieInfo[id];
        if (typeof attributeNames !== 'object') return;
        Object.keys(attributeNames).forEach((attributeName)=>{
            const attributeValue = attributeNames[attributeName];
            if (!attributeValue) return;
            // If res already has contents add the separator
            if (res.length) res += '|';
            if (attributeName.includes('fh')) res += `gadget-${id}-${attributeName}=${attributeValue}`;
            else res += `${id}:${attributeName}=${attributeValue}`;
        });
    });
    return res;
};
const $bf0cad76c08ceb09$export$ad3e452a397f8ecc = ()=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    const cookieData = localStorage.get((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME));
    if (typeof cookieData !== 'string') return '';
    // TODO: Remove when monolith manipulation of gadget local storage is removed.
    // In particular around frame heights of gadgets coming from AG.Cookie.js
    // Issue is the FE local storage provider adds leading and trailing quotations
    // while the old local storage value does not have it. This causes issues when
    // the local storage is dynamically updated by the old monolith code
    // Eg. Might end up with something like '"foo=1"|bar=2'
    // To handle this for now, we remove all quotations
    return cookieData.replace(/"/g, '');
};
const $bf0cad76c08ceb09$export$9d44840cd06e000d = (id, gadgetDataKey)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    const gadgetInfo = mappedCookieInfo[id];
    return gadgetInfo?.[gadgetDataKey];
};
const $bf0cad76c08ceb09$export$bfbe102b0a9ddb0b = (id, gadgetDataKey, value)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    mappedCookieInfo[id] = mappedCookieInfo[id] ?? {};
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    mappedCookieInfo[id][gadgetDataKey] = value;
    const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    localStorage.set((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $bf0cad76c08ceb09$export$d0ed0cab2f2757a9 = (id, gadgetDataKey)=>{
    const cleanedCookieData = $bf0cad76c08ceb09$export$ad3e452a397f8ecc();
    const mappedCookieInfo = $bf0cad76c08ceb09$export$6bac6bdc21b646b4(cleanedCookieData);
    if (mappedCookieInfo[id]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    delete mappedCookieInfo[id][gadgetDataKey];
    const updatedCookieData = $bf0cad76c08ceb09$export$20a3a47cb251067e(mappedCookieInfo);
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    localStorage.set((0, $JIPqS.GADGET_LOCAL_STORAGE_NAME), updatedCookieData);
};
const $bf0cad76c08ceb09$export$2e93c23f060e835b = (dashboardId, gadgetId, height)=>{
    if (dashboardId == null || height == null) return;
    const heightAsInt = Math.round(height);
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME)) ?? {};
    dashboardLocalData[dashboardId] = dashboardLocalData[dashboardId] ?? {};
    const dashboardData = dashboardLocalData[dashboardId];
    dashboardData[gadgetId] = dashboardData[gadgetId] ?? {};
    const gadgetData = dashboardData[gadgetId];
    const storedHeight = gadgetData.height;
    if (storedHeight === heightAsInt) return;
    gadgetData.height = heightAsInt;
    localStorage.set((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME), dashboardLocalData);
};
const $bf0cad76c08ceb09$export$e31e30011965d5e7 = (dashboardId, gadgetId)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    const gadgetLocalHeight = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    dashboardLocalData?.[dashboardId]?.[gadgetId]?.height;
    return gadgetLocalHeight !== 0 && gadgetLocalHeight != null ? gadgetLocalHeight : (0, $JIPqS.GADGET_DEFAULT_HEIGHT);
};
const $bf0cad76c08ceb09$export$2590d76ae5192a56 = (dashboardId)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)('');
    const dashboardLocalData = localStorage.get((0, $JIPqS.DASHBOARD_LOCAL_STORAGE_KEY_NAME));
    return dashboardLocalData?.[dashboardId] ?? {};
};

});

parcelRegister("8h45R", function(module, exports) {

$parcel$export(module.exports, "useIsRenamable", () => $424d7b25bd304486$export$99680f47796b1368);
$parcel$export(module.exports, "useForcedHeight", () => $424d7b25bd304486$export$6286e5c3de90c7ce);
$parcel$export(module.exports, "useGadgetAdditionalStateActions", () => $424d7b25bd304486$export$7050d853cb5c3b12);
$parcel$export(module.exports, "GadgetAdditionalStateContainer", () => $424d7b25bd304486$export$c59b94948beb035f);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $424d7b25bd304486$var$actions = {
    addNonRenamable: (id)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newIds = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                isNonRenamable: true
            }));
            setState({
                idToStateMap: newIds
            });
        },
    addForcedHeight: (id, forcedHeight)=>({ setState: setState, getState: getState })=>{
            const gadgetIdToStateMap = getState().idToStateMap;
            const newGadgetIdToStateMap = new Map(gadgetIdToStateMap.set(id, {
                ...gadgetIdToStateMap.get(id),
                forcedHeight: forcedHeight
            }));
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        },
    remove: (id)=>({ setState: setState, getState: getState })=>{
            if (!getState().idToStateMap.has(id)) return;
            const newGadgetIdToStateMap = new Map(getState().idToStateMap);
            newGadgetIdToStateMap.delete(id);
            setState({
                idToStateMap: newGadgetIdToStateMap
            });
        }
};
const $424d7b25bd304486$var$Store = (0, $iXqE5.createStore)({
    name: 'gadget-additional-state',
    initialState: {
        idToStateMap: new Map()
    },
    actions: $424d7b25bd304486$var$actions
});
const $424d7b25bd304486$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $424d7b25bd304486$export$99680f47796b1368 = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: (state, id)=>!state.idToStateMap.get(id)?.isNonRenamable
}));
const $424d7b25bd304486$export$6286e5c3de90c7ce = $424d7b25bd304486$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: (state, id)=>state.idToStateMap.get(id)?.forcedHeight
}));
const $424d7b25bd304486$export$7050d853cb5c3b12 = (0, $3sQ5x.createHook)($424d7b25bd304486$var$Store, {
    selector: null
});
const $424d7b25bd304486$export$c59b94948beb035f = (0, $gg7kZ.createContainer)($424d7b25bd304486$var$Store);

});


parcelRegister("bOnpg", function(module, exports) {

$parcel$export(module.exports, "useDashboardAnalytics", () => $d2709a7a4ffbbf0c$export$6da6d2b3a61f8861);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $d2709a7a4ffbbf0c$export$6da6d2b3a61f8861 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(({ eventType: eventType, actionSubject: actionSubject, action: action, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        let fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        // All of the events have exactly the same signature and transformations underneath.
        switch(eventType){
            case 0, $4d5e0871c06cee03$export$947dac6c72b26f81:
                fireAnalytics = (0, $8zOmE.fireTrackAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$12346a674644c156:
                fireAnalytics = (0, $8zOmE.fireOperationalAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$a1562d08625f5d7e:
                fireAnalytics = (0, $8zOmE.fireUIAnalytics);
                break;
            case 0, $4d5e0871c06cee03$export$f1d537d508d2945a:
                fireAnalytics = (0, $8zOmE.fireScreenAnalytics);
                break;
            default:
                fireAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        }
        fireAnalytics(createAnalyticsEvent({}), `${actionSubject} ${action}`, actionSubjectId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        attributes);
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("6IxJi", function(module, exports) {

$parcel$export(module.exports, "useGadgetMetricsBridge", () => $d46d9a3e27973a8e$export$a81a90ecebb273c6);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bVDE5 = parcelRequire("bVDE5");

var $6fab6 = parcelRequire("6fab6");

var $8UPoO = parcelRequire("8UPoO");

var $1oaeD = parcelRequire("1oaeD");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $7FHsN = parcelRequire("7FHsN");

var $gW6vr = parcelRequire("gW6vr");
const $d46d9a3e27973a8e$var$OVERALL_TIMEOUT = 60000;
const $d46d9a3e27973a8e$var$buildEventKey = (event)=>{
    if (event.eventType !== (0, $5TsWX.GADGET_MARK_EVENT_PREFIX) || event.markName == null || event.markStage == null) return event.eventType;
    return `${0, $5TsWX.GADGET_MARK_EVENT_PREFIX}-${event.markName}-${event.markStage}`;
};
const $d46d9a3e27973a8e$export$b70b6efb2347a731 = (gadgetMetricsEvents, gadgetId, event)=>{
    let recorded = gadgetMetricsEvents.get(gadgetId);
    if (recorded == null) {
        recorded = {
            contentType: 'Unspecified',
            source: event.source,
            events: new Map()
        };
        gadgetMetricsEvents.set(gadgetId, recorded);
    }
    if (recorded.contentType !== 'ErrorMessage' && event.contentType !== 'Unspecified') recorded.contentType = event.contentType;
    const record = {
        spaTime: Date.now()
    };
    if (!recorded.events.has($d46d9a3e27973a8e$var$buildEventKey(event))) recorded.events.set($d46d9a3e27973a8e$var$buildEventKey(event), record);
};
const $d46d9a3e27973a8e$export$8aed66d0a3a7041d = (gadgets)=>gadgets.filter((item)=>item.amdModule != null || item.forge != null || item.reactKey != null)// Include only gadgets in the inclusion list
    .filter((item)=>// report all forge and react gadgets
        item.forge != null || item.reactKey != null || (0, $gW6vr.GADGETS_TO_REPORT).has(item.amdModule ?? '')).map((gadget)=>gadget.id);
const $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce = (gadgets)=>gadgets// Include only WRM gadget
    .filter((item)=>item.amdModule != null)// exclude connect gadgets
    .filter((item)=>!(0, $5TsWX.CONNECT_MODULE_PATTERN).test(item.amdModule || ''))// find gadgets not in either inclusion list or exclusion list
    .filter((item)=>!(0, $gW6vr.GADGETS_TO_REPORT).has(item.amdModule ?? '') && !(0, $gW6vr.GADGETS_IGNORED).has(item.amdModule ?? ''));
// Currently WRM gadget does not send render finish event in Config mode so we don't have accurate TTI for it
const $d46d9a3e27973a8e$var$shouldSendGadgetMetrics = (event)=>!(event.source === (0, $5TsWX.WRM_GADGET_METRICS) && event.contentType === 'Config');
const $d46d9a3e27973a8e$export$a81a90ecebb273c6 = (dashboardId, gadgets, layout)=>{
    const currentDashboardId = (0, $5uXOq.useRef)(null);
    // Metrics context in the a dashboard lifecycle.
    const dashboardMetricsContext = (0, $5uXOq.useRef)(null);
    const [, { registerListener: registerMessageListener, unregisterListener: unregisterMessageListener, broadcastMessage: broadcastMessageListener }] = (0, $i0rkS.useMessageBus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { sendGadgetMetrics: sendGadgetMetrics, sendOverallGadgetMetrics: sendOverallGadgetMetrics, onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender, resetScrollStartMetrics: resetScrollStartMetrics } = (0, $7FHsN.useGadgetMetricsAnalytics)(dashboardId);
    const [, { onGadgetRender: onGadgetRender }] = (0, $8UPoO.useRenderAboveTheFold)();
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { name: routeName } = (0, $6jY6G.useCurrentRoute)();
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const maximizedId = getMaximisedGadgetId;
    if (currentDashboardId.current == null || currentDashboardId.current !== dashboardId) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'dashboardMetricsContext renewed', {
            dashboardId: dashboardId,
            previousDashboardId: currentDashboardId.current,
            currentPageId: currentPageId
        });
        resetScrollStartMetrics();
        // Dashboard reinitialised or changed
        currentDashboardId.current = dashboardId;
        if (dashboardMetricsContext.current?.metricsTimeout != null) clearTimeout(dashboardMetricsContext.current.metricsTimeout);
        const extractedGadgets = $d46d9a3e27973a8e$export$8aed66d0a3a7041d(maximizedId ? gadgets.filter((gadget)=>gadget.id === maximizedId) : gadgets);
        const allAboveTheFoldGadgets = (0, $8UPoO.getAboveTheFoldGadgets)((0, $6fab6.toColumns)(gadgets, layout), dashboardId);
        dashboardMetricsContext.current = {
            gadgetMetricsEvents: new Map(),
            gadgetIdsInOverallAnalytics: extractedGadgets,
            gadgetIdsInTti: extractedGadgets.filter((gadgetId)=>allAboveTheFoldGadgets.has(gadgetId)),
            allGadgetIds: gadgets.map((item)=>item.id),
            overallMetricsSent: false,
            atfMetricsSent: false,
            implicitlyIgnoredGadgetLogged: false,
            gadgetRenderStartTime: Date.now(),
            metricsTimeout: setTimeout(()=>{
                broadcastMessageListener((0, $JIPqS.GADGET_METRICS_TYPE).TIMEOUT, {}, {});
            }, $d46d9a3e27973a8e$var$OVERALL_TIMEOUT),
            timestamps: {
                created: Date.now(),
                pnow: performance?.now(),
                currentPageId: currentPageId,
                lastTransitionStartTime: lastTransitionStartTime,
                navigationStart: navigationStart,
                navStart: (0, $7FHsN.getNavStart)(isInitialRender, lastTransitionStartTime, navigationStart)
            }
        };
    }
    const gadgetMetricsTimeout = (0, $5uXOq.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        context.metricsTimeout = undefined;
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        context.overallMetricsSent = true;
        // Send metrics for timed out gadget that sent at least one event.
        context.gadgetMetricsEvents.forEach((item, id)=>{
            if (item.allEventHandled !== true) {
                // eslint-disable-next-line no-param-reassign
                item.timedOut = true;
                sendGadgetMetrics(id, item);
            }
        });
        // Send metrics for idle gadgets that haven't sent any event
        context.gadgetIdsInOverallAnalytics.filter((id)=>!context.gadgetMetricsEvents.has(id)).forEach((id)=>{
            sendGadgetMetrics(id, {
                source: (0, $5TsWX.IDLE_GADGET_SOURCE),
                timedOut: true,
                events: new Map()
            });
        });
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, true);
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, true);
    }, [
        sendGadgetMetrics,
        sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender
    ]);
    const onAllGadgetHandled = (0, $5uXOq.useCallback)(()=>{
        // Set up the overall flag so that gadgetMetricsListener will stop handling gadget events
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        context.overallMetricsSent = true;
        if (context.metricsTimeout != null) {
            clearTimeout(context.metricsTimeout);
            context.metricsTimeout = undefined;
        }
        sendOverallGadgetMetrics(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, false);
    }, [
        sendOverallGadgetMetrics
    ]);
    const onAboveTheFoldGadgetsHandled = (0, $5uXOq.useCallback)(()=>{
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        onAboveTheFoldGadgetsRender(context.gadgetIdsInOverallAnalytics, context.gadgetMetricsEvents, context.gadgetRenderStartTime, context.timestamps, false);
        context.atfMetricsSent = true;
    }, [
        onAboveTheFoldGadgetsRender
    ]);
    const gadgetMetricsListener = (0, $5uXOq.useCallback)((gid, command, ...args)=>{
        if (command !== 'metrics_event' || !args[0]) return;
        const context = dashboardMetricsContext.current;
        if (context == null) return;
        if (context.overallMetricsSent) return;
        const eventData = args[0];
        const eventsPerGadget = (0, $7FHsN.getAllEventHandlers)(eventData.source, eventData.contentType);
        const { pageId: pageIdInEvent } = eventData;
        // If the gadget id for the event is not in the current gadgetIds list, it is from a stale gadget of the previous dashboard
        if (currentPageId !== pageIdInEvent || context.allGadgetIds.every((id)=>id !== gid)) {
            (0, $dJl1T.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `Page [${currentPageId ?? ''}] recieved staled gadget metrics event [${eventData.eventType}] from gadget [${gid}] in page [${pageIdInEvent ?? ''}]`);
            return;
        }
        // Check if all expected events for a gadget are triggered and handled
        const isAllGadgetEventsHandled = (gadgetEvents)=>gadgetEvents?.allEventHandled === true || gadgetEvents?.timedOut === true || eventsPerGadget.every((e)=>gadgetEvents?.events.has(e));
        // Check if all gadgets has been handled
        const isAllGadgetHandled = (gadgetIds)=>gadgetIds.every((id)=>context.gadgetMetricsEvents.get(id)?.allEventHandled);
        if (context.gadgetMetricsEvents.has(gid)) {
            if (isAllGadgetEventsHandled(context.gadgetMetricsEvents.get(gid))) // gadget has been handled
            return;
            if (context.gadgetMetricsEvents.get(gid)?.events.has($d46d9a3e27973a8e$var$buildEventKey(eventData))) // event has been handled
            return;
        }
        $d46d9a3e27973a8e$export$b70b6efb2347a731(context.gadgetMetricsEvents, gid, eventData);
        const event = context.gadgetMetricsEvents.get(gid);
        if (event != null && isAllGadgetEventsHandled(event)) {
            event.allEventHandled = true;
            if ($d46d9a3e27973a8e$var$shouldSendGadgetMetrics(event)) {
                onGadgetRender(gid);
                sendGadgetMetrics(gid, event);
            }
            // if all above the fold gadgets are handled,  send gadgets metrics
            if (context.atfMetricsSent === false) {
                if (isAllGadgetHandled(context.gadgetIdsInTti)) onAboveTheFoldGadgetsHandled();
            }
            // if all gadgets are handled, send overall metrics
            if (isAllGadgetHandled(context.gadgetIdsInOverallAnalytics)) {
                onAllGadgetHandled();
                if (context.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
            }
        }
    }, [
        currentPageId,
        onAboveTheFoldGadgetsHandled,
        onAllGadgetHandled,
        sendGadgetMetrics,
        onGadgetRender
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // NOTE - This is temporary until we fix metrics for wallboard
            if (routeName === 'dashboard-wallboard') return;
            if (dashboardMetricsContext.current?.metricsTimeout != null) {
                clearTimeout(dashboardMetricsContext.current.metricsTimeout);
                dashboardMetricsContext.current.metricsTimeout = undefined;
            }
        }, [
        routeName
    ]);
    const gadgetMetricsMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type, message, context)=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).REPORT) return;
        const { gadgetId: gid, pageId: pageId } = context;
        if (gid == null) return;
        gadgetMetricsListener(gid, 'metrics_event', {
            ...message,
            pageId: pageId
        });
    }, [
        gadgetMetricsListener
    ]);
    const timeoutMessageBusListenerAdaptor = (0, $5uXOq.useCallback)((type)=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).TIMEOUT) return;
        gadgetMetricsTimeout();
    }, [
        gadgetMetricsTimeout
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // NOTE - This is temporary until we fix metrics for wallboard
        if (routeName === 'dashboard-wallboard') // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        registerMessageListener(gadgetMetricsMessageBusListenerAdaptor);
        registerMessageListener(timeoutMessageBusListenerAdaptor);
        return ()=>{
            unregisterMessageListener(gadgetMetricsMessageBusListenerAdaptor);
            unregisterMessageListener(timeoutMessageBusListenerAdaptor);
        };
    }, [
        gadgetMetricsMessageBusListenerAdaptor,
        gadgetMetricsListener,
        registerMessageListener,
        timeoutMessageBusListenerAdaptor,
        unregisterMessageListener,
        routeName
    ]);
    // NOTE - This is temporary until we fix metrics for wallboard
    if (routeName === 'dashboard-wallboard') return;
    if (dashboardMetricsContext.current == null || dashboardMetricsContext.current.overallMetricsSent === true) return;
    // Send overall event immediately for empty dashboard
    if (dashboardMetricsContext.current?.gadgetIdsInOverallAnalytics.length === 0) {
        onAboveTheFoldGadgetsHandled();
        onAllGadgetHandled();
    } else if (dashboardMetricsContext.current?.gadgetIdsInTti.length === 0 && dashboardMetricsContext.current?.atfMetricsSent === false) onAboveTheFoldGadgetsHandled();
    if (dashboardMetricsContext.current != null && !dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged) {
        dashboardMetricsContext.current.implicitlyIgnoredGadgetLogged = true;
        $d46d9a3e27973a8e$export$b2ee8eefeb9c97ce(gadgets).forEach((item)=>{
            (0, $dJl1T.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics for gadget [${item.amdModule ?? 'unknown'}] is ignored implicitly.`);
        });
    }
};

});
parcelRegister("8UPoO", function(module, exports) {

$parcel$export(module.exports, "getAboveTheFoldGadgets", () => $149138b232138cbc$export$e12eddecf5e86fe5);
$parcel$export(module.exports, "useRenderAboveTheFold", () => $149138b232138cbc$export$16f58cfd4c8ccf70);
$parcel$export(module.exports, "RenderAboveTheFoldContainer", () => $149138b232138cbc$export$9710049f7f21917b);
$parcel$export(module.exports, "useOnGadgetRender", () => $149138b232138cbc$export$c127791d148e941c);
$parcel$export(module.exports, "useOnGadgetRenderEffect", () => $149138b232138cbc$export$1f28971b410f9e3);
$parcel$export(module.exports, "useShouldRenderGadget", () => $149138b232138cbc$export$428a5d740650db3e);
$parcel$export(module.exports, "useLocalStorageGadgetHeight", () => $149138b232138cbc$export$94d0a966fb813ab7);
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */ 
var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $19nfo = parcelRequire("19nfo");
const $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT = 56;
const $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT = 80;
const $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT = 84;
const $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT = 7000;
const $149138b232138cbc$export$e12eddecf5e86fe5 = (columns, dashboardId)=>{
    const aboveTheFoldGadgets = new Set();
    const availableViewportHeight = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.innerHeight - $149138b232138cbc$var$TOP_NAVIGATION_HEIGHT - $149138b232138cbc$var$DASHBOARD_HEADER_HEIGHT;
    columns.forEach((column)=>{
        let occupiedViewportHeight = 0;
        column.some((gadget)=>{
            if (occupiedViewportHeight < availableViewportHeight) {
                const gadgetHeight = (0, $19nfo.getLocalStorageHeight)(dashboardId, gadget.id) + $149138b232138cbc$var$GADGET_HEADER_AND_FOOTER_HEIGHT;
                aboveTheFoldGadgets.add(gadget.id);
                occupiedViewportHeight += gadgetHeight;
                return false;
            }
            // if we have enough height, we terminate the loop
            return true;
        });
    });
    return aboveTheFoldGadgets;
};
const $149138b232138cbc$export$e324594224ef24da = {
    onGadgetRender: (gadgetId, height)=>({ setState: setState, getState: getState })=>{
            const { dashboardId: dashboardId, loadingAboveTheFold: hasAboveTheFold, timeoutId: timeoutLast } = getState();
            // Always return default for wallboard, where dashboardId is null
            if (dashboardId === null) return;
            // we want this to always happen whenever onGadgetRender is called
            if (height != null) {
                (0, $19nfo.updateLocalStorageHeight)(dashboardId, gadgetId, height);
                setState({
                    localStorageGadgetHeights: {
                        // we can't use this from the state as it might be stale due to other gadgets
                        // possibly updating their heights directly in localStorage
                        ...(0, $19nfo.getAllLocalStorageHeights)(dashboardId),
                        [gadgetId]: {
                            height: height
                        }
                    }
                });
            }
            if (!hasAboveTheFold) return;
            const remainingAboveTheFoldGadgets = new Set(getState().remainingAboveTheFoldGadgets);
            remainingAboveTheFoldGadgets.delete(gadgetId);
            const loadingAboveTheFold = Boolean(remainingAboveTheFoldGadgets.size);
            const timeoutId = loadingAboveTheFold ? timeoutLast : null;
            if (timeoutLast && !timeoutId) clearTimeout(timeoutLast);
            setState({
                remainingAboveTheFoldGadgets: remainingAboveTheFoldGadgets,
                loadingAboveTheFold: loadingAboveTheFold,
                timeoutId: timeoutId
            });
        }
};
const $149138b232138cbc$var$Store = (0, $iXqE5.createStore)({
    name: 'RenderAboveTheFold',
    initialState: {
        dashboardId: null,
        loadingAboveTheFold: true,
        aboveTheFoldGadgets: new Set(),
        remainingAboveTheFoldGadgets: new Set(),
        timeoutId: null,
        timeout: false,
        localStorageGadgetHeights: {}
    },
    actions: $149138b232138cbc$export$e324594224ef24da
});
const $149138b232138cbc$export$16f58cfd4c8ccf70 = (0, $3sQ5x.createHook)($149138b232138cbc$var$Store);
const $149138b232138cbc$export$f0ff1fd44503e803 = (0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: null
});
const $149138b232138cbc$export$9710049f7f21917b = (0, $gg7kZ.createContainer)($149138b232138cbc$var$Store, {
    onInit: ()=>({ setState: setState, getState: getState }, { columns: columns, dashboardId: dashboardId, maximizedGadgetId: maximizedGadgetId })=>{
            if (getState().dashboardId !== dashboardId && dashboardId != null) {
                const loadingAboveTheFoldTimeout = ()=>{
                    setState({
                        remainingAboveTheFoldGadgets: new Set(),
                        loadingAboveTheFold: false,
                        timeout: true
                    });
                };
                const aboveTheFoldGadgets = maximizedGadgetId ? new Set([
                    maximizedGadgetId
                ]) : $149138b232138cbc$export$e12eddecf5e86fe5(columns, dashboardId);
                // calculate gadgets
                setState({
                    dashboardId: dashboardId,
                    aboveTheFoldGadgets: aboveTheFoldGadgets,
                    remainingAboveTheFoldGadgets: new Set(aboveTheFoldGadgets),
                    loadingAboveTheFold: Boolean(aboveTheFoldGadgets.size),
                    timeoutId: setTimeout(loadingAboveTheFoldTimeout, $149138b232138cbc$var$PRIORITISED_RENDERING_TIMEOUT),
                    timeout: false,
                    localStorageGadgetHeights: (0, $19nfo.getAllLocalStorageHeights)(dashboardId)
                });
            }
        }
});
const $149138b232138cbc$export$c127791d148e941c = (id)=>{
    const [, { onGadgetRender: onGadgetRender }] = $149138b232138cbc$export$f0ff1fd44503e803();
    return (0, $5uXOq.useCallback)((height)=>onGadgetRender(id, height), [
        id,
        onGadgetRender
    ]);
};
const $149138b232138cbc$export$1f28971b410f9e3 = (id, gadgetRef)=>{
    const onGadgetRender = $149138b232138cbc$export$c127791d148e941c(id);
    (0, $5uXOq.useEffect)(()=>{
        onGadgetRender(gadgetRef?.getBoundingClientRect().height);
    }, [
        onGadgetRender,
        gadgetRef
    ]);
};
const $149138b232138cbc$export$b8a31aa234db5dc9 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
hook)=>(args)=>{
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '[PR]' is not assignable to parameter of type 'void'.
        const [value] = hook(args);
        return value;
    };
const $149138b232138cbc$export$428a5d740650db3e = $149138b232138cbc$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: ({ loadingAboveTheFold: loadingAboveTheFold, aboveTheFoldGadgets: aboveTheFoldGadgets, dashboardId: dashboardId }, gadgetId)=>{
        // Always return true for wallboard, where the dashboardId isn't defined as it uses query parameters instead
        if (dashboardId === null) return true;
        return !loadingAboveTheFold || aboveTheFoldGadgets.has(gadgetId);
    }
}));
const $149138b232138cbc$export$94d0a966fb813ab7 = $149138b232138cbc$export$b8a31aa234db5dc9((0, $3sQ5x.createHook)($149138b232138cbc$var$Store, {
    selector: ({ localStorageGadgetHeights: localStorageGadgetHeights }, gadgetId)=>localStorageGadgetHeights[gadgetId]?.height ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)
}));

});

parcelRegister("i0rkS", function(module, exports) {

$parcel$export(module.exports, "useMessageBus", () => $f812b795237bfc34$export$69241ffa7d4e8d8d);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $f812b795237bfc34$var$actions = {
    registerListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: [
                    ...listeners,
                    listener
                ]
            });
        },
    unregisterListener: (listener)=>({ setState: setState, getState: getState })=>{
            const { listeners: listeners } = getState();
            setState({
                listeners: listeners.filter((cb)=>cb !== listener)
            });
        },
    broadcastMessage: (type, message, context)=>({ getState: getState })=>{
            getState().listeners.forEach((listener)=>listener(type, message, context));
        }
};
const $f812b795237bfc34$var$Store = (0, $iXqE5.createStore)({
    name: 'dashboard-message-bus',
    initialState: {
        listeners: []
    },
    actions: $f812b795237bfc34$var$actions
});
const $f812b795237bfc34$export$69241ffa7d4e8d8d = (0, $3sQ5x.createHook)($f812b795237bfc34$var$Store);

});

parcelRegister("5TsWX", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_GADGET_TYPE", () => $3975f005d3e53b97$export$4db4c2521224b627);
$parcel$export(module.exports, "CONNECT_MODULE_PATTERN", () => $3975f005d3e53b97$export$c1ee01d79441a123);
$parcel$export(module.exports, "FORGE_MODULE_PATTERN", () => $3975f005d3e53b97$export$216b1f7517647987);
$parcel$export(module.exports, "WRM_GADGET_METRICS", () => $3975f005d3e53b97$export$747c046b02db553e);
$parcel$export(module.exports, "FORGE_GADGET_METRICS", () => $3975f005d3e53b97$export$fd11359c208e3b3d);
$parcel$export(module.exports, "REACT_GADGET_METRICS", () => $3975f005d3e53b97$export$e6e5910bcc3a541f);
$parcel$export(module.exports, "FALLBACK_GADGET_SOURCE", () => $3975f005d3e53b97$export$b17b847ae2e73914);
$parcel$export(module.exports, "IDLE_GADGET_SOURCE", () => $3975f005d3e53b97$export$8e7a356fc2e45e1);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PREFIX", () => $3975f005d3e53b97$export$deb23548f6bb4aa6);
$parcel$export(module.exports, "GADGET_MARK_EVENT_PATTERN", () => $3975f005d3e53b97$export$dc82d3f06c18522e);
$parcel$export(module.exports, "GADGET_RENDER_CONTAINER_EVENT", () => $3975f005d3e53b97$export$479474c5d2f30a0a);
$parcel$export(module.exports, "GADGET_START_EVENT", () => $3975f005d3e53b97$export$76b0ea781056f8d3);
$parcel$export(module.exports, "GADGET_RENDERING_FINISHED_EVENT", () => $3975f005d3e53b97$export$b9c9f3ffa9290059);
$parcel$export(module.exports, "DEFAULT_WRM_GADGET_EVENTS", () => $3975f005d3e53b97$export$f34d5b0533833e95);
const $3975f005d3e53b97$export$4db4c2521224b627 = 'unknown';
const $3975f005d3e53b97$export$c1ee01d79441a123 = /^atlassian-connect\/.*/;
const $3975f005d3e53b97$export$216b1f7517647987 = /^ari:cloud:ecosystem::extension\/.*/;
const $3975f005d3e53b97$export$747c046b02db553e = 'wrm_gadget_metrics';
const $3975f005d3e53b97$export$fd11359c208e3b3d = 'forge_gadget_metrics';
const $3975f005d3e53b97$export$e6e5910bcc3a541f = 'react_gadget_metrics';
const $3975f005d3e53b97$export$b17b847ae2e73914 = 'fallback_gadget';
const $3975f005d3e53b97$export$8e7a356fc2e45e1 = 'idle_gadget';
const $3975f005d3e53b97$export$deb23548f6bb4aa6 = 'gadget-mark';
const $3975f005d3e53b97$export$dc82d3f06c18522e = new RegExp(`^${$3975f005d3e53b97$export$deb23548f6bb4aa6}-(.+)-(start|end)$`);
const $3975f005d3e53b97$export$479474c5d2f30a0a = 'gadget-render-container';
const $3975f005d3e53b97$export$76b0ea781056f8d3 = 'gadget-start';
const $3975f005d3e53b97$export$b9c9f3ffa9290059 = 'gadget-rendering-finished';
const $3975f005d3e53b97$export$f34d5b0533833e95 = [
    $3975f005d3e53b97$export$479474c5d2f30a0a,
    $3975f005d3e53b97$export$76b0ea781056f8d3,
    $3975f005d3e53b97$export$b9c9f3ffa9290059
];

});

parcelRegister("7FHsN", function(module, exports) {

$parcel$export(module.exports, "getAllEventHandlers", () => $f42b084586d299a2$export$835bb833cb903f59);
$parcel$export(module.exports, "getNavStart", () => $f42b084586d299a2$export$f409d0aa399347ac);
$parcel$export(module.exports, "useGadgetMetricsAnalytics", () => $f42b084586d299a2$export$ea517a7cfce02895);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $99gkn = parcelRequire("99gkn");

var $bFU4G = parcelRequire("bFU4G");

var $hh0bW = parcelRequire("hh0bW");

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");

var $b3IiT = parcelRequire("b3IiT");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iAWa3 = parcelRequire("iAWa3");

var $3B7oW = parcelRequire("3B7oW");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $7cLxq = parcelRequire("7cLxq");

var $8UDz8 = parcelRequire("8UDz8");

var $trHKK = parcelRequire("trHKK");

var $hmyfM = parcelRequire("hmyfM");

var $8UPoO = parcelRequire("8UPoO");

var $5TsWX = parcelRequire("5TsWX");
// At time of writing BM3 doesn't support ssrFeatureFlags unless your page performs initial-paint
// in ssr (not just skeleton content), which Dashboard does not.
// We are forced to recreate here based on "@atlassian/jira-browser-metrics".
// We cannot reference code from BM directly since it gets removed in storybook, causing errors.
const $f42b084586d299a2$var$getSSRFeatureFlags = (0, $8QpSo.default)(()=>{
    try {
        const metaTagValue = (0, $j8DrX.default)('spa-service-flags');
        return metaTagValue != null && JSON.parse(metaTagValue) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $f42b084586d299a2$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {},
    wasExperienceSuccesful: true
};
// All expected metrics events from a WRM gadget in Config mode
const $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS = [
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
];
// Expected metrics events from immediately finished gadgets e.g. fallbacks
const $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS = [
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
];
// Events send by the gadget container, which should not be counted to determine idle gadget
const $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS = new Set([
    (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT)
]);
const $f42b084586d299a2$export$835bb833cb903f59 = (eventSource, contentType = 'View')=>{
    if (eventSource === (0, $5TsWX.WRM_GADGET_METRICS) || eventSource === (0, $5TsWX.FORGE_GADGET_METRICS) || eventSource === (0, $5TsWX.REACT_GADGET_METRICS)) return contentType === 'Config' ? $f42b084586d299a2$var$DEFAULT_WRM_GADGET_CONFIG_EVENTS : (0, $5TsWX.DEFAULT_WRM_GADGET_EVENTS);
    return $f42b084586d299a2$var$IMMEDIATE_FINISH_GADGET_EVENTS;
};
const $f42b084586d299a2$var$isIdle = (gadgetEventRecord)=>{
    if (gadgetEventRecord == null) return false;
    if (gadgetEventRecord.source === (0, $5TsWX.IDLE_GADGET_SOURCE)) return true;
    const eventEntries = Array.from(gadgetEventRecord.events.entries());
    return eventEntries.length === $f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.size && eventEntries.every((entry)=>$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(entry[0]));
};
const $f42b084586d299a2$export$b1f29dd0b70f467b = (events)=>{
    const customMarksMap = {};
    const customMarksList = [];
    events.forEach((event, eventKey)=>{
        const parts = (0, $5TsWX.GADGET_MARK_EVENT_PATTERN).exec(eventKey);
        if (parts == null) return;
        const key = parts[1];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const stage = parts[2];
        const customMark = customMarksMap[key];
        if (customMark == null) {
            const newCustomMark = {
                name: `gadgetMark_${key}`,
                [stage]: event.spaTime
            };
            customMarksMap[key] = newCustomMark;
            customMarksList.push(newCustomMark);
        } else customMark[stage] = event.spaTime;
    });
    return customMarksList;
};
const $f42b084586d299a2$var$getInitialMarks = (context)=>({
        TTI: Date.now() - Number(context.navStart),
        isInitialRender: context.isInitialRender,
        isWritable: context.isWritable,
        isRouteReplaced: context.isRouteReplaced,
        currentPageId: context.currentPageId,
        // TODO should be removed in favour of BM3 pageVisible property
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        pageVisible: !window?.document?.hidden,
        ssrFeatureFlags: $f42b084586d299a2$var$getSSRFeatureFlags(),
        featureFlags: (0, $7cLxq.getDashboardFeatureFlags)(),
        featureGates: (0, $8UDz8.getDashboardFeatureGates)(),
        centralised: true
    });
const $f42b084586d299a2$export$f409d0aa399347ac = (isInitialRender, lastTransitionStartTime, navigationStart)=>{
    const sessionStart = navigationStart != null ? new Date(navigationStart).getTime() : 0;
    return !isInitialRender && lastTransitionStartTime != null ? lastTransitionStartTime : sessionStart;
};
const $f42b084586d299a2$var$isInvalidContextState = (metricsContextTimeStamp, currentNavStart, currentPageId)=>{
    if (metricsContextTimeStamp.currentPageId !== currentPageId) return true;
    if (metricsContextTimeStamp.created < metricsContextTimeStamp.navStart) return true;
    const now = Date.now();
    if (now < metricsContextTimeStamp.navStart) return true;
    if (now < Number(currentNavStart)) return true;
    return false;
};
const $f42b084586d299a2$export$ea517a7cfce02895 = (dashboardId)=>{
    const [{ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime, navigationStart: navigationStart, currentPageId: currentPageId = 'unknown' }] = (0, $bVDE5.useSpaStateTransition)();
    const [{ aboveTheFoldGadgets: aboveTheFoldGadgets }] = (0, $8UPoO.useRenderAboveTheFold)();
    const [routerState] = (0, $doZTA.useRouter)();
    const navStart = $f42b084586d299a2$export$f409d0aa399347ac(isInitialRender, lastTransitionStartTime, navigationStart);
    const dashboardData = (0, $gh1hi.useDashboardResource)().data;
    const { scrollStartTimestamp: scrollStartTimestamp, resetScrollStartTime: resetScrollStartTime } = (0, $hmyfM.useDashboardScrollAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const newContext = {
        dashboardId: dashboardId,
        isInitialRender: isInitialRender,
        isRouteReplaced: routerState.action === 'REPLACE',
        lastTransitionStartTime: lastTransitionStartTime,
        navigationStart: navigationStart,
        currentPageId: currentPageId,
        navStart: navStart,
        gadgets: dashboardData?.gadgets,
        isWritable: dashboardData?.writable ?? false,
        scrollStartTimestamp: scrollStartTimestamp,
        aboveTheFoldGadgets: aboveTheFoldGadgets,
        resetScrollStartTime: resetScrollStartTime
    };
    const context = (0, $5uXOq.useRef)(newContext);
    context.current = newContext;
    const sendGadgetMetrics = (0, $5uXOq.useCallback)((gadgetId, gadgetEventRecord)=>{
        if (context.current.navigationStart == null) return;
        const gadgetModel = context.current.gadgets?.find((item)=>item.id === gadgetId) || null;
        // Setup common marks first
        const customMarks = {
            ...$f42b084586d299a2$var$getInitialMarks(context.current),
            timeout: gadgetEventRecord.timedOut === true,
            gadgetContentType: gadgetEventRecord.contentType,
            isAboveTheFold: context.current.aboveTheFoldGadgets.has(gadgetId)
        };
        // Timeout Marks
        if (gadgetEventRecord.timedOut === true) {
            if ($f42b084586d299a2$var$isIdle(gadgetEventRecord)) customMarks.timeout_idle = true;
            else $f42b084586d299a2$export$835bb833cb903f59(gadgetEventRecord.source, gadgetEventRecord.contentType).filter((event)=>!$f42b084586d299a2$var$GADGET_CONTAINER_EVENTS.has(event)).filter((event)=>!gadgetEventRecord.events.has(event)).forEach((event)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                customMarks[`timeout_${event}`] = true;
            });
        }
        if (gadgetEventRecord.source === (0, $5TsWX.WRM_GADGET_METRICS) || gadgetEventRecord.source === (0, $5TsWX.FORGE_GADGET_METRICS) || gadgetEventRecord.source === (0, $5TsWX.REACT_GADGET_METRICS)) {
            customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || gadgetModel?.reactKey || (0, $5TsWX.UNKNOWN_GADGET_TYPE);
            const renderContainer = gadgetEventRecord.events.get((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT));
            const start = gadgetEventRecord.events.get((0, $5TsWX.GADGET_START_EVENT));
            if (renderContainer != null) customMarks.gadgetRenderContainer = renderContainer.spaTime - Number(context.current.navStart);
            if (start != null) {
                customMarks.gadgetStartTime = start.spaTime - Number(context.current.navStart);
                customMarks.gadgetDuration = Date.now() - start.spaTime;
            }
        } else if (gadgetEventRecord.source === (0, $5TsWX.IDLE_GADGET_SOURCE) || gadgetEventRecord.source === (0, $5TsWX.FALLBACK_GADGET_SOURCE)) // The gadget doesn't send any event till timed out
        customMarks.gadgetType = gadgetModel?.amdModule || gadgetModel?.forge?.key || (0, $5TsWX.UNKNOWN_GADGET_TYPE);
        $f42b084586d299a2$export$b1f29dd0b70f467b(gadgetEventRecord.events).forEach((gadgetMark)=>{
            if (gadgetMark.start != null) customMarks[`${gadgetMark.name}-start`] = gadgetMark.start - Number(context.current.navStart);
            if (gadgetMark.start != null && gadgetMark.end != null) customMarks[`${gadgetMark.name}-duration`] = gadgetMark.end - gadgetMark.start;
        });
        const gadgetLoadIdentifier = `gadget-${context.current.dashboardId ?? 'no-dashboard-id'}-${gadgetId}`;
        (0, $trHKK.gadgetLoad)(gadgetLoadIdentifier).start({
            startTime: context.current.navStart
        });
        (0, $trHKK.gadgetLoad)(gadgetLoadIdentifier).stop({
            customData: customMarks,
            stopTime: Date.now()
        });
        if (gadgetEventRecord.source === (0, $5TsWX.WRM_GADGET_METRICS) && gadgetEventRecord.contentType !== 'View' && gadgetEventRecord.contentType !== 'Config' && !(0, $4R6GH.fg)('endeavour_fix_failed_view_wrm_events')) (0, $hh0bW.default)({
            ...$f42b084586d299a2$var$expAttributes,
            experience: (0, $JIPqS.VIEW_WRM_GADGET_EXPERIENCE),
            wasExperienceSuccesful: false
        });
    }, []);
    const sendOverallGadgetMetrics = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, timeout)=>{
        const metricToReport = {
            timeout: timeout,
            fullDashboardTTI: Date.now() - Number(context.current.navStart),
            dashboardScrollStartTime: context.current.scrollStartTimestamp.current != null ? context.current.scrollStartTimestamp.current - Number(context.current.navStart) : 'unknown',
            belowTheFoldTTI: Date.now() - (context.current.scrollStartTimestamp.current != null && (context.current.gadgets?.length || 0) - context.current.aboveTheFoldGadgets.size > 0 ? context.current.scrollStartTimestamp.current : Date.now())
        };
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fullDashboard loaded', metricToReport);
    }, [
        createAnalyticsEvent
    ]);
    const onAboveTheFoldGadgetsRender = (0, $5uXOq.useCallback)((gadgetIds, gadgetMetricsEvents, gadgetRenderStartTime, contextTimeStamps, timeout)=>{
        const totalGadgetsCount = context.current.gadgets?.length || 0;
        // count connect gadgets
        const connectGadgetCount = context.current.gadgets?.filter((item)=>(0, $5TsWX.CONNECT_MODULE_PATTERN).test(item.amdModule || '')).length || 0;
        // count forge gadgets
        const forgeGadgetCount = context.current.gadgets?.filter((item)=>(0, $5TsWX.FORGE_MODULE_PATTERN).test(item.forge?.key || '')).length || 0;
        // count internal gadgets
        const internalGadgetCount = totalGadgetsCount - connectGadgetCount - forgeGadgetCount;
        // count untracked gadgets (including connect)
        const untrackedGadgetCount = context.current.gadgets?.filter((item)=>gadgetIds.every((id)=>id !== item.id)).length || 0;
        // count the deprecated gadgets
        const deprecatedGadgetsCount = context.current.gadgets ? context.current.gadgets.filter((gadget)=>(0, $b3IiT.checkGadgetType)((0, $JIPqS.DEPRECATED_GADGETS_MAP), gadget.amdModule)).length : 0;
        const initialMarks = $f42b084586d299a2$var$getInitialMarks(context.current);
        const gadgetRenderStart = gadgetRenderStartTime - Number(context.current.navStart);
        // Validate metrics context
        const invalidContextState = $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        context.current.navStart, context.current.currentPageId) || initialMarks.TTI < 0 || gadgetRenderStart < 0;
        if (invalidContextState) // Report abnormal status
        (0, $dJl1T.default).safeWarnWithoutCustomerData('spa-apps.dashboard.gadget.metrics', `metrics context state is invalid for dashboard [${context.current.currentPageId ?? 'null'}]: { contextTimestamps: ${JSON?.stringify(contextTimeStamps)}, now:${Date.now()}, pnow:${performance?.now()}, navStart:${context.current.navStart} }`);
        const customData = {
            ...initialMarks,
            gadgetRenderStart: gadgetRenderStart,
            // counts
            gadgetCount_Total: totalGadgetsCount,
            gadgetCount_Internal: internalGadgetCount,
            gadgetCount_Connect: connectGadgetCount,
            gadgetCount_Forge: forgeGadgetCount,
            gadgetCount_Unknown: untrackedGadgetCount - connectGadgetCount,
            timeout: timeout,
            gadgetCount_AboveTheFold: context.current.aboveTheFoldGadgets.size,
            gadgetCount_BelowTheFold: totalGadgetsCount - context.current.aboveTheFoldGadgets.size,
            gadgetCount_Deprecated: deprecatedGadgetsCount,
            isStaled: invalidContextState
        };
        (0, $99gkn.addUFOCustomData)(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3B7oW.trackBM3FeatureFlagsAccessed)((0, $trHKK.dashboardLoad));
        (0, $bFU4G.addApdexToAll)({
            key: (0, $trHKK.dashboardLoad).key,
            stopTime: performance.now()
        });
        (0, $iAWa3.afterPaintEmit)((stopTime)=>{
            (0, $trHKK.dashboardLoad).stop({
                stopTime: stopTime,
                customData: // @ts-expect-error - feature flags may technically be null which BM3 doesn't like
                customData
            });
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $trHKK.dashboardLoad));
    }, []);
    const resetScrollStartMetrics = (0, $5uXOq.useCallback)(()=>{
        context.current.resetScrollStartTime();
    }, []);
    const sendDebuggingAnalytics = (0, $5uXOq.useCallback)((contextTimeStamps)=>{
        const attributes = {
            isStale: $f42b084586d299a2$var$isInvalidContextState(contextTimeStamps, context.current.navStart, context.current.currentPageId),
            tti: Date.now() - Number(context.current.navStart),
            currentPageId: context.current.currentPageId
        };
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'tti sent', attributes);
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendGadgetMetrics: sendGadgetMetrics,
        sendOverallGadgetMetrics: sendOverallGadgetMetrics,
        onAboveTheFoldGadgetsRender: onAboveTheFoldGadgetsRender,
        resetScrollStartMetrics: resetScrollStartMetrics,
        sendDebuggingAnalytics: sendDebuggingAnalytics
    };
};

});
parcelRegister("iAWa3", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $8ad29d98765af503$export$dc4c3408669b8f4e);

var $x9xyg = parcelRequire("x9xyg");

const $8ad29d98765af503$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
        (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});

parcelRegister("7cLxq", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureFlags", () => $9b049cc4dacaaa3a$export$5f260d38da0c0462);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
// IMPORTANT - endeavour dashboard flags should match schema, this is primarily for other teams FFs
const $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS = [];
const $9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $9b049cc4dacaaa3a$export$5f260d38da0c0462 = (0, $8QpSo.default)(()=>{
    // at time of writing getFeatureFlags() will throw for badly formed feature flag JSON
    try {
        const allFFs = (0, $y7eb2.default)() || {};
        return Object.fromEntries(Object.keys(allFFs).filter((key)=>$9b049cc4dacaaa3a$var$DASHBOARD_FEATURE_FLAG_SCHEMA.test(key) || $9b049cc4dacaaa3a$var$DASHBOARD_ADDITIONAL_FLAGS.includes(key)).sort((a, b)=>a.localeCompare(b, undefined, {
                ignorePunctuation: true
            })).map((key)=>[
                key,
                allFFs[key].value
            ]));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});

});

parcelRegister("8UDz8", function(module, exports) {

$parcel$export(module.exports, "getDashboardFeatureGates", () => $0c1208fe9722c23a$export$7cf9f66e85966b7);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $0c1208fe9722c23a$export$7cf9f66e85966b7 = (0, $8QpSo.default)(()=>({
        endeavour_nin_assigned_to_me_gadget: (0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget'),
        endeavour_nin_issues_in_progress_gadget: (0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget'),
        endeavour_nin_filter_results_gadget: (0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
        endeavour_nin_watched_issues_gadget: (0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget'),
        endeavour_nin_voted_issues_gadget: (0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget'),
        endeavour_gadget_deprecation_banner_v1: (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1'),
        endeavour_activity_streams_survey_banner: (0, $4R6GH.fg)('endeavour_activity_streams_survey_banner'),
        endeavour_platform_dashboard_banner: (0, $4R6GH.fg)('endeavour_platform_dashboard_banner'),
        endeavour_gadget_deprecation_remove_functionality: (0, $4R6GH.fg)('endeavour_gadget_deprecation_remove_functionality')
    }));

});

parcelRegister("trHKK", function(module, exports) {

$parcel$export(module.exports, "gadgetLoad", () => $b46e477904ae8756$export$4de73f6aec94634c);
$parcel$export(module.exports, "dashboardLoad", () => $b46e477904ae8756$export$2b2c4cbb9844d8cb);

var $dGrdR = parcelRequire("dGrdR");
const $b46e477904ae8756$export$4de73f6aec94634c = (0, $dGrdR.metrics).concurrent.custom({
    key: 'dashboard.gadget',
    featureFlags: []
});
const $b46e477904ae8756$export$2b2c4cbb9844d8cb = (0, $dGrdR.metrics).pageLoad({
    key: 'dashboard',
    featureFlags: []
});

});

parcelRegister("hmyfM", function(module, exports) {

$parcel$export(module.exports, "useDashboardScrollAnalytics", () => $03a594e6b9b8c3c6$export$83af525d5e7538fa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eNjJm = parcelRequire("eNjJm");

var $bVDE5 = parcelRequire("bVDE5");
const $03a594e6b9b8c3c6$export$83af525d5e7538fa = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const currentPage = (0, $eNjJm.useCurrentPage)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { startTime: startTime } = currentPage;
    const scrollStartTimestamp = (0, $5uXOq.useRef)(null);
    const debounceSendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((_scrollStartTimestamp)=>{
        if (scrollStartTimestamp.current != null) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const percentageOfPageScrolled = window.scrollY / window.innerHeight;
        if (percentageOfPageScrolled < 0.2) return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'scrolled',
            actionSubject: 'page'
        }), 'dashboardScroll', {
            isInitialRender: isInitialRender,
            scrollStartTimeFromPageLoad: _scrollStartTimestamp - startTime,
            percentageOfPageScrolled: percentageOfPageScrolled,
            currentPageId: currentPageId
        });
        scrollStartTimestamp.current = _scrollStartTimestamp;
    }, 500);
    (0, $5uXOq.useEffect)(()=>{
        const fireScrollAnalytics = ()=>{
            debounceSendAnalytics(Date.now());
        };
        const resetScrollPosition = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.scrollTo(0, 0);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('scroll', fireScrollAnalytics);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('unload', resetScrollPosition);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('scroll', fireScrollAnalytics);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('unload', resetScrollPosition);
        };
    }, [
        debounceSendAnalytics
    ]);
    const resetScrollStartTime = (0, $5uXOq.useCallback)(()=>{
        scrollStartTimestamp.current = null;
    }, []);
    return {
        scrollStartTimestamp: scrollStartTimestamp,
        resetScrollStartTime: resetScrollStartTime
    };
};

});
parcelRegister("eNjJm", function(module, exports) {

$parcel$export(module.exports, "useCurrentPage", () => $a69ad6f74a66de9c$export$6faff8ed5e305ed3);

var $3sQ5x = parcelRequire("3sQ5x");

var $7w9eZ = parcelRequire("7w9eZ");
const $a69ad6f74a66de9c$var$useSweetStateCurrentPage = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: (state)=>state.currentPage
});
const $a69ad6f74a66de9c$export$6faff8ed5e305ed3 = ()=>{
    const [currentPage] = $a69ad6f74a66de9c$var$useSweetStateCurrentPage();
    return currentPage;
};

});



parcelRegister("gW6vr", function(module, exports) {

$parcel$export(module.exports, "GADGETS_TO_REPORT", () => $a70b755fbe2a81b5$export$2c28b0760818db72);
$parcel$export(module.exports, "GADGETS_IGNORED", () => $a70b755fbe2a81b5$export$c1d730ac3dcf5785);
// A list of gadgets (gadgetType) should contribute to the overall dashboard TTI.
// Some gadgets not in this list may not send metrics event to the dashboard and potentially hold up the dashboard
// metrics until 60 second timeout.
const $a70b755fbe2a81b5$export$2c28b0760818db72 = new Set([
    // WRM gadgets
    'jira-dashboard-items/assigned-to-me',
    'jira-dashboard-items/bubble-chart-dashboard-item',
    'jira-dashboard-items/createdvsresolved',
    'jira-dashboard-items/favourite-filters',
    'jira-dashboard-items/filter-results',
    'jira-dashboard-items/in-progress',
    'jira-dashboard-items/labels',
    'jira-dashboard-items/piechart',
    'jira-dashboard-items/stats',
    'jira-dashboard-items/two-dimensional-stats',
    'jira-dashboard-items/voted',
    'jira-dashboard-items/watched',
    'jira-dashboard-items/issuescalendar',
    'jira-dashboard-items/projects',
    'jira-dashboard-items/activitystream',
    'jira-dashboard-items/recently-created',
    'jira-dashboard-items/workload-pie-chart',
    'jira-dashboard-items/roadmap',
    'jira-dashboard-items/average-age-chart',
    'jira-dashboard-items/average-time-in-status-chart',
    'jira-dashboard-items/average-number-of-times-in-status-chart',
    'jira-dashboard-items/heat-map',
    'jira-dashboard-items/time-to-first-response',
    'jira-dashboard-items/sprint-burndown',
    'jira-dashboard-items/resolution-time',
    'jira-dashboard-items/timesince',
    'jira-dashboard-items/spacer',
    'jira-dashboard-items/rapid-view',
    'jira-dashboard-items/version-report',
    // simple iframe gadgets
    'rest/gadgets/1.0/g/com.atlassian.bonfire.plugin:bonfire-test-sessions-gadget/gadget/bonfire-sessions-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.calendar:issuescalendar-gadget/templates/plugins/jira/portlets/calendar/gadget/calendar-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:firstresponse-gadget/com/atlassian/jira/ext/charting/gadget/firstresponse-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:numberoftimesinstatus-gadget/com/atlassian/jira/ext/charting/gadget/numberoftimesinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:timeinstatus-gadget/com/atlassian/jira/ext/charting/gadget/timeinstatus-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.ext.charting:workloadpie-gadget/com/atlassian/jira/ext/charting/gadget/workloadpie-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:average-age-chart-gadget/gadgets/average-age-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:recently-created-chart-gadget/gadgets/recently-created-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:resolution-time-gadget/gadgets/resolution-time-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:time-since-chart-gadget/gadgets/timesince-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:crucible-charting-gadget/gadgets/crucible-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-charting-gadget/gadgets/fisheye-charting-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirafisheyeplugin:fisheye-recent-commits-gadget/gadgets/fisheye-recent-commits-gadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.jirawallboard.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml',
    'rest/gadgets/1.0/g/com.atlassian.streams.streams-jira-plugin:activitystream-gadget/gadgets/activitystream-gadget.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-rapid-view/gadgets/greenhopper-rapid-view.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-sprint-burndown/gadgets/greenhopper-sprint-burndown.xml',
    'rest/gadgets/1.0/g/com.pyxis.greenhopper.jira:greenhopper-gadget-version-report/gadgets/greenhopper-version-report.xml'
]);
const $a70b755fbe2a81b5$export$c1d730ac3dcf5785 = new Set([
    'jira-dashboard-items/sprint-days-remaining',
    'jira-dashboard-items/sprint-health',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item'
]);

});


parcelRegister("h5Jym", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $80ca19e1fa573e80$export$ea2491906b753456);

var $5uXOq = parcelRequire("5uXOq");

var $x9xyg = parcelRequire("x9xyg");

var $JIPqS = parcelRequire("JIPqS");

var $gh1hi = parcelRequire("gh1hi");

var $4oDnX = parcelRequire("4oDnX");

var $i0rkS = parcelRequire("i0rkS");
const $80ca19e1fa573e80$var$isAmdGadget = (gadget)=>gadget.amdModule != null && gadget.amdModule !== (0, $JIPqS.CONNECT_ITEM_AMD_MODULE);
const $80ca19e1fa573e80$var$isWaitableGadget = (gadget)=>$80ca19e1fa573e80$var$isAmdGadget(gadget);
const $80ca19e1fa573e80$var$getWaitableGadgetSet = (gadgets)=>new Set(gadgets.filter($80ca19e1fa573e80$var$isWaitableGadget).map(({ id: id })=>id));
const $80ca19e1fa573e80$export$ea2491906b753456 = ()=>{
    const { data: data, loading: loading } = (0, $gh1hi.useDashboardResource)();
    const [, { registerListener: registerListener, unregisterListener: unregisterListener }] = (0, $i0rkS.useMessageBus)();
    const lastDashboardId = (0, $5uXOq.useRef)();
    const pendingGadgetSet = (0, $5uXOq.useRef)(new Set());
    const [, { setAppReady: setAppReady }] = (0, $4oDnX.useSpaStateActions)();
    const callback = (0, $5uXOq.useCallback)((type, _, { gadgetId: gadgetId })=>{
        if (type !== (0, $JIPqS.GADGET_METRICS_TYPE).REPORT) return;
        if (!pendingGadgetSet.current.has(gadgetId)) return;
        pendingGadgetSet.current.delete(gadgetId);
        if (pendingGadgetSet.current.size > 0) return;
        unregisterListener(callback);
        (0, $x9xyg.setMark)((0, $JIPqS.PAGE_READY_METRIC_KEY));
        setAppReady();
    }, [
        setAppReady,
        unregisterListener
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (loading || data == null || data.id === lastDashboardId.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        lastDashboardId.current = data.id;
        pendingGadgetSet.current = $80ca19e1fa573e80$var$getWaitableGadgetSet(data.gadgets);
        if (pendingGadgetSet.current.size === 0) {
            (0, $x9xyg.setMark)((0, $JIPqS.PAGE_READY_METRIC_KEY));
            setAppReady();
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        registerListener(callback);
        return ()=>{
            unregisterListener(callback);
        };
    }, [
        callback,
        data,
        loading,
        registerListener,
        setAppReady,
        unregisterListener
    ]);
};

});

parcelRegister("5jJ3W", function(module, exports) {

$parcel$export(module.exports, "addDashboardToRecents", () => $f6e4dfdb0385e67e$export$9f034829a82f8a11);
const $f6e4dfdb0385e67e$export$9f034829a82f8a11 = (dashboardId)=>fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
        method: 'POST'
    });

});

parcelRegister("8CCTB", function(module, exports) {

$parcel$export(module.exports, "getErrorCode", () => $f10972789d3e7859$export$ab5c47d1a2f2c859);
const $f10972789d3e7859$export$ab5c47d1a2f2c859 = (error)=>{
    if (error && typeof error.message === 'string') return Number(error?.message?.substring(error.message.length - 3));
    return null;
};

});

parcelRegister("1Bx5m", function(module, exports) {

$parcel$export(module.exports, "AboveTheFoldContainer", () => $c6a764536e1ff0c0$export$60c1d52f3e30a1cd);

var $5uXOq = parcelRequire("5uXOq");

var $8UPoO = parcelRequire("8UPoO");

var $1oaeD = parcelRequire("1oaeD");

var $6fab6 = parcelRequire("6fab6");
const $c6a764536e1ff0c0$export$60c1d52f3e30a1cd = ({ gadgets: gadgets, dashboardId: dashboardId, layout: layout, children: children })=>{
    const { getMaximisedGadgetId: getMaximisedGadgetId } = (0, $1oaeD.useMaximizedGadget)(gadgets);
    const columns = (0, $5uXOq.useMemo)(()=>(0, $6fab6.toColumns)(gadgets, layout), [
        gadgets,
        layout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UPoO.RenderAboveTheFoldContainer), {
        columns: columns,
        dashboardId: dashboardId,
        scope: dashboardId,
        maximizedGadgetId: getMaximisedGadgetId
    }, children);
};

});

parcelRegister("7v0Ei", function(module, exports) {

$parcel$export(module.exports, "AmdGadgetMonolithOverrideStyles", () => $c5037e48649c048f$export$17921465e6f60e58);

var $5uXOq = parcelRequire("5uXOq");
const $c5037e48649c048f$var$styles = `.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #172B4D)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #172B4D)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #091E420F)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #44546F)"};
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: ${"var(--ds-font-weight-semibold, 600)"};
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #0C66E4)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $c5037e48649c048f$export$17921465e6f60e58 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", null, $c5037e48649c048f$var$styles);

});

parcelRegister("fxC6K", function(module, exports) {

$parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST_OLD", () => $525e26e500bd2620$export$c7a31c767972da3f);
$parcel$export(module.exports, "DASHBOARD_PERMISSION_ERROR_CODE_LIST_NEW", () => $525e26e500bd2620$export$4bc19e43c0adcefb);
// NOTE: Avoid modifying code `401` as this is used by wallboard and permission error pages (search DASHBOARD_PERMISSION_ERROR_CODE_LIST for usages).
// Wallboard does not reference this list directly because there are import issues, so it uses `401` as a string.
const $525e26e500bd2620$export$c7a31c767972da3f = [
    401,
    403,
    404
];
const $525e26e500bd2620$export$4bc19e43c0adcefb = [
    401,
    403,
    404,
    429
];

});

parcelRegister("kUwqK", function(module, exports) {

$parcel$export(module.exports, "usePageStatusLogger", () => $994ab79b91cbaa2e$export$8b3b053e4f10e669);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");


var $bVDE5 = parcelRequire("bVDE5");

var $bOnpg = parcelRequire("bOnpg");

var $7cLxq = parcelRequire("7cLxq");
const $994ab79b91cbaa2e$var$TEN_MIN = 600000;
// We need to replace '.' in FF keys with '_' to match BM3 and avoid confusion in Splunk
const $994ab79b91cbaa2e$var$sanitiseKeys = (featureFlags)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(featureFlags || {}).map(([key, value])=>[
            key.replace(/\./g, '_'),
            value
        ]));
const $994ab79b91cbaa2e$export$8b3b053e4f10e669 = (interval)=>{
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const [{ isInitialRender: isInitialRender, currentPageId: currentPageId, lastTransition: lastTransition }] = (0, $bVDE5.useSpaStateTransition)();
    (0, $5uXOq.useEffect)(()=>{
        const logFeatureFlags = ()=>{
            const featureFlags = JSON.stringify($994ab79b91cbaa2e$var$sanitiseKeys((0, $7cLxq.getDashboardFeatureFlags)()));
            const attributes = {
                isInitialRender: isInitialRender,
                lastTransition: lastTransition,
                currentPageId: currentPageId,
                featureFlags: featureFlags
            };
            (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.page-status', Object.entries(attributes) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([k, v])=>`${k} [${String(v ?? null)}]`).join(' '));
            fireAnalytics({
                eventType: (0, $4d5e0871c06cee03$export$12346a674644c156),
                actionSubject: 'dashboard.page-status',
                actionSubjectId: 'featureFlags',
                action: 'logged',
                attributes: attributes
            });
        };
        logFeatureFlags();
        const logInterval = setInterval(logFeatureFlags, Math.max($994ab79b91cbaa2e$var$TEN_MIN, interval) || $994ab79b91cbaa2e$var$TEN_MIN);
        return ()=>clearInterval(logInterval);
    }, [
        interval,
        fireAnalytics,
        isInitialRender,
        currentPageId,
        lastTransition
    ]);
};

});

parcelRegister("hwuTz", function(module, exports) {

$parcel$export(module.exports, "RouteResourceValidator", () => $79eff52e66ba4eb8$export$1d8835c03b47dfbd);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");
const $79eff52e66ba4eb8$export$1d8835c03b47dfbd = ()=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const { promise: promise, loading: loading, data: data, error: error } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const [hasRendered, setHasRendered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading) setHasRendered(true);
    }, [
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        const prefix = `Resource validation [${isInitialRender ? 'initial' : 'transition'}][${hasRendered ? 'rerender' : 'original'}]`;
        if (!promise) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource may be missing`);
        else if (loading) (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} loading`);
        else if (data) {
            const { amdModules: amdModules, sharedValue: sharedValue } = data;
            if (sharedValue == null || sharedValue instanceof Error) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD resource shared value [${String(sharedValue)}]`);
            else if (!sharedValue?.isPreloaded && isInitialRender && !hasRendered) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, config+wrm resource did not run in SSR`);
            else if (amdModules === null) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, WRM resources failed to load`);
            else {
                const [failedCount, totalCount] = Object.values(amdModules).reduce(([f], v, i, arr)=>[
                        f + (v == null ? 1 : 0),
                        arr.length
                    ], [
                    0,
                    0
                ]);
                if (failedCount > 0) {
                    const failedNames = Object.entries(amdModules).filter(([, v])=>v == null).map(([k])=>k).join(',');
                    (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed, AMD evaluation failed [${failedCount}] of [${totalCount}], failed modules [${failedNames}]`);
                } else (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} success`);
            }
        } else if (error) (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.route-resource-validate', `${prefix} failed with AMD resource error [${error instanceof Error ? error.message : String(error)}]`, error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promise,
        loading,
        data,
        error
    ]);
    return null;
};

});


parcelRegister("h7J1E", function(module, exports) {

$parcel$export(module.exports, "useGadgetTitle", () => $9f983f20098b68ef$export$dba832fc7432cba1);
$parcel$export(module.exports, "useConnectGadgetTitles", () => $9f983f20098b68ef$export$66e677fcbdac9c95);

var $5uXOq = parcelRequire("5uXOq");
function $9f983f20098b68ef$export$dba832fc7432cba1({ defaultTitle: initialDefaultTitle, title: title, onSave: onSave }) {
    const [defaultTitle, setDefaultTitle] = (0, $5uXOq.useState)(initialDefaultTitle);
    const [userTitle, setUserTitle] = (0, $5uXOq.useState)(title);
    const setTitle = (0, $5uXOq.useCallback)(async (newTitle)=>{
        const previousTitle = userTitle;
        setUserTitle(newTitle);
        onSave?.(newTitle).catch(()=>{
            setUserTitle(previousTitle);
        });
    }, [
        userTitle,
        onSave
    ]);
    const setDefaultTitleWithInitialTitle = (0, $5uXOq.useCallback)((defaultTitleUpdaterOrValue)=>{
        setDefaultTitle(typeof defaultTitleUpdaterOrValue === 'function' ? defaultTitleUpdaterOrValue(initialDefaultTitle) : defaultTitleUpdaterOrValue);
    }, [
        initialDefaultTitle
    ]);
    return {
        title: userTitle || defaultTitle,
        setDefaultTitle: setDefaultTitleWithInitialTitle,
        setTitle: setTitle
    };
}
const $9f983f20098b68ef$export$66e677fcbdac9c95 = ()=>{
    const [connectGadgets, setConnectGadgets] = (0, $5uXOq.useState)({});
    const registerConnectGadget = (0, $5uXOq.useCallback)((id, setTitle)=>{
        setConnectGadgets((gadgets)=>({
                ...gadgets,
                [id]: setTitle
            }));
    }, []);
    const unregisterConnectGadget = (0, $5uXOq.useCallback)((id)=>{
        setConnectGadgets((gadgets)=>{
            const { [id]: _, ...rest } = gadgets;
            return rest;
        });
    }, []);
    const setCustomTitle = (0, $5uXOq.useCallback)((id, title)=>{
        const setTitle = connectGadgets[id];
        if (!setTitle) throw new Error(`Unable to set custom title on Connect gadget. No gadget with id ${id} found. Available ids: ${Object.keys(connectGadgets).join(', ')}`);
        return setTitle(title);
    }, [
        connectGadgets
    ]);
    return {
        registerConnectGadget: registerConnectGadget,
        setCustomTitle: setCustomTitle,
        unregisterConnectGadget: unregisterConnectGadget
    };
};

});

parcelRegister("52i38", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb8d5d132a6208ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $eb8d5d132a6208ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "dashboard-view.page-title",
        "defaultMessage": "Dashboard"
    }
});

});

parcelRegister("fPA7s", function(module, exports) {

$parcel$export(module.exports, "EmptyDashboardPlaceholder", () => $a47d68a6c07cc5b5$export$8f129bf59f671c93);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kNt2r = parcelRequire("kNt2r");

var $erLBt = parcelRequire("erLBt");

var $koVbs = parcelRequire("koVbs");

var $iht5S = parcelRequire("iht5S");
const $a47d68a6c07cc5b5$var$TOOLBOX_ILLUSTRATION_SIZE = '256px';
const $a47d68a6c07cc5b5$export$8f129bf59f671c93 = ({ hasEditPermissions: hasEditPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kNt2r.EmptyDashboardPlaceholderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kNt2r.EmptyDashboardPlaceholderContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a47d68a6c07cc5b5$var$boxStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $erLBt.default), {
        alt: "",
        "data-testId": "empty-dashboard-img-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $iht5S.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kNt2r.EmptyDashboardPlaceholderText), null, hasEditPermissions ? formatMessage((0, $iht5S.default).clickEditButton) : formatMessage((0, $iht5S.default).noPermissions))));
};
const $a47d68a6c07cc5b5$var$boxStyle = (0, $8CUq3.xcss)({
    width: $a47d68a6c07cc5b5$var$TOOLBOX_ILLUSTRATION_SIZE,
    height: $a47d68a6c07cc5b5$var$TOOLBOX_ILLUSTRATION_SIZE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("kNt2r", function(module, exports) {

$parcel$export(module.exports, "EmptyDashboardPlaceholderContainer", () => $b08803d657ecb6fa$export$6186d9ab34f7c892);
$parcel$export(module.exports, "EmptyDashboardPlaceholderContentContainer", () => $b08803d657ecb6fa$export$6d5d2ac6e84d3c53);
$parcel$export(module.exports, "EmptyDashboardPlaceholderText", () => $b08803d657ecb6fa$export$b65f3ce3834a21ea);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $44v1T = parcelRequire("44v1T");
const $b08803d657ecb6fa$export$6186d9ab34f7c892 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3inb68",
            __cmplp.className
        ])
    });
});
const $b08803d657ecb6fa$export$6d5d2ac6e84d3c53 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1kvu _p12f1vuk _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b08803d657ecb6fa$export$b65f3ce3834a21ea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qpxbi _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("erLBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbf00366986f0f4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = gptx74kc87fs3brp2t4k9nhr
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/gptx74kc87fs3brp2t4k9nhr

var $dCLgq = parcelRequire("dCLgq");

var $8EX0V = parcelRequire("8EX0V");
const $bbbf00366986f0f4$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8EX0V)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8EX0V))
});
var $bbbf00366986f0f4$export$2e2bcd8739ae039 = $bbbf00366986f0f4$var$Illustration;
// for advanced use only
const $bbbf00366986f0f4$export$a179c88182cb9d56 = [
    0,
    0,
    241,
    189
];

});
parcelRegister("8EX0V", function(module, exports) {
module.exports = new URL("toolbox.b560c410.svg", import.meta.url).toString();

});


parcelRegister("iht5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e18658aa66f7fde$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7e18658aa66f7fde$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "dashboard-view.empty-dashboard-placeholder.header",
        "defaultMessage": "This dashboard is empty"
    },
    clickEditButton: {
        "id": "dashboard-view.empty-dashboard-placeholder.click-edit-button",
        "defaultMessage": "You can add to this dashboard by clicking the \u2018Edit\u2019 button on the top right corner."
    },
    noPermissions: {
        "id": "dashboard-view.empty-dashboard-placeholder.no-permissions",
        "defaultMessage": "You don't have permissions to add to this dashboard. You may want to create your own dashboard instead, by selecting Dashboards > Create Dashboard in the top navigation bar."
    }
});

});


parcelRegister("cOK0t", function(module, exports) {

$parcel$export(module.exports, "GadgetReadOnly", () => $acfbb20e5a1435f8$export$4bbe38d7c1a57cd0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $JIPqS = parcelRequire("JIPqS");

var $5T44u = parcelRequire("5T44u");

var $eXVsp = parcelRequire("eXVsp");

var $b3IiT = parcelRequire("b3IiT");

var $bOnpg = parcelRequire("bOnpg");

var $6Nisr = parcelRequire("6Nisr");

var $8FVKN = parcelRequire("8FVKN");

var $lwPtc = parcelRequire("lwPtc");

var $4ozF0 = parcelRequire("4ozF0");

var $j3C3s = parcelRequire("j3C3s");

var $gFWXX = parcelRequire("gFWXX");

var $1yhBH = parcelRequire("1yhBH");

var $iIi7d = parcelRequire("iIi7d");

var $cmgca = parcelRequire("cmgca");

var $4R6GH = parcelRequire("4R6GH");

const $acfbb20e5a1435f8$var$noop = ()=>undefined;
const $acfbb20e5a1435f8$export$4bbe38d7c1a57cd0 = ({ dashboardId: dashboardId, data: data, display: display, unconfiguredFallback: unconfiguredFallback, refreshId: refreshId, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget, onMaximizeOrRestore: onMaximizeOrRestore })=>{
    const { id: id, isMaximizable: isMaximizable, titleUrl: titleUrl, forge: forge } = data;
    const isFirstPartyGadget = !(0, $cmgca.isConnectGadget)(data) && !forge;
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const onCopyLinkHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.copy-link-button',
            actionSubjectId: 'gadget'
        });
    }, [
        fireAnalytics
    ]);
    const isDeprecated = (0, $b3IiT.checkGadgetType)((0, $JIPqS.DEPRECATED_GADGETS_MAP), data.amdModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Nisr.GadgetReadOnlyController), {
        data: data,
        display: display,
        dashboardRefreshId: refreshId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FVKN.GadgetControllerContextConsumer), null, ({ isDisplayed: isDisplayed, isMaximized: isMaximized, isMinimized: isMinimized, onMinimizeOrRestore: onMinimizeOrRestore, shouldUseCache: shouldUseCache, isLoading: isLoading, setIsLoading: setIsLoading, lastRefreshed: lastRefreshed, isUnconfigured: isUnconfigured, title: title, setDefaultTitle: setDefaultTitle, onRenameSave: onRenameSave })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ozF0.GadgetLayoutWithAnalytics), {
            gadgetData: data,
            isDisplayed: isDisplayed,
            isContentHidden: isMinimized,
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j3C3s.GadgetTitleWrapper), {
                id: `gadget-title-${id}`
            }, isDeprecated && (0, $4R6GH.fg)('endeavour_gadget_deprecation_banner_v1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $acfbb20e5a1435f8$var$titleStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFWXX.TitleReadOnly), {
                title: title,
                titleUrl: titleUrl,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXVsp.DeprecationTooltip), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFWXX.TitleReadOnly), {
                title: title,
                titleUrl: titleUrl,
                forgeEnvironment: forge?.environment,
                forgeEnvironmentKey: forge?.environmentKey
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yhBH.GadgetToolbar), {
                gadgetId: id,
                title: title,
                onMinimizeOrRestore: onMinimizeOrRestore,
                isMinimized: isMinimized,
                isMaximizable: isMaximizable,
                onMaximizeOrRestore: onMaximizeOrRestore,
                isMaximized: isMaximized,
                additionalToolbarItems: isMaximizable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5T44u.CopyLinkButton), {
                    dashboardId: dashboardId,
                    gadgetId: id,
                    onCopyClick: onCopyLinkHandler
                })
            })),
            footer: isFirstPartyGadget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iIi7d.LastRefreshed), {
                lastRefreshed: lastRefreshed,
                updateInterval: (0, $JIPqS.REFRESH_LABEL_UPDATE_INTERVAL)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "dashboard-view.ui.gadget-readonly.gadget-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwPtc.GadgetInner), {
            dashboardId: dashboardId,
            data: data,
            isUnconfigured: isUnconfigured,
            isEditModeEnabled: false,
            isLoading: isLoading,
            isInEditMode: false,
            shouldUseCache: shouldUseCache,
            setIsLoading: setIsLoading,
            setDefaultTitle: setDefaultTitle,
            onEditModeCancel: $acfbb20e5a1435f8$var$noop,
            isMaximized: isMaximized,
            unconfiguredFallback: unconfiguredFallback,
            onRegisterConnectGadget: onRegisterConnectGadget,
            onUnregisterConnectGadget: onUnregisterConnectGadget,
            setTitle: onRenameSave
        })))));
};
const $acfbb20e5a1435f8$var$titleStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row'
});

});
parcelRegister("5T44u", function(module, exports) {

$parcel$export(module.exports, "CopyLinkButton", () => $b0246b66f763c5eb$export$534d10f1c5b9c7b3);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $jOyH3 = parcelRequire("jOyH3");

var $b6nbP = parcelRequire("b6nbP");

var $koVbs = parcelRequire("koVbs");

var $JIPqS = parcelRequire("JIPqS");

var $g15xx = parcelRequire("g15xx");
const $b0246b66f763c5eb$export$534d10f1c5b9c7b3 = ({ dashboardId: dashboardId, gadgetId: gadgetId, onCopyClick: onCopyClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
    if (false) return;
    const label = formatMessage((0, $g15xx.default).copyTextLabel);
    const tooltip = isCopied ? formatMessage((0, $g15xx.default).copiedLabel) : label;
    const id = gadgetId ? `${dashboardId}-${gadgetId}` : dashboardId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { protocol: protocol, host: host, pathname: pathname } = window.location;
    const url = gadgetId ? `${protocol}//${host}${pathname}?${0, $JIPqS.MAXIMIZED_PARAM}=${gadgetId}` : `${protocol}//${host}${pathname}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6nbP.default), {
        id: id,
        label: label,
        shouldFitContainer: true,
        tooltipDelay: 0,
        tooltipLabel: tooltip,
        tooltipLabelPosition: "bottom",
        value: url,
        hideFieldText: true,
        onCopyClick: onCopyClick,
        onClickChange: (status)=>setIsCopied(status),
        onCopyReset: ()=>setIsCopied(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        "aria-label": label,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            spacing: "spacious",
            label: label
        })
    }));
};

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ba5c183c8a258f8be0ef328c0a8b726>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a87d743bb5f5b238079f9e871192b6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("b6nbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75a19e3ebf5c6c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7EEmi = parcelRequire("7EEmi");
class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ariaDescribedBy: ariaDescribedBy } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EEmi.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled,
            ariaDescribedBy: ariaDescribedBy
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            copied: false,
            copyFailed: false
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        }, this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("7EEmi", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $4e1842edd397110a$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $4e1842edd397110a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3Fq5M = parcelRequire("3Fq5M");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $fVAPR = parcelRequire("fVAPR");

var $az4zD = parcelRequire("az4zD");


var $gT8ZY = parcelRequire("gT8ZY");

var $9iXoh = parcelRequire("9iXoh");
class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
            onClick: onCopyClick,
            "aria-label": tooltipLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            label: ""
        }));
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined,
            "aria-describedby": props.ariaDescribedBy
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel)
        }, copyButton || this.renderDefaultButton())));
    }
}
var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        ...props,
        xcss: $4e1842edd397110a$var$pressableStyles
    });
$4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$FlexGrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $4e1842edd397110a$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '40px',
    width: '40px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    ':active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
});

});
parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41sbm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41sbm"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("gT8ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb069c8c90804ba8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("9iXoh", function(module, exports) {

$parcel$export(module.exports, "Root", () => $d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        userSelect: 'none'
    }) : '');
const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});



parcelRegister("g15xx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac14ce1c250287f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac14ce1c250287f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyTextLabel: {
        "id": "dashboard-view.copy-link-button.copy-link",
        "defaultMessage": "Copy link"
    },
    copiedLabel: {
        "id": "dashboard-view.copy-link-button.copied",
        "defaultMessage": "Copied!"
    }
});

});


parcelRegister("eXVsp", function(module, exports) {

$parcel$export(module.exports, "DeprecationTooltip", () => $a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8);

var $5uXOq = parcelRequire("5uXOq");

var $6yUsV = parcelRequire("6yUsV");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $cM8Sm = parcelRequire("cM8Sm");
const $a9bfc6bd944fc87c$export$3afd8bd60d8bcdb8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a9bfc6bd944fc87c$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        appearance: "warning"
    }, formatMessage((0, $cM8Sm.default).gadgetDeprecationTooltip, {
        Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
                href: "https://community.atlassian.com/t5/Jira-articles/Update-We-re-ending-support-for-five-dashboard-gadgets-in-May/ba-p/2844556"
            }, chunks),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null))
    })));
};
const $a9bfc6bd944fc87c$var$tooltipStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("6yUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c43b93305034f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $ctg8C = parcelRequire("ctg8C");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $60LNO = parcelRequire("60LNO");
const $e2c43b93305034f0$var$rootStyles = null;
const $e2c43b93305034f0$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $e2c43b93305034f0$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ctg8C.default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: testId && `${testId}--button`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $60LNO.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;

});
parcelRegister("60LNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $474777c4d72d6c07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jfSgx = parcelRequire("jfSgx");
const $474777c4d72d6c07$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $474777c4d72d6c07$var$iconWrapperStyles = null;
const $474777c4d72d6c07$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $jfSgx.typesMapping);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $474777c4d72d6c07$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
};
var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;

});
parcelRegister("jfSgx", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $e3da74fa628ddd87$export$4d111645c0b39d5d);

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");
const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("cM8Sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c54fb5c971a7e8c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5c54fb5c971a7e8c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    gadgetDeprecationTooltip: {
        "id": "dashboard-internal-common.common.gadget.deprecation-tooltip.gadget-deprecation-tooltip.non-final",
        "defaultMessage": "Starting May 2025, we're no longer supporting this gadget. Delete it before then to reference its data in the available alternatives.<br></br><Link>More about the gadgets and the extended timeline</Link>"
    }
});

});


parcelRegister("6Nisr", function(module, exports) {

$parcel$export(module.exports, "GadgetReadOnlyController", () => $8a6270d5e3995ead$export$ef82df624fcfbd37);

var $5uXOq = parcelRequire("5uXOq");

var $fJpBG = parcelRequire("fJpBG");

var $83NgX = parcelRequire("83NgX");

var $jATTU = parcelRequire("jATTU");

var $8FVKN = parcelRequire("8FVKN");

var $2XTsA = parcelRequire("2XTsA");

var $9TUxn = parcelRequire("9TUxn");

var $HCTtk = parcelRequire("HCTtk");
const $8a6270d5e3995ead$export$ef82df624fcfbd37 = ({ data: { id: id, userPrefs: userPrefs, reactKey: reactKey, configurable: configurable, refreshable: isRefreshableByJira, connect: connect, forge: forge, ...data }, display: display, dashboardRefreshId: dashboardRefreshId, children: children })=>{
    const localStorageService = (0, $83NgX.useLocalStorageService)(id);
    const { reinitialise: onGadgetKeyChange, isEditable: isReactEditable, isLoading: isReactLoading } = (0, $9TUxn.useReactGadget)(id, reactKey);
    const automaticRefreshMs = (0, $5uXOq.useMemo)(()=>{
        const { refresh: refresh } = (0, $fJpBG.decodeUserPreferences)(userPrefs?.fields);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return parseInt(refresh, 10) * 60000 || null;
    }, [
        userPrefs?.fields
    ]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const readonly = (0, $HCTtk.useGadgetReadOnlyController)({
        userPrefs: userPrefs,
        configurable: isReactEditable ?? configurable,
        ...data
    });
    // Ecosystem gadgets are not supposed to re-render if they are opting out refreshing
    const ignoreGlobalDashboardRefresh = Boolean(forge?.key || connect?.addonKey) && !isRefreshableByJira;
    const { onRefresh: onRefresh, ...common } = (0, $2XTsA.useGadgetCommonController)({
        id: id,
        display: display,
        automaticRefreshMs: automaticRefreshMs,
        localStorageService: localStorageService,
        dashboardRefreshId: ignoreGlobalDashboardRefresh ? null : dashboardRefreshId,
        onGadgetKeyChange: onGadgetKeyChange
    });
    const ecosystemRefresh = (0, $jATTU.useEcosystemRefresh)({
        id: id,
        connect: connect,
        forge: forge
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FVKN.GadgetControllerContextProvider), {
        value: {
            ...common,
            ...readonly,
            isRenamable: false,
            isLoading: isReactLoading ?? isLoading,
            setIsLoading: reactKey ? ()=>undefined : setIsLoading,
            onRefresh: isRefreshableByJira ? onRefresh : ecosystemRefresh.onRefresh ?? onRefresh
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ecosystemRefresh.wrapperRef
    }, children));
};

});
parcelRegister("83NgX", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageService", () => $d6a2211d9def985e$export$aae02958650bede0);

var $5uXOq = parcelRequire("5uXOq");

var $19nfo = parcelRequire("19nfo");
const $d6a2211d9def985e$export$d4655e9fae202a89 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.getGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$3bf5aef0d5c5f925 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.putGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$84a14851141ef231 = (id)=>(0, $5uXOq.useCallback)((...args)=>(0, $19nfo.deleteGadgetDataFromLocalStorage)(id, ...args), [
        id
    ]);
const $d6a2211d9def985e$export$aae02958650bede0 = (id)=>{
    const get = $d6a2211d9def985e$export$d4655e9fae202a89(id);
    const put = $d6a2211d9def985e$export$3bf5aef0d5c5f925(id);
    const del = $d6a2211d9def985e$export$84a14851141ef231(id);
    return {
        get: get,
        put: put,
        del: del
    };
};

});

parcelRegister("jATTU", function(module, exports) {

$parcel$export(module.exports, "useEcosystemRefresh", () => $dc36a798f3ea6a32$export$a96edb2d9dc3e9bf);

var $5uXOq = parcelRequire("5uXOq");

var $3v45P = parcelRequire("3v45P");

var $JIPqS = parcelRequire("JIPqS");
const $dc36a798f3ea6a32$export$1da99641cec7fdf3 = (payload, id)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.connectHost?.broadcastEvent((0, $JIPqS.CONNECT_GADGET_REFRESH_REQUEST_EVENT), {
        id: id
    }, payload);
const $dc36a798f3ea6a32$export$a96edb2d9dc3e9bf = ({ id: id, connect: connect, forge: forge })=>{
    const isConnect = Boolean(connect?.addonKey);
    const isForge = Boolean(forge?.key);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const ecosystemOnRefresh = (0, $5uXOq.useCallback)(()=>{
        const payload = {
            origin: 'gadget',
            gadgetId: id
        };
        if (isConnect) $dc36a798f3ea6a32$export$1da99641cec7fdf3(payload, wrapperRef.current?.querySelector('iframe')?.id);
        else if (isForge) (0, $3v45P.emit)((0, $JIPqS.FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT), payload);
    }, [
        id,
        isConnect,
        isForge
    ]);
    return {
        wrapperRef: wrapperRef,
        onRefresh: isConnect || isForge ? ecosystemOnRefresh : undefined
    };
};

});

parcelRegister("8FVKN", function(module, exports) {

$parcel$export(module.exports, "GadgetControllerContextProvider", () => $34f96cfa0524cd59$export$4de1bad6b03d7763);
$parcel$export(module.exports, "GadgetControllerContextConsumer", () => $34f96cfa0524cd59$export$4d4eb85e0f24da5c);
$parcel$export(module.exports, "useGadgetRefresh", () => $34f96cfa0524cd59$export$9e5c8ef16417c38e);
$parcel$export(module.exports, "useGadgetRenderKey", () => $34f96cfa0524cd59$export$b4c09774e3d2cd2d);
$parcel$export(module.exports, "useIsConnectDisabled", () => $34f96cfa0524cd59$export$2afbda65cda4cd52);
$parcel$export(module.exports, "useGadgetSetPreferences", () => $34f96cfa0524cd59$export$263d54a76be27f46);

var $jnkfq = parcelRequire("jnkfq");
const { createUseContextField: $34f96cfa0524cd59$export$56fb4dd71461f98e, Provider: $34f96cfa0524cd59$export$4de1bad6b03d7763, Consumer: $34f96cfa0524cd59$export$4d4eb85e0f24da5c } = (0, $jnkfq.createRendererContext)();
const $34f96cfa0524cd59$export$9e5c8ef16417c38e = $34f96cfa0524cd59$export$56fb4dd71461f98e('onRefresh');
const $34f96cfa0524cd59$export$b4c09774e3d2cd2d = $34f96cfa0524cd59$export$56fb4dd71461f98e('renderKey');
const $34f96cfa0524cd59$export$2afbda65cda4cd52 = $34f96cfa0524cd59$export$56fb4dd71461f98e('isConnectDisabled');
const $34f96cfa0524cd59$export$263d54a76be27f46 = $34f96cfa0524cd59$export$56fb4dd71461f98e('setPreferences');

});

parcelRegister("2XTsA", function(module, exports) {

$parcel$export(module.exports, "useGadgetCommonController", () => $369e7d9cc957d88d$export$3db154a5767b2bd0);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");
const $369e7d9cc957d88d$export$3db154a5767b2bd0 = ({ id: id, display: display, automaticRefreshMs: automaticRefreshMs, localStorageService: { get: localStorageServiceGet, put: localStorageServicePut, del: localStorageServiceDel }, dashboardRefreshId: dashboardRefreshId, onGadgetKeyChange: onGadgetKeyChange })=>{
    const isDisplayed = display !== (0, $JIPqS.GADGET_DISPLAY).HIDDEN;
    const isMaximized = display === (0, $JIPqS.GADGET_DISPLAY).MAXIMIZED;
    const [isMinimized, setIsMinimized] = (0, $5uXOq.useState)(()=>localStorageServiceGet('minimized') === 'true');
    const onMinimizeOrRestore = (0, $5uXOq.useCallback)((doMinimize)=>{
        if (doMinimize !== isMinimized) {
            if (doMinimize) localStorageServicePut('minimized', 'true');
            else localStorageServiceDel('minimized');
            setIsMinimized(doMinimize);
        }
    }, [
        isMinimized,
        setIsMinimized,
        localStorageServicePut,
        localStorageServiceDel
    ]);
    const [shouldUseCache, setShouldUseCache] = (0, $5uXOq.useState)(true);
    const [refreshId, setRefreshId] = (0, $5uXOq.useState)(Date.now());
    const renderKey = `${id}-${refreshId}-${dashboardRefreshId}-${isMaximized ? 'canvas' : 'default'}`;
    const prevRenderKey = (0, $5uXOq.useRef)(renderKey);
    const onRefresh = (0, $5uXOq.useCallback)(()=>{
        setShouldUseCache(false);
        setRefreshId(Date.now());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (automaticRefreshMs == null || automaticRefreshMs <= 0) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        // The interval is stored in a signed 32-bit int so any number above 2**31-1 would
        // become negative which will cause the callback to infinitely loop without any delay.
        // https://stackoverflow.com/a/12633556/1104483
        const refreshIntervalMs = Math.min(automaticRefreshMs, Math.pow(2, 31) - 1);
        const interval = setInterval(onRefresh, refreshIntervalMs);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        automaticRefreshMs,
        onRefresh
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (prevRenderKey.current !== renderKey) {
            prevRenderKey.current = renderKey;
            onGadgetKeyChange();
        }
    }, [
        renderKey,
        onGadgetKeyChange
    ]);
    // id is a timestamp
    const lastRefreshed = Math.max(Number(dashboardRefreshId), refreshId);
    return {
        isDisplayed: isDisplayed,
        isMaximized: isMaximized,
        isMinimized: isMinimized,
        onMinimizeOrRestore: onMinimizeOrRestore,
        renderKey: renderKey,
        shouldUseCache: shouldUseCache,
        onRefresh: onRefresh,
        lastRefreshed: lastRefreshed
    };
};

});

parcelRegister("9TUxn", function(module, exports) {

$parcel$export(module.exports, "useReactGadget", () => $f21126f6c18da11d$export$a821269bdacf74ba);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $gh1hi = parcelRequire("gh1hi");

var $iXzvf = parcelRequire("iXzvf");
const $f21126f6c18da11d$export$a821269bdacf74ba = (gadgetId, reactKey)=>{
    const { update: update, refresh: refresh, loading: loading } = (0, $gh1hi.useDashboardReactGadgetsResource)();
    const [resetId, setResetId] = (0, $5uXOq.useState)(null);
    const [namedState, setNamedState] = (0, $5uXOq.useState)('idle');
    const isReactGadget = (0, $kspzT.isReactKey)(reactKey);
    const reinitialise = (0, $5uXOq.useCallback)(()=>{
        if (namedState === 'idle') {
            // IMPORTANT - Mutations to resource while loading will be lost
            if (loading) {
                setResetId(gadgetId);
                setNamedState('update');
            } else {
                // IMPORTANT - Set null in the resource and then refresh to remove the nulls
                update((0, $iXzvf.lensReactGadget)(gadgetId, null));
                setNamedState('refresh');
            }
        }
    }, [
        gadgetId,
        loading,
        update,
        namedState
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!loading && resetId != null && namedState === 'update') {
            setResetId(null);
            // IMPORTANT - Set null in the resource and then refresh to remove the nulls
            update((0, $iXzvf.lensReactGadget)(resetId, null));
            setNamedState('refresh');
        }
    }, [
        loading,
        update,
        resetId,
        namedState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // IMPORTANT - We need to arrive here asynchronously in case multiple gadgets are reset at once
        if (namedState === 'refresh') {
            setNamedState('loading');
            refresh();
        }
    }, [
        refresh,
        namedState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && namedState === 'loading') setNamedState('idle');
    }, [
        loading,
        namedState
    ]);
    if (!isReactGadget) return {
        reinitialise: ()=>undefined,
        isEditable: null,
        isLoading: null
    };
    const { componentEdit: componentEdit } = (0, $kspzT.default)[reactKey];
    return {
        reinitialise: reinitialise,
        isEditable: Boolean(componentEdit),
        isLoading: namedState === 'loading' || loading && namedState === 'idle'
    };
};

});
parcelRegister("iXzvf", function(module, exports) {

$parcel$export(module.exports, "lensReactGadget", () => $18ff57dda50a1c7b$export$703ae6d6d75e47f1);
const $18ff57dda50a1c7b$export$bada82ca295a26d5 = (updateGadgets)=>(resource)=>resource && {
            ...resource,
            reactGadgetsState: updateGadgets(resource.reactGadgetsState)
        };
const $18ff57dda50a1c7b$export$703ae6d6d75e47f1 = (id, setterOrValue)=>{
    const setter = typeof setterOrValue === 'function' ? setterOrValue : ()=>setterOrValue;
    return $18ff57dda50a1c7b$export$bada82ca295a26d5((reactGadgetsState)=>{
        if (!reactGadgetsState || !(id in reactGadgetsState)) return reactGadgetsState;
        const prevStateOrError = reactGadgetsState[id];
        const newState = setter(prevStateOrError);
        const prevState = prevStateOrError === null || prevStateOrError instanceof Error ? {} : prevStateOrError;
        return {
            ...reactGadgetsState,
            [id]: newState === null ? null : {
                ...prevState,
                ...newState
            }
        };
    });
};

});


parcelRegister("HCTtk", function(module, exports) {

$parcel$export(module.exports, "useGadgetReadOnlyController", () => $b218980b25edb990$export$8c1c073a838c204c);

var $8Rkzz = parcelRequire("8Rkzz");

var $h7J1E = parcelRequire("h7J1E");

var $l7m8v = parcelRequire("l7m8v");
const $b218980b25edb990$export$8c1c073a838c204c = ({ customisedTitle: customisedTitle, title: defaultTitle, configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const { isUnconfigured: isUnconfigured } = (0, $l7m8v.useConfigurationStatus)({
        configurable: configurable,
        hasNonHiddenUserPrefs: hasNonHiddenUserPrefs,
        renderedGadgetUrl: renderedGadgetUrl,
        userPrefs: userPrefs
    });
    const { title: title, setDefaultTitle: setDefaultTitle, setTitle: setTitle } = (0, $h7J1E.useGadgetTitle)({
        defaultTitle: defaultTitle,
        title: customisedTitle
    });
    return {
        isUnconfigured: isUnconfigured,
        isEditModeEnabled: false,
        isEditButtonDisabled: true,
        isInEditMode: false,
        isConnectDisabled: false,
        onEditModeTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditModeCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        title: title,
        isRenaming: false,
        setDefaultTitle: setDefaultTitle,
        onRenameTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onRenameSave: setTitle,
        onRenameCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setPreferences: ()=>null
    };
};

});
parcelRegister("l7m8v", function(module, exports) {

$parcel$export(module.exports, "useConfigurationStatus", () => $93e0d1b0527a2ad8$export$416bc2c29f65a3f8);

var $5uXOq = parcelRequire("5uXOq");

var $5IKQ6 = parcelRequire("5IKQ6");
const $93e0d1b0527a2ad8$export$416bc2c29f65a3f8 = ({ configurable: configurable, hasNonHiddenUserPrefs: hasNonHiddenUserPrefs, renderedGadgetUrl: renderedGadgetUrl, userPrefs: userPrefs })=>{
    const isConfigurable = Boolean(configurable || hasNonHiddenUserPrefs || renderedGadgetUrl);
    const isUnconfigured = (0, $5uXOq.useMemo)(()=>isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(userPrefs), [
        isConfigurable,
        userPrefs
    ]);
    return {
        isConfigurable: isConfigurable,
        isUnconfigured: isUnconfigured
    };
};

});



parcelRegister("lwPtc", function(module, exports) {

$parcel$export(module.exports, "GadgetInner", () => $1be6d64e8f66591c$export$9bb8ef6d23720658);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $l8ruj = parcelRequire("l8ruj");

var $8UPoO = parcelRequire("8UPoO");

var $gc2JH = parcelRequire("gc2JH");

var $cmgca = parcelRequire("cmgca");

var $eW8ji = parcelRequire("eW8ji");

var $1NzHy = parcelRequire("1NzHy");

var $9sF5P = parcelRequire("9sF5P");

var $k3y1k = parcelRequire("k3y1k");

var $ce1BZ = parcelRequire("ce1BZ");
const $1be6d64e8f66591c$export$9bb8ef6d23720658 = ({ dashboardId: dashboardId, data: data, isUnconfigured: isUnconfigured, isEditModeEnabled: isEditModeEnabled, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, setTitle: setTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel, unconfiguredFallback: unconfiguredFallback, onRegisterConnectGadget: onRegisterConnectGadget, onUnregisterConnectGadget: onUnregisterConnectGadget })=>{
    const enhancedContext = (0, $gc2JH.useGadgetDataContextEnhancer)(data.context);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(data.id);
    const unconfiguredModernGadgetInViewMode = !isInEditMode && isUnconfigured && !(0, $cmgca.isConnectGadget)(data);
    const localStorageHeight = (0, $8UPoO.useLocalStorageGadgetHeight)(data.id);
    if (unconfiguredFallback != null && unconfiguredModernGadgetInViewMode) return unconfiguredFallback;
    if ((0, $cmgca.isConnectGadget)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NzHy.Connect), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        onEditModeCancel: onEditModeCancel,
        onRegister: onRegisterConnectGadget,
        onUnregister: onUnregisterConnectGadget,
        setTitle: setTitle
    }));
    if (data.amdModule != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-amd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eW8ji.Amd), {
        dashboardId: dashboardId,
        gadgetId: data.id,
        amdModule: data.amdModule,
        context: enhancedContext,
        defaultTitle: data.title,
        userPrefs: data.userPrefs,
        inlineHtml: data.inlineHtml,
        isEditable: isEditModeEnabled,
        isLoading: isLoading,
        isInEditMode: isInEditMode,
        setIsLoading: setIsLoading,
        setDefaultTitle: setDefaultTitle,
        shouldUseCache: shouldUseCache,
        isMaximized: isMaximized,
        onEditModeCancel: onEditModeCancel
    }));
    if (data.inlineHtml != null && data.renderedGadgetUrl == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-inline-html"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3y1k.InlineHtml), {
        id: data.id,
        inlineHtml: data.inlineHtml,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    }));
    if (data.forge != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-forge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9sF5P.Forge), {
        forgeKey: data.forge.key,
        gadgetData: data,
        isInEditMode: isInEditMode,
        onEditModeCancel: onEditModeCancel,
        setIsLoading: setIsLoading
    }));
    if ((0, $kspzT.isReactKey)(data.reactKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "gadget-inner-react"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce1BZ.ReactGadget), {
        id: data.id,
        reactKey: data.reactKey,
        onEditModeCancel: onEditModeCancel,
        isInEditMode: isInEditMode,
        userPrefs: data.userPrefs,
        onRenderComplete: onGadgetRender,
        setDefaultTitle: setDefaultTitle,
        customSkeletonHeightInPx: localStorageHeight
    }));
    throw new Error(`Unrecognised gadget type [${data.title}, ${data?.gadgetSpecUrl}]`);
};

});
parcelRegister("gc2JH", function(module, exports) {

$parcel$export(module.exports, "useGadgetDataContextEnhancer", () => $ef0abc66ae6c989f$export$c9b763726c221f0f);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $8wYJI = parcelRequire("8wYJI");
const $ef0abc66ae6c989f$export$191677f0ab656833 = ({ user: user, ...context }, enhancedUser)=>({
        ...context,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        user: {
            ...user,
            ...enhancedUser
        }
    });
const $ef0abc66ae6c989f$export$c9b763726c221f0f = (data)=>{
    const accountId = (0, $90yGq.useAccountId)();
    const languageTag = (0, $8wYJI.useLanguageTag)();
    return (0, $5uXOq.useMemo)(()=>$ef0abc66ae6c989f$export$191677f0ab656833(data, {
            accountId: accountId,
            languageTag: languageTag
        }), [
        accountId,
        data,
        languageTag
    ]);
};

});
parcelRegister("8wYJI", function(module, exports) {

$parcel$export(module.exports, "useLanguageTag", () => $98f5b4da7049a1e2$export$dbb9c2c3f6b09f02);

var $9OXo1 = parcelRequire("9OXo1");
const $98f5b4da7049a1e2$export$271af7ea6b55125e = 'en-US';
const $98f5b4da7049a1e2$export$dbb9c2c3f6b09f02 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.languageTag || $98f5b4da7049a1e2$export$271af7ea6b55125e;
};

});


parcelRegister("cmgca", function(module, exports) {

$parcel$export(module.exports, "isConnectGadget", () => $d6e9d4b1bec846d6$export$d4464474d72c938d);

var $JIPqS = parcelRequire("JIPqS");
const $d6e9d4b1bec846d6$export$d4464474d72c938d = ({ amdModule: amdModule })=>amdModule === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE);

});

parcelRegister("eW8ji", function(module, exports) {

$parcel$export(module.exports, "Amd", () => $f71dbcea44b19d9c$export$f7e1ea694836dc0c);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");

var $fJpBG = parcelRequire("fJpBG");

var $jcw0u = parcelRequire("jcw0u");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $4R6GH = parcelRequire("4R6GH");

var $9kbEN = parcelRequire("9kbEN");

var $4uQB7 = parcelRequire("4uQB7");

var $c1XZn = parcelRequire("c1XZn");

var $jszBL = parcelRequire("jszBL");

var $8FVKN = parcelRequire("8FVKN");

var $ih7Bj = parcelRequire("ih7Bj");

var $7vg9b = parcelRequire("7vg9b");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $ikoXd = parcelRequire("ikoXd");

var $WIEWs = parcelRequire("WIEWs");
const $f71dbcea44b19d9c$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.VIEW_WRM_GADGET_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $f71dbcea44b19d9c$var$reportError = (gadgetId, reportGadgetMetrics, error)=>{
    reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_START_EVENT), 'ErrorMessage');
    reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_RENDERING_FINISHED_EVENT), 'ErrorMessage');
    (0, $hh0bW.default)({
        ...$f71dbcea44b19d9c$var$expAttributes,
        wasExperienceSuccesful: false
    });
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: (0, $JIPqS.VIEW_WRM_GADGET_EXPERIENCE),
            packageName: 'jiraDashboardInternalCommon'
        }
    });
};
const $f71dbcea44b19d9c$export$f7e1ea694836dc0c = ({ dashboardId: dashboardId, gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, userPrefs: userPrefs, inlineHtml: inlineHtml, isEditable: isEditable, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, shouldUseCache: shouldUseCache, isMaximized: isMaximized, onEditModeCancel: onEditModeCancel })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { loading: loadingB, data: data } = (0, $gh1hi.useDashboardAMDModulesResource)();
    const { amdModules: amdModules = null } = data ?? {};
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const preference = (0, $5uXOq.useMemo)(()=>(0, $fJpBG.decodeUserPreferences)(userPrefs?.fields), [
        userPrefs?.fields
    ]);
    const module = (0, $5uXOq.useRef)(null);
    const divRef = (0, $5uXOq.useRef)(null);
    const { addEventHandler: addEventHandler, triggerEvent: triggerEvent, removeEventHandlers: removeEventHandlers } = (0, $jszBL.useEventPublisher)();
    const isGlobalsReady = (0, $ih7Bj.useIsGlobalsReady)();
    const isRenderable = isGlobalsReady && !loadingB && amdModules?.[amdModule ?? ''] != null || module.current != null;
    const isSkeleton = isLoading && !isInEditMode;
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const [gadgetError, setGadgetError] = (0, $5uXOq.useState)(null);
    (0, $7vg9b.useLinkInterceptor)(divRef.current, isLoading);
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((gid, eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $5TsWX.WRM_GADGET_METRICS)
        }, {
            gadgetId: gid,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        currentPageId
    ]);
    const gadgetApi = (0, $5uXOq.useMemo)(()=>(0, $ikoXd.getInlineGadgetApi)({
            gadgetId: gadgetId,
            amdModule: amdModule ?? '',
            context: context,
            defaultTitle: defaultTitle,
            isEditable: isEditable,
            closeEdit: onEditModeCancel,
            setIsLoading: setIsLoading,
            ref: divRef,
            setDefaultTitle: setDefaultTitle,
            reportGadgetMetrics: reportGadgetMetrics,
            dashboardId: dashboardId,
            addEventHandler: addEventHandler,
            removeEventHandlers: removeEventHandlers,
            triggerEvent: triggerEvent,
            setPreferences: setPreferences,
            shouldUseCache: shouldUseCache,
            view: isMaximized ? 'canvas' : 'default',
            setError: setGadgetError
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // IMPORTANT - this effect must come before AMD initialisation effect
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (inlineHtml == null || divRef.current == null) return;
        divRef.current.innerHTML = '';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        divRef.current.appendChild(document.createRange().createContextualFragment(inlineHtml));
    }, [
        inlineHtml
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (async ()=>{
            // TODO - amdModule missing should be a hard error not a type refinement
            if (!isRenderable || amdModule == null) return;
            // first time initialisation
            if (module.current == null) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const Module = amdModules[amdModule];
                try {
                    module.current = new Module(gadgetApi);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                    setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                    (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Failed to instantiate AMD module [${amdModule}]`, error);
                }
            }
            // re-render on edit-mode config/view change
            if (module.current != null) {
                (0, $dJl1T.default).safeInfoWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] in ${isInEditMode ? 'Edit' : 'View'} mode`);
                reportGadgetMetrics(gadgetId, (0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT), isInEditMode ? 'Config' : 'View', undefined, undefined);
                const render = isInEditMode && module.current?.renderEdit || preference.isConfigured && module.current?.render || null;
                if (render == null) {
                    $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, new Error('gadget render is null'));
                    setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                    // NOTE - this is not a plausible case but log it anyway, ideally we'd want type guarantees
                    (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method missing`);
                } else {
                    try {
                        render.call(module.current, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        window.jQuery(divRef.current), preference);
                        setGadgetError(null);
                        if ((0, $4R6GH.fg)('endeavour_gadget_sample_view-wrm-gadget_success')) // The view-wrm-gadget success count is being sampled at 10%.
                        // The Tome SLO (https://tome.prod.atl-paas.net/slo/5c05ad48-7535-4566-a4ef-a6e1d94de332)
                        // success count has a multiplier of 10 to account for this sampling.
                        {
                            if ((0, $9kbEN.isInSample)(10)) (0, $hh0bW.default)({
                                ...$f71dbcea44b19d9c$var$expAttributes,
                                wasExperienceSuccesful: true
                            });
                        } else (0, $hh0bW.default)({
                            ...$f71dbcea44b19d9c$var$expAttributes,
                            wasExperienceSuccesful: true
                        });
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        $f71dbcea44b19d9c$var$reportError(gadgetId, reportGadgetMetrics, error);
                        setGadgetError((0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR);
                        (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd', `Render AMD module [${amdModule}] failure in ${isInEditMode ? 'Edit' : 'View'} mode, render method throws error`, error);
                    }
                    triggerEvent('afterRender');
                }
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInEditMode,
        preference,
        isRenderable
    ]);
    (0, $5uXOq.useEffect)(// clean up, in separate hook because we only want it called once on unmount
    ()=>()=>{
            if (module.current) module.current = null;
        }, []);
    return gadgetError != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
        errorType: gadgetError,
        id: gadgetId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.GadgetContainer), {
        id: `gadget-${gadgetId}`,
        ref: divRef,
        isHidden: isSkeleton
    }), isSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WIEWs.SkeletonWrapper), {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.amd.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};

});
parcelRegister("4uQB7", function(module, exports) {

$parcel$export(module.exports, "GadgetErrorFallbackBase", () => $73c4c8c0862da954$export$f9edce43cd0e391a);
$parcel$export(module.exports, "GadgetErrorFallback", () => $73c4c8c0862da954$export$6de1d4202af2589f);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $koVbs = parcelRequire("koVbs");

var $8FVKN = parcelRequire("8FVKN");

var $ii3gE = parcelRequire("ii3gE");

var $2n7g7 = parcelRequire("2n7g7");

var $e0K9l = parcelRequire("e0K9l");
const $73c4c8c0862da954$export$f9edce43cd0e391a = ({ id: id, message: message, isRefresh: isRefresh = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onRefreshClick = (0, $8FVKN.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ii3gE.GadgetFallback), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            spacing: "spacious",
            label: formatMessage((0, $2n7g7.default).errorTitle),
            color: "var(--ds-text-warning, #A54800)"
        }),
        action: isRefresh && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "default",
            spacing: "default",
            onClick: onRefreshClick
        }, formatMessage((0, $2n7g7.default).refreshButtonText))
    }, message);
};
const $73c4c8c0862da954$export$6de1d4202af2589f = ({ id: id, errorType: errorType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($73c4c8c0862da954$export$f9edce43cd0e391a, {
        message: formatMessage((0, $e0K9l.MESSAGES_BY_ERROR)[errorType]),
        isRefresh: (0, $e0K9l.IS_REFRESH_BY_ERROR)[errorType],
        id: id
    });
};

});
parcelRegister("ii3gE", function(module, exports) {

$parcel$export(module.exports, "GadgetFallback", () => $b7e4ec4cca3d9de1$export$5c6c3d588eda4d74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8UPoO = parcelRequire("8UPoO");
const $b7e4ec4cca3d9de1$export$5c6c3d588eda4d74 = ({ icon: icon, action: action, id: id, children: children })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(id);
    (0, $5uXOq.useEffect)(()=>{
        const measuredHeight = ref.current?.getBoundingClientRect().height;
        onGadgetRender(measuredHeight === 0 ? undefined : measuredHeight);
    }, [
        onGadgetRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b7e4ec4cca3d9de1$var$GadgetFallbackWrapper, {
        ref: ref
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b7e4ec4cca3d9de1$var$contentStyles
    }, children), action);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b7e4ec4cca3d9de1$var$GadgetFallbackWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _bfhk11bn _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _syaz1dyx _vchhusvi _y3gn1h6o _4t3i1kw7",
            __cmplp.className
        ])
    });
});
const $b7e4ec4cca3d9de1$var$contentStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    margin: 'space.100'
});

});

parcelRegister("2n7g7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8791e45dc80d54b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8791e45dc80d54b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-message",
        "defaultMessage": "We're having some trouble displaying this gadget. It's probably a temporary problem. Try refreshing the gadget."
    },
    errorTitle: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.error-title",
        "defaultMessage": "Warning"
    },
    configErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.config-error-message",
        "defaultMessage": "Something went wrong. We could not save your gadget configuration. Refresh this gadget to update its configuration and try again."
    },
    refreshButtonText: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.refresh-button-text",
        "defaultMessage": "Refresh"
    },
    notSupportedErrorMessage: {
        "id": "dashboard-internal-common.common.gadget.gadget-error-fallback.not-supported-error-message",
        "defaultMessage": "This gadget is no longer supported by Jira."
    }
});

});

parcelRegister("e0K9l", function(module, exports) {

$parcel$export(module.exports, "MESSAGES_BY_ERROR", () => $96b21687e2fe8cc8$export$8c49a4613a61ecc1);
$parcel$export(module.exports, "IS_REFRESH_BY_ERROR", () => $96b21687e2fe8cc8$export$1b18ce488a22b856);

var $JIPqS = parcelRequire("JIPqS");

var $2n7g7 = parcelRequire("2n7g7");
const $96b21687e2fe8cc8$export$8c49a4613a61ecc1 = {
    [(0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR]: (0, $2n7g7.default).configErrorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR]: (0, $2n7g7.default).errorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).EDIT_ERROR]: (0, $2n7g7.default).errorMessage,
    [(0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: (0, $2n7g7.default).notSupportedErrorMessage
};
const $96b21687e2fe8cc8$export$1b18ce488a22b856 = {
    [(0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).EDIT_ERROR]: true,
    [(0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR]: false
};

});


parcelRegister("c1XZn", function(module, exports) {

$parcel$export(module.exports, "SkeletonGadgetContent", () => $5d9b139cc9647a02$export$8609a145e570faa1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7Wo16 = parcelRequire("7Wo16");

var $fNobW = parcelRequire("fNobW");

var $44v1T = parcelRequire("44v1T");

var $koVbs = parcelRequire("koVbs");

var $19nfo = parcelRequire("19nfo");

var $kZxfg = parcelRequire("kZxfg");
const $5d9b139cc9647a02$export$8609a145e570faa1 = ({ dashboardId: dashboardId, gadgetId: gadgetId, customHeight: customHeight, isPulsing: isPulsing = true, isLimitedToScreenHeight: isLimitedToScreenHeight = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const gadgetLocalHeight = customHeight ?? `${(0, $19nfo.getLocalStorageHeight)(dashboardId, gadgetId)}px`;
    const heightIsZero = gadgetLocalHeight.match(/^0[^.0-9]*$/);
    // will match 0px,0%,etc but not 0.1px
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "skeleton-gadget-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d9b139cc9647a02$var$SkeletonContent, {
        height: gadgetLocalHeight,
        isLimitedToScreenHeight: isLimitedToScreenHeight,
        isPulsing: isPulsing,
        "data-testid": "dashboard-internal-common.common.gadget.gadget-skeleton.skeleton-content",
        role: "status",
        "aria-label": "Loading"
    }, !heightIsZero && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Wo16))), {
        LEGACY_size: "large",
        label: formatMessage((0, $kZxfg.default).genericPlaceholderIcon),
        color: "currentColor"
    })));
};
const $5d9b139cc9647a02$var$PulseAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5d9b139cc9647a02$var$SkeletonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLimitedToScreenHeight: isLimitedToScreenHeight, isPulsing: isPulsing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kmmpls": (0, $lD23V.default)(__cmplp.height ?? '100%'),
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _4t3i101j _bfhkm7j4 _1e0c1txw _4cvr1h6o _1bah1h6o _1nj1m7j4 _v4q31yy8 _nhwa12c5 _1qzzvp3v _8em7p3kn",
            __cmplp.isLimitedToScreenHeight && "_c71lve9e",
            __cmplp.isPulsing ? "_h82i9cwz" : "_h82iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Wo16", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b76701fdeded2ed2baf8d7b2cda2dab9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c80946547c07390$var$_react = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c80946547c07390$var$_chartBar = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("fDskX")));

var $5c80946547c07390$var$_presentation = $5c80946547c07390$var$_interopRequireDefault((parcelRequire("dRtil")));
function $5c80946547c07390$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartBarIcon.
 * This component is ChartBarIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesPresentationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c80946547c07390$var$ChartBarIcon = (props)=>/*#__PURE__*/ $5c80946547c07390$var$_react.default.createElement($5c80946547c07390$var$_chartBar.default, Object.assign({
        LEGACY_fallbackIcon: $5c80946547c07390$var$_presentation.default
    }, props));
$5c80946547c07390$var$ChartBarIcon.Name = 'ChartBarIconMigration';
var $5c80946547c07390$var$_default = module.exports.default = $5c80946547c07390$var$ChartBarIcon;

});
parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d3ac0915bdeb94dd7c93af5baf915b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.917 9.75H1.75V13c0 .69.56 1.25 1.25 1.25h2.917m0-4.5v4.5m0-4.5v-4h4.166m-4.166 8.5h4.166m0-8.5v-4h4.167V13c0 .69-.56 1.25-1.25 1.25h-2.917m0-8.5v8.5"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});

parcelRegister("dRtil", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a176f2f205c06729$var$_react = $a176f2f205c06729$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a176f2f205c06729$var$_chartBar = $a176f2f205c06729$var$_interopRequireDefault((parcelRequire("fDskX")));
function $a176f2f205c06729$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a176f2f205c06729$var$MediaServicesPresentationIcon = (props)=>/*#__PURE__*/ $a176f2f205c06729$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="2" height="3" x="8" y="12" fill="inherit" rx="1"/><rect width="2" height="5" x="11" y="10" fill="inherit" rx="1"/><rect width="2" height="7" x="14" y="8" fill="inherit" rx="1"/></g></svg>`
    }, props, {
        newIcon: $a176f2f205c06729$var$_chartBar.default
    }));
$a176f2f205c06729$var$MediaServicesPresentationIcon.displayName = 'MediaServicesPresentationIcon';
var $a176f2f205c06729$var$_default = module.exports.default = $a176f2f205c06729$var$MediaServicesPresentationIcon;

});


parcelRegister("kZxfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfdcaba3d94c905$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4cfdcaba3d94c905$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericPlaceholderIcon: {
        "id": "dashboard-internal-common.common.gadget.gadget-skeleton.generic-placeholder-icon",
        "defaultMessage": "Placeholder icon"
    }
});

});


parcelRegister("jszBL", function(module, exports) {

$parcel$export(module.exports, "useEventPublisher", () => $4e63d8ae41297db4$export$15f587a36eadd076);

var $5uXOq = parcelRequire("5uXOq");
const $4e63d8ae41297db4$export$15f587a36eadd076 = ()=>{
    // Do not reassign current, as this change will not be seen by useCallback dependency list.  Mutate object instead.
    const eventHandlers = (0, $5uXOq.useRef)(new Map()).current;
    const singleUseEventHandlers = (0, $5uXOq.useRef)(new Map()).current;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const addEventHandler = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler, isSingleUse = false)=>{
        const handlers = isSingleUse ? singleUseEventHandlers : eventHandlers;
        handlers.has(eventName) ? handlers.get(eventName)?.add(handler) : handlers.set(eventName, new Set([
            handler
        ]));
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const removeEventHandlers = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName, handler)=>{
        if (eventName == null) {
            eventHandlers.clear();
            singleUseEventHandlers.clear();
            return;
        }
        if (!handler) {
            eventHandlers.delete(eventName);
            singleUseEventHandlers.delete(eventName);
            return;
        }
        eventHandlers.get(eventName)?.delete(handler);
        singleUseEventHandlers.get(eventName)?.delete(handler);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const triggerEvent = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (eventName)=>{
        eventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.get(eventName)?.forEach((handler)=>{
            handler();
        });
        singleUseEventHandlers.delete(eventName);
    }, [
        eventHandlers,
        singleUseEventHandlers
    ]);
    return {
        addEventHandler: addEventHandler,
        removeEventHandlers: removeEventHandlers,
        triggerEvent: triggerEvent
    };
};

});

parcelRegister("ih7Bj", function(module, exports) {

$parcel$export(module.exports, "useIsGlobalsReady", () => $6d5b1af24dce0aaf$export$676419e1d49cf911);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $jU6q7 = parcelRequire("jU6q7");

var $4P2OM = parcelRequire("4P2OM");
let $6d5b1af24dce0aaf$var$pollingSingleton = null;
const $6d5b1af24dce0aaf$export$ef596e2a3bce12f6 = ()=>{
    $6d5b1af24dce0aaf$var$pollingSingleton = null;
};
class $6d5b1af24dce0aaf$var$PollingTimedOutError extends Error {
    constructor(){
        super('Timed out polling for globals');
        this.skipSentry = true;
    }
}
const $6d5b1af24dce0aaf$export$676419e1d49cf911 = ()=>{
    try {
        $6d5b1af24dce0aaf$var$pollingSingleton = $6d5b1af24dce0aaf$var$pollingSingleton ?? new (0, $jU6q7.default)(100, (0, $4P2OM.POLLING_TIMEOUT_MS), (0, $dJl1T.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeWarnWithoutCustomerData('spa-apps.dashboard.common', 'error creating globals polling singleton', error);
    }
    // IMPORTANT - must evaluate readiness synchronously on the first call to avoid async delay
    const [isGlobalsReady, setIsGlobalsReady] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isReady ?? false);
    const [isTimedOut, setIsTimedOut] = (0, $5uXOq.useState)(()=>$6d5b1af24dce0aaf$var$pollingSingleton?.isTimedOut ?? false);
    (0, $5uXOq.useEffect)(()=>{
        const setGlobalsReady = ()=>{
            setIsGlobalsReady(true);
        };
        const setTimedOut = ()=>{
            setIsTimedOut(true);
        };
        $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onReady', setGlobalsReady);
        $6d5b1af24dce0aaf$var$pollingSingleton?.addEventListener('onTimeout', setTimedOut);
        return ()=>{
            $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onReady', setGlobalsReady);
            $6d5b1af24dce0aaf$var$pollingSingleton?.removeEventListener('onTimeout', setTimedOut);
        };
    }, []);
    // NOTE - additional state and effect is needed for error to trigger react ErrorBoundary
    (0, $5uXOq.useEffect)(()=>{
        if (isTimedOut) throw new $6d5b1af24dce0aaf$var$PollingTimedOutError();
    }, [
        isTimedOut
    ]);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $6d5b1af24dce0aaf$var$pollingSingleton !== null ? isGlobalsReady : (0, $4P2OM.DEPENDENCIES).every((dep)=>window[dep]);
};

});
parcelRegister("jU6q7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6560cd8e50818359$export$2e2bcd8739ae039);

var $4P2OM = parcelRequire("4P2OM");

var $euXBp = parcelRequire("euXBp");
const $6560cd8e50818359$var$formatGlobals = (deps)=>deps.map((dep)=>`window.${dep}`).join(', ');
// IMPORTANT - EventTarget does not exist in SSR so a degenerate version is required so that it doesn't fail SSR.
// This class should not be run on SSR as it will fall back to the degenerate version.
const $6560cd8e50818359$var$EventTargetUniversal = typeof EventTarget === 'undefined' ? (0, $euXBp.default) : EventTarget;
class $6560cd8e50818359$export$2e2bcd8739ae039 extends $6560cd8e50818359$var$EventTargetUniversal {
    #intervalID;
    #timeoutID;
    #startTime;
    constructor(pollingMs, timeoutMs, logger){
        super(), this.isReady = false, this.isTimedOut = false, this.missingDeps = [], this.#intervalID = null, this.#timeoutID = null, this.#startTime = Date.now(), this.#constructPolling = (pollingMs, timeoutMs, logger)=>{
            this.#intervalID = setInterval(()=>{
                const newReadyDeps = (0, $4P2OM.DEPENDENCIES).filter(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                (dep)=>window[dep] && this.missingDeps.includes(dep));
                if (newReadyDeps.length !== 0) {
                    this.missingDeps = this.missingDeps.filter((dep)=>!newReadyDeps.includes(dep));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `globals [${$6560cd8e50818359$var$formatGlobals(newReadyDeps)}] ready after ${(Date.now() - this.#startTime) / 1000}s, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                }
                if (this.missingDeps.length === 0) {
                    this.isReady = true;
                    this.destroy();
                    this.dispatchEvent(new CustomEvent('onReady'));
                    logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, $4P2OM.DEPENDENCIES))}] ready after ${(Date.now() - this.#startTime) / 1000}s`);
                }
            }, pollingMs);
            this.#timeoutID = setTimeout(()=>{
                this.destroy();
                if (!this.isReady) {
                    this.isTimedOut = true;
                    this.dispatchEvent(new CustomEvent('onTimeout'));
                    logger.safeErrorWithoutCustomerData('spa-apps.dashboard.common', `timed out polling globals, missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
                }
            }, timeoutMs);
        }, this.destroy = ()=>{
            if (this.#intervalID != null) {
                clearInterval(this.#intervalID);
                this.#intervalID = null;
            }
            if (this.#timeoutID != null) {
                clearTimeout(this.#timeoutID);
                this.#timeoutID = null;
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.missingDeps = (0, $4P2OM.DEPENDENCIES).filter((dep)=>!window[dep]);
        if (this.missingDeps.length === 0) {
            logger.safeInfoWithoutCustomerData('spa-apps.dashboard.common', `all globals [${$6560cd8e50818359$var$formatGlobals((0, $4P2OM.DEPENDENCIES))}] ready on initialisation`);
            this.isReady = true;
        } else {
            logger.safeWarnWithoutCustomerData('spa-apps.dashboard.common', `missing globals [${$6560cd8e50818359$var$formatGlobals(this.missingDeps)}]`);
            this.#constructPolling(pollingMs, timeoutMs, logger);
        }
    }
    #constructPolling;
}

});
parcelRegister("4P2OM", function(module, exports) {

$parcel$export(module.exports, "DEPENDENCIES", () => $f910f3784745e897$export$db362e2d293fe52e);
$parcel$export(module.exports, "POLLING_TIMEOUT_MS", () => $f910f3784745e897$export$560b5415aba6175);
const $f910f3784745e897$export$db362e2d293fe52e = [
    'require',
    'jQuery'
];
const $f910f3784745e897$export$560b5415aba6175 = 60000;

});

parcelRegister("euXBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae767f7162d54de$export$2e2bcd8739ae039);
class $9ae767f7162d54de$export$2e2bcd8739ae039 {
    constructor(){
        throw new Error('EventTarget is not defined');
    }
}

});



parcelRegister("7vg9b", function(module, exports) {

$parcel$export(module.exports, "useLinkInterceptor", () => $403995a50b1fa001$export$d6b75f959ce086c3);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $lVJAU = parcelRequire("lVJAU");

var $cdUgf = parcelRequire("cdUgf");

var $2SLmH = parcelRequire("2SLmH");
const $403995a50b1fa001$export$ad8ccaa587ef5e2e = 3984;
// Issue Table meatball menu links
// These have been explicitly ignored as they will generally open modals or perform actions
const $403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS = [
    // Assign. The anchor tag it belongs to opens a modal in the monolith.
    /^\/secure\/AssignIssue!default\.jspa/,
    // Assign to me. The anchor tag it belongs to reassigns then reloads page.
    /^\/secure\/AssignIssue\.jspa/,
    // Vote and watch. The anchor tag it belongs to votes/watches on the issue then reloads page.
    /^\/secure\/VoteOrWatchIssue\.jspa/,
    // Rank top. The anchor tag it belongs to ranks the issue to the top then reloads page.
    /^\/secure\/RankTop\.jspa/,
    // Rank bottom. The anchor tag it belongs to ranks the issue to the bottom then reloads page.
    /^\/secure\/RankBottom\.jspa/,
    // Create sub task. The anchor tag it belongs opens a modal in SPA (not monolith)
    /^\/secure\/CreateSubTaskIssue!default\.jspa/,
    // Permission helper. The anchor tag it belongs to opens a modal in monolith.
    /^\/notimportant/,
    // Workflow page. This is when a user transitions an issue, it can open a modal or refresh the modal.
    /^\/secure\/WorkflowUIDispatcher\.jspa/
];
const $403995a50b1fa001$var$EXCLUDED_PATHS = [
    /^\/rest\/(?:gadget|api)\/1\.0\//,
    /^\/plugins\/servlet\/gadgets\/ifr/,
    ...$403995a50b1fa001$var$EXCLUDED_ISSUE_TABLE_PATHS
];
const $403995a50b1fa001$var$isExcludedPath = (path)=>{
    return $403995a50b1fa001$var$EXCLUDED_PATHS.some((regex)=>regex.test(path));
};
const $403995a50b1fa001$export$d6b75f959ce086c3 = (element, isLoading)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const linkClickHandler = (event)=>{
            const anchor = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest?.('a');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (anchor == null || window.location.hostname !== anchor.hostname) // skip if it is not an anchor or to external link
            return;
            if (anchor.href && anchor.href.length > $403995a50b1fa001$export$ad8ccaa587ef5e2e) {
                event.preventDefault();
                const flagConfig = {
                    key: (0, $7HGHK.toFlagId)('urlTooLongWarning'),
                    type: 'error',
                    title: (0, $2SLmH.default).linkInterceptorUrlTooLongTitle,
                    description: (0, $2SLmH.default).linkInterceptorUrlTooLongDescription,
                    messageId: 'dashboard-internal-common.controllers.flagConfig.error',
                    messageType: 'transactional'
                };
                showFlag(flagConfig);
            } else if (anchor.pathname && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            !(0, $cdUgf.clickedWithShortcutKeys)(event) && // some links from the monolith code are invalid and calls
            // event.preventDefault (e.g. popups), so we filter those out
            !event.defaultPrevented && !$403995a50b1fa001$var$isExcludedPath(anchor.pathname)) {
                event.preventDefault();
                push(anchor.href);
            }
        };
        element?.addEventListener('click', linkClickHandler);
        return ()=>{
            element?.removeEventListener('click', linkClickHandler);
        };
    }, [
        element,
        isLoading,
        push,
        showFlag
    ]);
};

});
parcelRegister("cdUgf", function(module, exports) {

$parcel$export(module.exports, "clickedWithShortcutKeys", () => $330ad2eb7d232df1$export$141f1be6ae7df96b);
const $330ad2eb7d232df1$export$141f1be6ae7df96b = (e)=>{
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return true;
    return false;
};

});

parcelRegister("2SLmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e234c15db6f6ac4a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e234c15db6f6ac4a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkInterceptorUrlTooLongTitle: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-title",
        "defaultMessage": "Requested URL too large"
    },
    linkInterceptorUrlTooLongDescription: {
        "id": "dashboard-internal-common.controllers.link-interceptor-url-too-long-description",
        "defaultMessage": "Try shortening the JQL of your saved filter."
    }
});

});


parcelRegister("ikoXd", function(module, exports) {

$parcel$export(module.exports, "getInlineGadgetApi", () => $f1aaef72e172dd4d$export$a7c3539038fb2c0);

var $8Rkzz = parcelRequire("8Rkzz");

var $hh0bW = parcelRequire("hh0bW");

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $19nfo = parcelRequire("19nfo");
const $f1aaef72e172dd4d$export$a7c3539038fb2c0 = ({ gadgetId: gadgetId, amdModule: amdModule, context: context, defaultTitle: defaultTitle, isEditable: isEditable, closeEdit: closeEdit, ref: ref, setIsLoading: setIsLoading, setDefaultTitle: setDefaultTitle, reportGadgetMetrics: reportGadgetMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), dashboardId: dashboardId, setPreferences: setPreferences, addEventHandler: addEventHandler, removeEventHandlers: removeEventHandlers, triggerEvent: triggerEvent, shouldUseCache: shouldUseCache, view: view, setError: setError })=>{
    const resize = ()=>{
        if (!dashboardId || !gadgetId) return;
        // Store current height of gadget in local storage
        const height = ref.current?.getBoundingClientRect().height;
        (0, $19nfo.updateLocalStorageHeight)(dashboardId, gadgetId, height);
    };
    const moduleAPI = {
        on: (id, handler)=>addEventHandler(id, handler),
        once: (id, handler)=>addEventHandler(id, handler, true),
        off: (id, handler)=>removeEventHandlers(id, handler),
        trigger: (id)=>triggerEvent(id)
    };
    const expAttributes = {
        analyticsSource: 'dashboard',
        experience: (0, $JIPqS.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
        application: null,
        edition: null,
        additionalAttributes: {}
    };
    return {
        gadget: {
            amdModule: amdModule,
            context: context,
            moduleAPI: moduleAPI
        },
        showLoadingBar: ()=>{
            setIsLoading(true);
        },
        resize: resize,
        isEditable: ()=>isEditable,
        savePreferences: async (preferences)=>{
            // IMPORTANT
            //  per JDAG-413 we need to batch react state updates with route resource update
            const maybePromise = setPreferences(preferences, ()=>{
                setError(null);
                closeEdit();
            });
            if (!maybePromise) return;
            try {
                await maybePromise;
                (0, $hh0bW.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.amd.api', `${e.message} [${defaultTitle}]`);
                setError((0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR);
                (0, $hh0bW.default)({
                    ...expAttributes,
                    wasExperienceSuccesful: false
                });
                (0, $jcw0u.default)({
                    error: e,
                    meta: {
                        id: (0, $JIPqS.SAVE_AMD_GADGET_CONFIG_PREFERENCES),
                        packageName: 'jiraDashboardInternalCommon'
                    }
                });
            }
        },
        setTitle: setDefaultTitle,
        hideLoadingBar: ()=>setIsLoading(false),
        initRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        getRefreshFieldValue: (fieldName)=>{
            const input = ref.current?.querySelector(`input[name=${fieldName || 'refresh'}]`);
            if (input == null || !(input instanceof HTMLInputElement) || !input.checked) return 'false';
            return input.value;
        },
        getGadgetId: ()=>gadgetId,
        closeEdit: closeEdit,
        // deprecated
        forceLayoutRefresh: ()=>{
            (0, $dJl1T.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'deprecated forceLayoutRefresh() is called');
            resize();
        },
        publicInstace: ()=>(0, $dJl1T.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', 'Unexpected public instance called'),
        _preparePreferencesToBeSaved: (preference)=>{
            let preferenceStr = '';
            try {
                preferenceStr = JSON.stringify(preference);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                preferenceStr = 'non-stringifiable type';
            }
            (0, $dJl1T.default).safeWarnWithoutCustomerData('endeavour.spa.dashboard.gadget.amd.api', `Unexpected prepare preferences called with ${preferenceStr} for ${defaultTitle}`);
        },
        getContext: ()=>context,
        // deprecated, replaced by react life cycle
        ...moduleAPI,
        listenTo: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        stopListening: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        listenToOnce: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        reportGadgetMetrics: reportGadgetMetrics,
        shouldUseCache: shouldUseCache,
        view: view
    };
};

});

parcelRegister("WIEWs", function(module, exports) {

$parcel$export(module.exports, "styleOverrideFromMonolith", () => $ab2b4dcf374b66f3$export$a135452a315aaac8);
$parcel$export(module.exports, "editModeStyleOverrideFromMonolith", () => $ab2b4dcf374b66f3$export$5dd19c8cd0b42775);
$parcel$export(module.exports, "Container", () => $ab2b4dcf374b66f3$export$42a852a2b6b56249);
$parcel$export(module.exports, "SkeletonWrapper", () => $ab2b4dcf374b66f3$export$6069cbe61f690103);
$parcel$export(module.exports, "GadgetContainer", () => $ab2b4dcf374b66f3$export$3f9afbcf9557b0b4);
$parcel$export(module.exports, "ConfigureButton", () => $ab2b4dcf374b66f3$export$b95d78b6ea7efb0b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");
const $ab2b4dcf374b66f3$export$a135452a315aaac8 = `
.piechart-gadget .piechart-fill {
    opacity: 1
}

.piechart-gadget .legend-icon {
    float: left;
    margin-top: 2px;
    margin-right: 10px
}


.piechart-gadget a {
    color: #0052cc;
    text-decoration: none;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.piechart-gadget a:focus,.piechart-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.piechart-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.piechart-gadget .legend-wrapper {
    padding: 0 7px 7px 7px;
    max-width: 450px
}

.piechart-gadget .legend-wrapper a {
    text-decoration: none;
    color: ${"var(--ds-text, #172B4D)"};
}

.piechart-gadget .legend-wrapper a:focus,.piechart-gadget .legend-wrapper a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper a:active {
    color: ${"var(--ds-text, #172B4D)"};
    text-decoration: underline
}

.piechart-gadget .legend-wrapper .legend-item {
    border-top-width: 0;
    border-bottom-width: 0
}

.piechart-gadget .legend-wrapper .legend-item:first-child {
    border-top: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item:last-child {
    border-bottom: 2px solid ${"var(--ds-border-accent-gray, #758195)"};
}

.piechart-gadget .legend-wrapper .legend-item .legend-content {
    padding: 8px 7px 8px 7px
}

.piechart-gadget .legend-wrapper .legend-item .legend-content .legend-item-value {
    padding-right: 7px
}

.two-d-container .extra-container {
    padding: 0
}

.two-d-container .extra-container tbody tr:last-child>td,.two-d-container .extra-container tbody tr:last-child>th,.two-d-container .extra-container tbody tr:last-child>tr,.two-d-container .extra-container tbody tr>td:last-child {
    padding: 7px;
    background: ${"var(--ds-background-neutral, #091E420F)"};
}

.two-d-container .data-footer {
    padding: 5px
}

.two-d-container .data-footer p {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: ${"var(--ds-text-subtle, #44546F)"};
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui thead tr th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #5e6c84;
    font-size: 12px;
    font-weight: ${"var(--ds-font-weight-semibold, 600)"};
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px
}

table.aui thead .aui-iconfont-up {
    visibility: hidden
}

table.aui thead .aui-iconfont-up:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(-45deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 8px
}

table.aui thead .aui-iconfont-down {
    visibility: hidden
}

table.aui thead .aui-iconfont-down:after {
    top: 11px;
    margin-left: -16px;
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    border: none;
    border-right: 2px solid;
    border-top: 2px solid;
    transform: rotate(135deg);
    visibility: visible;
    float: right;
    position: relative;
    top: 6px
}

table.aui tbody:before {
    height: 0
}

table.aui tbody a {
    text-decoration: none;
    color: ${"var(--ds-link, #0C66E4)"};
}

table.aui tbody a:focus,table.aui tbody a:hover {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody a:active {
    color: ${"var(--ds-link, #0C66E4)"};
    text-decoration: underline
}

table.aui tbody>tr:hover {
    background: #ebecf0
}

table.aui tbody>tr>td:last-child {
    border-left-width: 0
}

table.aui tbody>tr>th {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

table.aui tbody>tr:first-child>th {
    border-top-width: 0
}

.stats-gadget {
    padding: 0
}

.stats-gadget tbody a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.stats-gadget tbody a:focus,.stats-gadget tbody a:hover {
    color: #0065ff;
    text-decoration: underline
}

.stats-gadget tbody a:active {
    color: #0049b0;
    text-decoration: underline
}

.stats-gadget tbody tr>td .aui-progress-indicator-value {
    background: #0065ff
}

.stats-gadget tbody tr.stats-gadget-final-row>* {
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    background: #ebecf0
}

.stats-gadget tbody td {
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    color: #172b4d;
    font-size: 14px;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 20px
}

.stats-gadget tbody:last-child>td,.stats-gadget tbody:last-child>th {
    padding: 7px
}

.favourite-filters-item {
    padding: 0
}

.favourite-filters-item .favourite-filters-view {
    border-top: 2px solid #dfe1e6
}

.favourite-filters-item tbody>tr:first-child td {
    border-top-width: 1px
}

.favourite-filters-item .config-options,.favourite-filters-item .empty-container {
    padding: 6px 0 0 7px
}

.favourite-filters-item .config-options .operations-list .aui-button:first-child,.favourite-filters-item .config-options .operations-list li:first-child,.favourite-filters-item .config-options>div .aui-button:first-child,.favourite-filters-item .config-options>div li:first-child,.favourite-filters-item .empty-container .operations-list .aui-button:first-child,.favourite-filters-item .empty-container .operations-list li:first-child,.favourite-filters-item .empty-container>div .aui-button:first-child,.favourite-filters-item .empty-container>div li:first-child {
    display: none
}

.favourite-filters-item .config-options .operations-list .aui-button:nth-child(2),.favourite-filters-item .config-options>div .aui-button:nth-child(2),.favourite-filters-item .empty-container .operations-list .aui-button:nth-child(2),.favourite-filters-item .empty-container>div .aui-button:nth-child(2) {
    margin-left: 0;
    padding-left: 0
}

.favourite-filters-item .config-options .operations-list a,.favourite-filters-item .config-options>div a,.favourite-filters-item .empty-container .operations-list a,.favourite-filters-item .empty-container>div a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.favourite-filters-item .config-options .operations-list a:focus,.favourite-filters-item .config-options .operations-list a:hover,.favourite-filters-item .config-options>div a:focus,.favourite-filters-item .config-options>div a:hover,.favourite-filters-item .empty-container .operations-list a:focus,.favourite-filters-item .empty-container .operations-list a:hover,.favourite-filters-item .empty-container>div a:focus,.favourite-filters-item .empty-container>div a:hover {
    color: #0065ff;
    text-decoration: underline
}

.favourite-filters-item .config-options .operations-list a:active,.favourite-filters-item .config-options>div a:active,.favourite-filters-item .empty-container .operations-list a:active,.favourite-filters-item .empty-container>div a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget {
    padding: 0
}

.createdvsresolved-gadget a {
    color: #0052cc;
    text-decoration: none;
    color: #5e6c84
}

.createdvsresolved-gadget a:focus,.createdvsresolved-gadget a:hover {
    color: #0065ff;
    text-decoration: underline
}

.createdvsresolved-gadget a:active {
    color: #0049b0;
    text-decoration: underline
}

.createdvsresolved-gadget .createdvsresolved-chart text {
    fill: #091e42
}

.createdvsresolved-gadget .createdvsresolved-chart .grid line,.createdvsresolved-gadget .createdvsresolved-chart .versions line {
    stroke: #dfe1e6
}

.createdvsresolved-gadget .createdvsresolved-chart .created path,.createdvsresolved-gadget .createdvsresolved-chart .created-points circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart .resolved path,.createdvsresolved-gadget .createdvsresolved-chart .resolved-points circle {
    stroke: #36b37e
}

.createdvsresolved-gadget .createdvsresolved-chart-info {
    padding-left: 7px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-link {
    display: block;
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-grouping {
    margin-left: 0
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .created-totals svg circle {
    stroke: #ff5630
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg {
    padding-bottom: 2px
}

.createdvsresolved-gadget .createdvsresolved-chart-details-totals .resolved-totals svg circle {
    stroke: #36b37e
}`;
const $ab2b4dcf374b66f3$export$5dd19c8cd0b42775 = `
form.aui .buttons-container .buttons, form.aui .submit-cancel-controls {
    text-align: end;
}
.piechart-gadget .dashboard-item-preferences-config {
    margin: -20px
}
`;
const $ab2b4dcf374b66f3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$6069cbe61f690103 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$3f9afbcf9557b0b4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHidden && "_3um015vq _kqsw7079",
            __cmplp.className
        ])
    });
});
const $ab2b4dcf374b66f3$export$b95d78b6ea7efb0b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1NzHy", function(module, exports) {

$parcel$export(module.exports, "Connect", () => $e94ecec6e18bdb3d$export$59e6910693f047c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $dJZWD = parcelRequire("dJZWD");

var $c1XZn = parcelRequire("c1XZn");

var $8UPoO = parcelRequire("8UPoO");

var $8h45R = parcelRequire("8h45R");

var $8FVKN = parcelRequire("8FVKN");

var $ih7Bj = parcelRequire("ih7Bj");

var $19nfo = parcelRequire("19nfo");
const $e94ecec6e18bdb3d$var$GadgetContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// for monolith to identify gadget
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$GadgetContainerComponent, {
        className: "connect-gadget",
        ...props,
        ref: ref
    }));
const $e94ecec6e18bdb3d$export$59e6910693f047c2 = ({ dashboardId: dashboardId, gadgetId: gadgetId, inlineHtml: inlineHtml, isLoading: isLoading, isInEditMode: isInEditMode, setIsLoading: setIsLoading, onEditModeCancel: onEditModeCancel, onRegister: onRegister, onUnregister: onUnregister, setTitle: setTitle })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    const isGlobalsReady = (0, $ih7Bj.useIsGlobalsReady)();
    const isDisabled = (0, $8FVKN.useIsConnectDisabled)();
    const forcedHeightFromState = (0, $8h45R.useForcedHeight)(gadgetId);
    const forcedHeight = (0, $5uXOq.useMemo)(()=>forcedHeightFromState ?? (0, $19nfo.getLocalStorageHeight)(dashboardId, gadgetId), [
        forcedHeightFromState,
        dashboardId,
        gadgetId
    ]);
    const onGadgetRender = (0, $8UPoO.useOnGadgetRender)(gadgetId);
    const onRefresh = (0, $8FVKN.useGadgetRefresh)();
    const showSkeleton = isLoading && !isInEditMode;
    (0, $5uXOq.useEffect)(()=>{
        // TODO - inlineHtml missing should be a hard error not a type refinement
        if (!isGlobalsReady || inlineHtml == null) return;
        (0, $dJZWD.setupConnectJs)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const slotHtml = document.createRange().createContextualFragment(inlineHtml);
            if (divRef.current) {
                divRef.current.innerHTML = '';
                divRef.current.appendChild(slotHtml);
                setIsLoading(false);
                onGadgetRender();
            }
        }).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.connect', 'Failed to render Connect gadget', error);
        // TODO - where is setError here, where is reportError here?? (compare with amd gadget)
        });
    }, [
        isGlobalsReady,
        inlineHtml,
        onGadgetRender,
        setIsLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onRegister(gadgetId, setTitle);
        return ()=>{
            onUnregister(gadgetId);
        };
    }, [
        gadgetId,
        setTitle,
        onRegister,
        onUnregister
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const target = divRef.current?.getElementsByTagName('iframe')[0];
        if (!target || !isInEditMode || isLoading) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.connectHost?.broadcastEvent('jira_dashboard_item_edit', {
            id: target.getAttribute('id')
        });
    }, [
        isInEditMode,
        isLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const connectEventHandler = (event)=>{
            const eventData = event.data;
            const target = divRef.current?.getElementsByTagName('iframe')[0];
            if (target == null || eventData == null || eventData.eid !== target.getAttribute('id')) return;
            if (eventData.type === 'unload') onRefresh();
            else onEditModeCancel();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('message', connectEventHandler, false);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('message', connectEventHandler);
        };
    }, [
        dashboardId,
        gadgetId,
        inlineHtml,
        isGlobalsReady,
        onRefresh,
        onEditModeCancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$Container, {
        minHeight: forcedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$GadgetContainer, {
        id: `gadget-${gadgetId}`,
        "data-gadget-id": gadgetId,
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.connect",
        ref: divRef,
        isHidden: showSkeleton,
        isDisabled: isDisabled
    }), showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e94ecec6e18bdb3d$var$SkeletonWrapper, {
        "data-testid": "dashboard-internal-common.ui.gadget.gadget-inner.connect.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
        dashboardId: dashboardId,
        gadgetId: gadgetId
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e94ecec6e18bdb3d$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhku67f _kqswstnw _1ltvidpf _154iidpf _1bsb1osq _4t3i1osq _1pby1sen",
            __cmplp.className
        ])
    });
});
const $e94ecec6e18bdb3d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minHeight: minHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l1bpbj": (0, $lD23V.default)(`${__cmplp.minHeight}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1tkemu0a",
            __cmplp.className
        ])
    });
});
const $e94ecec6e18bdb3d$var$GadgetContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1kw7",
            __cmplp.isDisabled ? "_lcxvglyw" : "_lcxv1kw7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9sF5P", function(module, exports) {

$parcel$export(module.exports, "Forge", () => $ce96d098a49d18cb$export$4b9c9e62f20bbcd0);

var $5uXOq = parcelRequire("5uXOq");

var $WjHsO = parcelRequire("WjHsO");

var $JIPqS = parcelRequire("JIPqS");

var $1bM8W = parcelRequire("1bM8W");

var $4qMi4 = parcelRequire("4qMi4");

var $e0AC8 = parcelRequire("e0AC8");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $bVDE5 = parcelRequire("bVDE5");

var $4uQB7 = parcelRequire("4uQB7");

var $c1XZn = parcelRequire("c1XZn");

var $8FVKN = parcelRequire("8FVKN");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $dg9na = parcelRequire("dg9na");
const $ce96d098a49d18cb$export$4b36646b2dadb9ee = ({ gadgetData: gadgetData, forgeKey: forgeKey, isInEditMode: isInEditMode, onEditModeCancel: onEditModeCancel, setIsLoading: setIsLoading })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const { data: dashboardData } = (0, $gh1hi.useDashboardResource)();
    const { data: forgeResourceData, loading: isDashboardForgeResourceLoading, error: resourceError } = (0, $gh1hi.useDashboardForgeResource)();
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [isUpdatePending, setIsUpdatePending] = (0, $5uXOq.useState)(false);
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType, contentType, markName, markStage)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: contentType,
            markName: markName,
            markStage: markStage,
            source: (0, $5TsWX.FORGE_GADGET_METRICS)
        }, {
            gadgetId: gadgetData.id,
            pageId: currentPageId
        });
    }, [
        gadgetData.id,
        broadcastMessageBusListener,
        currentPageId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT), 'View');
    }, [
        reportGadgetMetrics
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isDashboardForgeResourceLoading) setIsLoading(false);
    }, [
        isDashboardForgeResourceLoading,
        setIsLoading
    ]);
    const onConfigurationSave = (0, $5uXOq.useCallback)((dataToSave)=>{
        (0, $1bM8W.fireUiTriggerClickEvent)('dashboardGadgetEdit');
        setIsUpdatePending(true);
        return (0, $dg9na.savePreferences)(gadgetData, dataToSave, setPreferences, setError, ()=>{
            setIsUpdatePending(false);
        });
    }, [
        gadgetData,
        setPreferences,
        setError,
        setIsUpdatePending
    ]);
    const dashboardId = dashboardData?.id || '';
    const extensionData = (0, $5uXOq.useMemo)(()=>({
            gadgetConfiguration: (0, $dg9na.transformUserPrefsForForgeAppConsumption)(gadgetData.userPrefs?.fields),
            dashboard: {
                id: dashboardId
            },
            gadget: {
                id: gadgetData.id
            }
        }), [
        gadgetData.userPrefs?.fields,
        dashboardId,
        gadgetData.id
    ]);
    if (isDashboardForgeResourceLoading || isUpdatePending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null);
    const forgeGadget = forgeResourceData?.gadgets.find((gadget)=>gadget.id === forgeKey);
    if (resourceError || error || !forgeGadget || !dashboardId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
        errorType: error ?? (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR,
        id: gadgetData.id
    });
    return(// have to use Suspense here because AsyncDashboardGadget is lazy loaded using React.lazy()
    // which requires a Suspense further up the tree to work
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-dashboard-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null)
    }, isInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WjHsO.AsyncDashboardGadgetEdit), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null),
        onEditModeCancel: onEditModeCancel,
        onConfigurationSave: onConfigurationSave
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WjHsO.AsyncDashboardGadgetView), {
        extension: forgeGadget,
        extensionData: extensionData,
        onReportGadgetMetrics: reportGadgetMetrics,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), null)
    })));
};
const $ce96d098a49d18cb$export$4b9c9e62f20bbcd0 = (props)=>{
    const { gadgetData: { id: id }, isInEditMode: isInEditMode } = props;
    const envType = props.gadgetData.forge?.environment;
    const forgeKey = props.gadgetData.forge?.key;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qMi4.AnalyticsWrapper), {
        attributes: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            envType: envType,
            ...forgeKey ? (0, $e0AC8.parseExtensionId)(forgeKey) : {}
        },
        key: `${id}__${isInEditMode}`,
        isInEditMode: isInEditMode,
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
                errorType: (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR,
                id: id
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce96d098a49d18cb$export$4b36646b2dadb9ee, props));
};

});
parcelRegister("WjHsO", function(module, exports) {

$parcel$export(module.exports, "AsyncDashboardGadgetView", () => $797cf06bbdcad765$export$8f8b884c8f9b7f99);
$parcel$export(module.exports, "AsyncDashboardGadgetEdit", () => $797cf06bbdcad765$export$11802f9302dce8a3);
// eslint-disable-next-line jira/restricted/react-lazy

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");
const $797cf06bbdcad765$var$GADGET_START_EVENT = 'gadget-start';
const $797cf06bbdcad765$var$GADGET_FINISH_EVENT = 'gadget-rendering-finished';

// We are using React.lazy() instead of react-loosley-lazy here because DashboardGadget
// renders RendererNext from the forge-ui package which uses Suspense
// and you can't mix React.Suspense with RLL
const $797cf06bbdcad765$var$getUiKitModule = ()=>(parcelRequire("hqvG9"));
const $797cf06bbdcad765$export$d53932a75c2ba294 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetView
        }))));
const $797cf06bbdcad765$export$e388a2aaf41cd524 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getUiKitModule().then((module)=>({
            default: module.DashboardGadgetEdit
        }))));

const $797cf06bbdcad765$var$getForgeExtensionModule = ()=>(parcelRequire("fsYFz"));
const $797cf06bbdcad765$export$90dc543486d6f150 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetViewExtension
        }))));
const $797cf06bbdcad765$export$8a87cc350601aff5 = (0, $1rTGO.withMetrics)(/*#__PURE__*/ (0, $5uXOq.lazy)(()=>$797cf06bbdcad765$var$getForgeExtensionModule().then((module)=>({
            default: module.DashboardGadgetEditExtension
        }))));
const $797cf06bbdcad765$var$useDashboardGadget = (onReportGadgetMetrics, extensionData, entryPoint)=>{
    const onInitialRender = (0, $5uXOq.useCallback)((payload)=>{
        if (payload !== undefined && payload.error == null) onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_FINISH_EVENT, 'View');
        else onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_FINISH_EVENT, 'ErrorMessage');
    }, [
        onReportGadgetMetrics
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onReportGadgetMetrics($797cf06bbdcad765$var$GADGET_START_EVENT, 'View');
    }, [
        onReportGadgetMetrics
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        const extraPropsUiCommon = {
            module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
            entryPoint: entryPoint,
            extensionData: {
                ...extensionData,
                entryPoint: entryPoint,
                type: (0, $k2DRb.DASHBOARD_GADGET_MODULE)
            }
        };
        return {
            onInitialRender: onInitialRender,
            extraPropsUiCommon: extraPropsUiCommon
        };
    }, [
        entryPoint,
        extensionData,
        onInitialRender
    ]);
};
const $797cf06bbdcad765$export$8f8b884c8f9b7f99 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $797cf06bbdcad765$var$useDashboardGadget(onReportGadgetMetrics, extensionData);
    const extraPropsUiKit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUi = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if ((0, $3mOWa.isNativeUiExtension)(props.extension) || (0, $3mOWa.isCustomUIExtension)(props.extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$90dc543486d6f150, {
        ...restProps,
        ...extraPropsCustomUi
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$d53932a75c2ba294, {
        ...restProps,
        ...extraPropsUiKit
    });
};
const $797cf06bbdcad765$export$11802f9302dce8a3 = (props)=>{
    const { extensionData: extensionData, onReportGadgetMetrics: onReportGadgetMetrics, ...restProps } = props;
    const { onInitialRender: onInitialRender, extraPropsUiCommon: extraPropsUiCommon } = $797cf06bbdcad765$var$useDashboardGadget(onReportGadgetMetrics, extensionData, (0, $k2DRb.ENTRY_POINT_EDIT));
    const extraPropsUiKitEdit = {
        ...extraPropsUiCommon,
        onInitialRender: onInitialRender
    };
    const extraPropsCustomUiEdit = {
        ...extraPropsUiCommon,
        onLoad: onInitialRender
    };
    if ((0, $3mOWa.isNativeUiExtension)(props.extension, (0, $k2DRb.ENTRY_POINT_EDIT)) || (0, $3mOWa.isCustomUIExtension)(props.extension, (0, $k2DRb.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$8a87cc350601aff5, {
        ...restProps,
        ...extraPropsCustomUiEdit
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($797cf06bbdcad765$export$e388a2aaf41cd524, {
        ...restProps,
        ...extraPropsUiKitEdit
    });
};

});
parcelRegister("hqvG9", function(module, exports) {

let $cafd7027c444f8e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cafd7027c444f8e7$var$load("i0S0H").then(()=>parcelRequire('3JVox'));

});

parcelRegister("fsYFz", function(module, exports) {

let $b4288837980abe71$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b4288837980abe71$var$load("kWrFZ"),
    $b4288837980abe71$var$load("eNmuD"),
    $b4288837980abe71$var$load("cM9em"),
    $b4288837980abe71$var$load("fr9NE"),
    $b4288837980abe71$var$load("hPzOn"),
    $b4288837980abe71$var$load("h2MrD"),
    $b4288837980abe71$var$load("bYT2S"),
    $b4288837980abe71$var$load("jZDL6")
]).then(()=>parcelRequire('1CNt0'));

});


parcelRegister("1bM8W", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $32b5ad7fb71ba34b$export$1798d320c6527c08);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $32b5ad7fb71ba34b$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $32b5ad7fb71ba34b$export$cfefb608fbbf02c9);

var $k2DRb = parcelRequire("k2DRb");

var $8uOa6 = parcelRequire("8uOa6");

var $9BrHy = parcelRequire("9BrHy");

var $hBuqR = parcelRequire("hBuqR");
const $32b5ad7fb71ba34b$var$moduleEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $32b5ad7fb71ba34b$var$triggerEventId = (0, $9BrHy.getEventId)({
    module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
    moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $k2DRb.ENTRY_POINT_EDIT)
});
const $32b5ad7fb71ba34b$export$1798d320c6527c08 = (source, attributes)=>(0, $8uOa6.fireTrackEvent)((0, $hBuqR.TRACK_ACTIONS).EDITED, {
        id: $32b5ad7fb71ba34b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $32b5ad7fb71ba34b$export$762dee9e981de3e1 = (source, attributes)=>(0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $32b5ad7fb71ba34b$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $32b5ad7fb71ba34b$export$cfefb608fbbf02c9 = (source, attributes)=>(0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
        id: $32b5ad7fb71ba34b$var$triggerEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("4qMi4", function(module, exports) {

$parcel$export(module.exports, "AnalyticsWrapper", () => $03ae219febd68629$export$63b55d605f8a2340);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");
const $03ae219febd68629$export$63b55d605f8a2340 = (props)=>{
    const { isInEditMode: isInEditMode, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        ...restProps,
        module: (0, $k2DRb.DASHBOARD_GADGET_MODULE),
        entryPoint: isInEditMode ? (0, $k2DRb.ENTRY_POINT_EDIT) : undefined,
        shouldFireInitializedEvent: true
    });
};

});

parcelRegister("dg9na", function(module, exports) {

$parcel$export(module.exports, "savePreferences", () => $7fcdc9b72606be07$export$f1786e2fa4419c16);
$parcel$export(module.exports, "transformUserPrefsForForgeAppConsumption", () => $7fcdc9b72606be07$export$b5d9bfce42b49862);

var $hh0bW = parcelRequire("hh0bW");

var $dJl1T = parcelRequire("dJl1T");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $1bM8W = parcelRequire("1bM8W");
const $7fcdc9b72606be07$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $7fcdc9b72606be07$export$f1786e2fa4419c16 = async (data, preferences, setPreferences, setError, onComplete)=>{
    const { title: defaultTitle } = data;
    // the backend checks that each user pref value is valid json
    // so we need to stringify string values eg ""value""
    // this is done inside the gadget for other gadget types but
    // we need to do it here for forge
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newUserPrefs = {};
    Object.entries(preferences).forEach(([key, value])=>{
        newUserPrefs[key] = typeof value === 'string' ? JSON.stringify(value) : value;
    });
    const maybePromise = setPreferences(newUserPrefs, onComplete);
    if (!maybePromise) return;
    try {
        await maybePromise;
        setError(null);
        (0, $hh0bW.default)({
            ...$7fcdc9b72606be07$var$expAttributes,
            wasExperienceSuccesful: true
        });
        (0, $1bM8W.fireTrackEditedEvent)('dashboardGadgetEdit');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.forge', `${e.message} [${defaultTitle}]`);
        setError((0, $JIPqS.GADGET_ERROR_TYPE).CONFIG_ERROR);
        (0, $hh0bW.default)({
            ...$7fcdc9b72606be07$var$expAttributes,
            wasExperienceSuccesful: false
        });
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: (0, $JIPqS.SAVE_FORGE_GADGET_CONFIG_PREFERENCES),
                packageName: 'jiraDashboardInternalCommon'
            }
        });
        (0, $1bM8W.fireOperationalEditFailedEvent)('dashboardGadgetEdit', {
            error: e
        });
    }
};
// user prefs with a string value are encoded like "&quot;value&quot;" so we need to
// decode them for forge gadgets
const $7fcdc9b72606be07$var$decodeQuotes = (value)=>value.replace(/(?:&quot;)/gm, '"');
const $7fcdc9b72606be07$export$b5d9bfce42b49862 = (userPrefsFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedUserPrefs = {};
    if (userPrefsFields !== undefined) userPrefsFields.forEach((field)=>{
        if (field.name !== 'isConfigured') // the backend stringifies all configuration values,
        // we need to parse them here for forge gadgets
        transformedUserPrefs[field.name] = JSON.parse($7fcdc9b72606be07$var$decodeQuotes(field.value));
    });
    return transformedUserPrefs;
};

});


parcelRegister("k3y1k", function(module, exports) {

$parcel$export(module.exports, "InlineHtml", () => $4f214ca561897841$export$109427fbef437c1e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fNobW = parcelRequire("fNobW");

var $344pu = parcelRequire("344pu");

var $8UPoO = parcelRequire("8UPoO");

var $7vg9b = parcelRequire("7vg9b");
const $4f214ca561897841$export$109427fbef437c1e = ({ id: id, inlineHtml: inlineHtml, isLoading: isLoading, setIsLoading: setIsLoading })=>{
    const inlineHtmlRef = (0, $5uXOq.useRef)(null);
    const [hasIntroLogo, setHasIntroLogo] = (0, $5uXOq.useState)(false);
    (0, $7vg9b.useLinkInterceptor)(inlineHtmlRef.current, isLoading);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const slotHtml = document.createRange().createContextualFragment(inlineHtml);
        if (inlineHtmlRef.current) {
            inlineHtmlRef.current.innerHTML = '';
            inlineHtmlRef.current.appendChild(slotHtml);
            const introLogoElement = inlineHtmlRef.current.querySelector('.intro-logo');
            if (introLogoElement) setHasIntroLogo(true);
        }
        setIsLoading(false);
    }, [
        inlineHtml,
        setIsLoading
    ]);
    (0, $8UPoO.useOnGadgetRenderEffect)(id, inlineHtmlRef.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "inline-html-gadget",
        hold: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: hasIntroLogo && $4f214ca561897841$var$introStyles
    }, hasIntroLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $344pu.default), {
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: `gadget-${id}`,
        ref: inlineHtmlRef
    })));
};
const $4f214ca561897841$var$introStyles = (0, $8CUq3.xcss)({
    overflow: 'auto',
    height: '160px',
    display: 'flex',
    justifyContent: 'space-around',
    padding: 'space.200',
    gap: 'space.200'
});

});
parcelRegister("344pu", function(module, exports) {

$parcel$export(module.exports, "default", () => $031bf061693e3531$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $dCLgq = parcelRequire("dCLgq");

var $6EOSB = parcelRequire("6EOSB");
const $031bf061693e3531$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6EOSB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6EOSB))
});
var $031bf061693e3531$export$2e2bcd8739ae039 = $031bf061693e3531$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $031bf061693e3531$export$a179c88182cb9d56 = [
    0,
    0,
    431,
    406
];

});
parcelRegister("6EOSB", function(module, exports) {
module.exports = new URL("graph-go-up-with-people.4705ad58.svg", import.meta.url).toString();

});



parcelRegister("ce1BZ", function(module, exports) {

$parcel$export(module.exports, "ReactGadget", () => $e6dfd10c598d91ed$export$561f0f8350aca3ee);

var $5uXOq = parcelRequire("5uXOq");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $bVDE5 = parcelRequire("bVDE5");

var $4uQB7 = parcelRequire("4uQB7");

var $8FVKN = parcelRequire("8FVKN");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $kMe81 = parcelRequire("kMe81");
const $e6dfd10c598d91ed$var$expAttributes = {
    analyticsSource: 'dashboard',
    application: null,
    edition: null,
    additionalAttributes: {}
};
const $e6dfd10c598d91ed$export$561f0f8350aca3ee = ({ id: id, userPrefs: userPrefs, isInEditMode: isInEditMode, reactKey: reactKey, onEditModeCancel: onEditModeCancel, onRenderComplete: onRenderComplete, setDefaultTitle: setDefaultTitle, customSkeletonHeightInPx: customSkeletonHeightInPx })=>{
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const setPreferences = (0, $8FVKN.useGadgetSetPreferences)();
    const ref = (0, $5uXOq.useRef)(null);
    const isExperienceCompletedRef = (0, $5uXOq.useRef)(false);
    const { state: state, componentView: ComponentView, componentEdit: ComponentEdit, setState: setState } = (0, $kMe81.useReactGadgetState)(id, reactKey);
    const experienceKey = `${(0, $JIPqS.VIEW_REACT_GADGET_EXPERIENCE)}-${reactKey.split('/')[1]}`; // e.g. view-react-gadget-filter-results
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: isInEditMode ? 'Config' : 'View',
            source: (0, $5TsWX.REACT_GADGET_METRICS)
        }, {
            gadgetId: id,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        isInEditMode,
        id,
        currentPageId
    ]);
    const reportGadgetStart = (0, $5uXOq.useCallback)(()=>{
        reportGadgetMetrics((0, $5TsWX.GADGET_START_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const onGadgetFinish = (0, $5uXOq.useCallback)(// this API is not ideal, but a temporary solution to allow gadget to not save height to localStorage
    (shouldPersistHeight = true)=>{
        if (shouldPersistHeight) {
            const height = ref.current?.getBoundingClientRect().height;
            onRenderComplete(height);
        }
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDERING_FINISHED_EVENT));
        if (!isExperienceCompletedRef.current) {
            (0, $hh0bW.default)({
                ...$e6dfd10c598d91ed$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: true
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        reportGadgetMetrics,
        onRenderComplete,
        experienceKey
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
            id: id,
            errorType: (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR
        }), [
        id
    ]);
    const sendFailExperience = (0, $5uXOq.useCallback)(()=>{
        if (!isExperienceCompletedRef.current) {
            (0, $hh0bW.default)({
                ...$e6dfd10c598d91ed$var$expAttributes,
                experience: experienceKey,
                wasExperienceSuccesful: false
            });
            isExperienceCompletedRef.current = true;
        }
    }, [
        experienceKey
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // gadget container mounted event
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    const setGadgetContentTitle = (0, $5uXOq.useCallback)((contentTitle)=>{
        setDefaultTitle((initialDefaultTitle)=>contentTitle ? `${initialDefaultTitle}: ${contentTitle}` : initialDefaultTitle);
    }, [
        setDefaultTitle
    ]);
    const Component = isInEditMode ? ComponentEdit : ComponentView;
    if (state instanceof Error) {
        sendFailExperience();
        throw state;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: errorFallback,
        packageName: "jiraDashboardInternalCommon",
        id: reactKey,
        teamName: "endeavour",
        onError: sendFailExperience,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        setPreferences: setPreferences,
        state: state,
        onGadgetStart: reportGadgetStart,
        onGadgetFinish: onGadgetFinish,
        userPrefs: userPrefs,
        onEditModeCancel: onEditModeCancel,
        setState: setState,
        setGadgetContentTitle: setGadgetContentTitle,
        customSkeletonHeightInPx: customSkeletonHeightInPx
    })));
};

});
parcelRegister("kMe81", function(module, exports) {

$parcel$export(module.exports, "useReactGadgetState", () => $6bed3136adbdd754$export$8e5d1b52830d94a5);

var $5uXOq = parcelRequire("5uXOq");

var $kspzT = parcelRequire("kspzT");

var $gh1hi = parcelRequire("gh1hi");

var $iXzvf = parcelRequire("iXzvf");
const $6bed3136adbdd754$export$8e5d1b52830d94a5 = (id, reactKey)=>{
    const { data: data, update: update, loading: loading, error: error } = (0, $gh1hi.useDashboardReactGadgetsResource)();
    const reactGadgetsState = data?.reactGadgetsState ?? null;
    const state = (()=>{
        if (reactGadgetsState != null && id in reactGadgetsState) return reactGadgetsState[id];
        if (loading) return null;
        if (reactGadgetsState == null) return error ?? new Error('Gadget resource not initialised');
        return new Error(`Gadget state not found in initialised resource for gadget with reactKey: "${reactKey}" and ID: "${id}"`);
    })();
    const { componentView: componentView, componentEdit: componentEdit } = (0, $kspzT.default)[reactKey];
    const setState = (0, $5uXOq.useCallback)((setterOrValue)=>{
        if (reactGadgetsState && id in reactGadgetsState) update((0, $iXzvf.lensReactGadget)(id, setterOrValue));
    }, [
        update,
        reactGadgetsState,
        id
    ]);
    return {
        state: state,
        componentView: componentView,
        componentEdit: componentEdit,
        setState: setState
    };
};

});



parcelRegister("4ozF0", function(module, exports) {

$parcel$export(module.exports, "GadgetLayoutWithAnalytics", () => $a21461a35586ce8b$export$fbd1c75042cfdd67);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $4uQB7 = parcelRequire("4uQB7");

var $lE1Ya = parcelRequire("lE1Ya");

var $grY2f = parcelRequire("grY2f");
function $a21461a35586ce8b$export$fbd1c75042cfdd67({ gadgetData: gadgetData, isDisplayed: isDisplayed, header: header, isContentHidden: isContentHidden, customWrapperStyles: customWrapperStyles, children: children, footer: footer, customPlaceholder: customPlaceholder }) {
    const { id: id, color: color, title: title, errorMessage: errorMessage } = gadgetData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        objectType: "gadget",
        objectId: gadgetData.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "gadget",
        packageName: "jiraDashboardInternalCommon",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            isDisplayed ? $a21461a35586ce8b$var$wrapperStyles : $a21461a35586ce8b$var$gadgetNotDisplayedStyles,
            ...Array.isArray(customWrapperStyles) ? customWrapperStyles : [
                customWrapperStyles
            ],
            color && $a21461a35586ce8b$var$colorsMap[color]
        ],
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: `gadget-title-${id}`
    }, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-labelledby": `gadget-title-${id}`,
        id: `gadget-content-${id}`,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grY2f.GadgetBoundary), {
        data: gadgetData,
        isError: !title,
        errorFallback: errorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallbackBase), {
            id: id,
            message: errorMessage
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uQB7.GadgetErrorFallback), {
            id: id,
            errorType: !title ? (0, $JIPqS.GADGET_ERROR_TYPE).NOT_SUPPORTED_ERROR : (0, $JIPqS.GADGET_ERROR_TYPE).VIEW_ERROR
        }),
        customPlaceholder: customPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            isContentHidden ? $a21461a35586ce8b$var$contentHiddenStyles : $a21461a35586ce8b$var$contentStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lE1Ya.GadgetAnalyticsContainer), {
        data: gadgetData
    }, children), footer))))));
}
const $a21461a35586ce8b$var$wrapperStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderTopWidth: '4px',
    borderTopStyle: 'solid',
    borderRadius: 'border.radius.100',
    marginBottom: 'space.200',
    background: "var(--ds-surface-raised, #FFFFFF)",
    paddingInline: 'space.200',
    paddingBottom: 'space.200',
    position: 'relative',
    borderColor: 'color.border.brand'
});
const $a21461a35586ce8b$var$gadgetNotDisplayedStyles = (0, $8CUq3.xcss)({
    display: 'none'
});
const $a21461a35586ce8b$var$colorsMap = Object.fromEntries(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore-next-line The borderColor value isn't a valid token
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
Object.entries((0, $JIPqS.COLOR_MAP)).map(([key, value])=>[
        key,
        (0, $8CUq3.xcss)({
            borderColor: value
        })
    ]));
const $a21461a35586ce8b$var$contentStyles = (0, $8CUq3.xcss)({
    overflowWrap: 'anywhere'
});
const $a21461a35586ce8b$var$contentHiddenStyles = (0, $8CUq3.xcss)({
    display: 'none'
});

});
parcelRegister("lE1Ya", function(module, exports) {

$parcel$export(module.exports, "GadgetAnalyticsContainer", () => $8dd46ecf3ec4fed0$export$33d5cbc3e6507749);

var $5uXOq = parcelRequire("5uXOq");

var $bOnpg = parcelRequire("bOnpg");

var $3Wusa = parcelRequire("3Wusa");
const $8dd46ecf3ec4fed0$export$33250e472f9e12c2 = 4840;
const $8dd46ecf3ec4fed0$export$33d5cbc3e6507749 = ({ data: data, children: children })=>{
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const eventSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (data !== null && eventSent.current === false) {
            fireAnalytics({
                ...(0, $3Wusa.getGadgetAnalyticsProps)(data),
                action: 'viewed'
            });
            eventSent.current = true;
        }
    }, [
        data,
        fireAnalytics
    ]);
    if (!data) return null;
    if (data.renderedGadgetUrl != null && data.renderedGadgetUrl.length > $8dd46ecf3ec4fed0$export$33250e472f9e12c2) {
        if (eventSent.current === false) {
            fireAnalytics({
                ...(0, $3Wusa.getGadgetAnalyticsProps)(data),
                action: 'viewedFailed'
            });
            eventSent.current = true;
        }
        throw new Error('Request header is too large');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("3Wusa", function(module, exports) {

$parcel$export(module.exports, "getGadgetAnalyticsProps", () => $ad3242df71f39677$export$42d88d3ece4aff0);


var $kspzT = parcelRequire("kspzT");
const $ad3242df71f39677$export$42d88d3ece4aff0 = (data)=>{
    let gadgetType = 'UNKNOWN_GADGET';
    if (data.amdModule != null) gadgetType = data.amdModule;
    else if (data.forge != null) gadgetType = data.forge.key;
    else if ((0, $kspzT.isReactKey)(data.reactKey)) gadgetType = data.reactKey;
    return {
        eventType: (0, $4d5e0871c06cee03$export$947dac6c72b26f81),
        actionSubjectId: 'gadget',
        actionSubject: 'gadget',
        attributes: {
            gadgetTitle: data.title,
            gadgetType: gadgetType
        }
    };
};

});


parcelRegister("grY2f", function(module, exports) {

$parcel$export(module.exports, "GadgetBoundary", () => $4828aa186ac8828a$export$9327e9e817f0323d);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $c1XZn = parcelRequire("c1XZn");

var $8UPoO = parcelRequire("8UPoO");

var $8FVKN = parcelRequire("8FVKN");
const $4828aa186ac8828a$export$9327e9e817f0323d = ({ data: data, errorFallback: errorFallback, customPlaceholder: customPlaceholder, isError: isError, children: children })=>{
    const { id: id } = data;
    const renderKey = (0, $8FVKN.useGadgetRenderKey)();
    const shouldRender = (0, $8UPoO.useShouldRenderGadget)(id);
    const renderFallback = (0, $5uXOq.useCallback)(()=>errorFallback, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "gadget-content",
        packageName: "jiraDashboardInternalCommon",
        fallback: renderFallback
    }, (()=>{
        if (isError) return errorFallback;
        if (customPlaceholder) return customPlaceholder;
        if (!shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1XZn.SkeletonGadgetContent), {
            customHeight: `${(0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`,
            isPulsing: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: renderKey
        }, children);
    })());
};

});


parcelRegister("j3C3s", function(module, exports) {

$parcel$export(module.exports, "GadgetTitleWrapper", () => $41769e611e2b6e1f$export$88d654f5e42c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $41769e611e2b6e1f$export$88d654f5e42c4cf({ isRenaming: isRenaming, children: children, id: id }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $41769e611e2b6e1f$var$titleStyles,
            isRenaming && $41769e611e2b6e1f$var$titleRenamingStyles
        ],
        id: id
    }, children);
}
const $41769e611e2b6e1f$var$titleStyles = (0, $8CUq3.xcss)({
    minHeight: "var(--ds-space-250, 20px)",
    flexGrow: 1,
    minWidth: '0',
    paddingBlock: 'space.200',
    paddingRight: 'space.100',
    wordBreak: 'break-word',
    marginRight: 'space.200'
});
const $41769e611e2b6e1f$var$titleRenamingStyles = (0, $8CUq3.xcss)({
    cursor: 'text'
});

});

parcelRegister("gFWXX", function(module, exports) {

$parcel$export(module.exports, "TitleReadOnly", () => $dc1e643a17c4a39f$export$10ece9f949c62d6e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $3bDjY = parcelRequire("3bDjY");

var $h0JHu = parcelRequire("h0JHu");

var $hDzhb = parcelRequire("hDzhb");

var $6hp8I = parcelRequire("6hp8I");
const $dc1e643a17c4a39f$var$TitleInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey }, ref)=>{
    const displayTitle = forgeEnvironment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
        extensionEnvType: forgeEnvironment,
        extensionEnvKey: forgeEnvironmentKey,
        extensionName: title
    }) : title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2",
        testId: "dashboard-internal-common.ui.gadget.title-readonly.title-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$HeaderTextWrapper, {
        ref: ref
    }, titleUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        href: titleUrl
    }, displayTitle) : displayTitle));
});
const $dc1e643a17c4a39f$export$10ece9f949c62d6e = ({ title: title, titleUrl: titleUrl, forgeEnvironment: forgeEnvironment, forgeEnvironmentKey: forgeEnvironmentKey })=>{
    const dimensions = (0, $6hp8I.useDimensions)();
    const ref = (0, $5uXOq.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current == null) return;
        const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = ref.current;
        const shouldShowTooltip = offsetWidth < scrollWidth;
        if (showTooltip !== shouldShowTooltip) setShowTooltip(shouldShowTooltip);
    }, [
        dimensions,
        showTooltip
    ]);
    const tooltipContent = (0, $5uXOq.useMemo)(()=>{
        if (showTooltip) return forgeEnvironment ? `${title} (${forgeEnvironment})` : title;
        return null;
    }, [
        showTooltip,
        forgeEnvironment,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc1e643a17c4a39f$var$TitleInner, {
        title: title,
        ref: ref,
        titleUrl: titleUrl,
        forgeEnvironment: forgeEnvironment,
        forgeEnvironmentKey: forgeEnvironmentKey
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc1e643a17c4a39f$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $dc1e643a17c4a39f$var$HeaderTextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkidpf _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1yhBH", function(module, exports) {

$parcel$export(module.exports, "GadgetToolbar", () => $5fcf8ae904c6c9b8$export$bef5bd636ffcc29c);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $gE1Ym = parcelRequire("gE1Ym");

var $4h1Pq = parcelRequire("4h1Pq");

var $5JpK2 = parcelRequire("5JpK2");

var $jOrGg = parcelRequire("jOrGg");

var $j2iKG = parcelRequire("j2iKG");

var $kgoHi = parcelRequire("kgoHi");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");


var $bOnpg = parcelRequire("bOnpg");

var $8FVKN = parcelRequire("8FVKN");

var $7K2Ba = parcelRequire("7K2Ba");
function $5fcf8ae904c6c9b8$export$bef5bd636ffcc29c({ gadgetId: gadgetId, title: title, onMinimizeOrRestore: onMinimizeOrRestore, isMinimized: isMinimized, isMaximizable: isMaximizable, onMaximizeOrRestore: onMaximizeOrRestore, isMaximized: isMaximized, additionalToolbarItems: additionalToolbarItems }) {
    const onRefresh = (0, $8FVKN.useGadgetRefresh)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        onClick: ()=>onMinimizeOrRestore(!isMinimized),
        action: "minimize-restore-button",
        tooltipMessageKey: (0, $7K2Ba.default)[isMinimized ? 'expand' : 'minimize'],
        ariaLabelMessageKey: (0, $7K2Ba.default)[isMinimized ? 'expandAriaLabel' : 'minimizeAriaLabel'],
        gadgetName: title,
        gadgetId: gadgetId,
        icon: isMinimized ? (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))) : (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG)))
    }), isMaximizable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        onClick: ()=>onMaximizeOrRestore(!isMaximized),
        action: "maximize-restore-button",
        tooltipMessageKey: (0, $7K2Ba.default)[isMaximized ? 'singleColumn' : 'maximize'],
        ariaLabelMessageKey: (0, $7K2Ba.default)[isMaximized ? 'singleColumn' : 'maximizeAriaLabel'],
        gadgetId: gadgetId,
        gadgetName: title,
        icon: isMaximized ? (0, (/*@__PURE__*/$parcel$interopDefault($4h1Pq))) : (0, (/*@__PURE__*/$parcel$interopDefault($gE1Ym)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fcf8ae904c6c9b8$export$266a769812832828, {
        gadgetId: gadgetId,
        onClick: onRefresh,
        action: "refresh-button",
        tooltipMessageKey: (0, $7K2Ba.default).refresh,
        ariaLabelMessageKey: (0, $7K2Ba.default).refreshAriaLabel,
        gadgetName: title,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jOrGg)))
    }), additionalToolbarItems);
}
const $5fcf8ae904c6c9b8$export$266a769812832828 = ({ gadgetId: gadgetId, onClick: onClick, action: action, tooltipMessageKey: tooltipMessageKey, ariaLabelMessageKey: ariaLabelMessageKey, gadgetName: gadgetName, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const onClickHandler = ()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubject: `gadget.${action}`,
            action: 'clicked',
            actionSubjectId: 'gadget'
        });
        onClick();
    };
    const tooltipContent = formatMessage(tooltipMessageKey);
    const ariaLabel = formatMessage(ariaLabelMessageKey, {
        gadgetName: gadgetName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "default",
        label: ariaLabel,
        onClick: onClickHandler,
        icon: icon,
        testId: `dashboard-internal-common.ui.gadget.toolbar.${action}`,
        "aria-controls": `gadget-content-${gadgetId}`
    }));
};

});
parcelRegister("gE1Ym", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c924d7aa97536feacf0cc0682b2e7ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1e1e97b4a9cecff$var$_react = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c1e1e97b4a9cecff$var$_fullscreenEnter = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("5C3Gx")));

var $c1e1e97b4a9cecff$var$_vidFullScreenOn = $c1e1e97b4a9cecff$var$_interopRequireDefault((parcelRequire("1Lys5")));
function $c1e1e97b4a9cecff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FullscreenEnterIcon.
 * This component is FullscreenEnterIcon, with `UNSAFE_fallbackIcon` set to "VidFullScreenOnIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1e1e97b4a9cecff$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $c1e1e97b4a9cecff$var$_react.default.createElement($c1e1e97b4a9cecff$var$_fullscreenEnter.default, Object.assign({
        LEGACY_fallbackIcon: $c1e1e97b4a9cecff$var$_vidFullScreenOn.default
    }, props));
$c1e1e97b4a9cecff$var$FullscreenEnterIcon.Name = 'FullscreenEnterIconMigration';
var $c1e1e97b4a9cecff$var$_default = module.exports.default = $c1e1e97b4a9cecff$var$FullscreenEnterIcon;

});
parcelRegister("5C3Gx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac50bcefc684eb6ed2a48092f1a2b091>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41635c272d6a179a$var$_react = $41635c272d6a179a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $41635c272d6a179a$var$_baseNew = $41635c272d6a179a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $41635c272d6a179a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41635c272d6a179a$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $41635c272d6a179a$var$_react.default.createElement($41635c272d6a179a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 6V3c0-.69.56-1.25 1.25-1.25h3M14.25 10v3c0 .69-.56 1.25-1.25 1.25h-3m0-12.5h3c.69 0 1.25.56 1.25 1.25v3M6 14.25H3c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$41635c272d6a179a$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $41635c272d6a179a$var$_default = module.exports.default = $41635c272d6a179a$var$FullscreenEnterIcon;

});

parcelRegister("1Lys5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1494e7af70bbd024$var$_react = $1494e7af70bbd024$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1494e7af70bbd024$var$_fullscreenEnter = $1494e7af70bbd024$var$_interopRequireDefault((parcelRequire("5C3Gx")));
function $1494e7af70bbd024$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1494e7af70bbd024$var$VidFullScreenOnIcon = (props)=>/*#__PURE__*/ $1494e7af70bbd024$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2M6 4h3a1 1 0 1 1 0 2H6v3a1 1 0 1 1-2 0V6a2 2 0 0 1 2-2m12 2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $1494e7af70bbd024$var$_fullscreenEnter.default
    }));
$1494e7af70bbd024$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var $1494e7af70bbd024$var$_default = module.exports.default = $1494e7af70bbd024$var$VidFullScreenOnIcon;

});


parcelRegister("4h1Pq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e159e576acb01648bbd8ed46b8160907>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ca2b071cc9d641$var$_react = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ca2b071cc9d641$var$_fullscreenExit = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("g5bVM")));

var $31ca2b071cc9d641$var$_fullScreen = $31ca2b071cc9d641$var$_interopRequireDefault((parcelRequire("aU3Qy")));
function $31ca2b071cc9d641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FullscreenExitIcon.
 * This component is FullscreenExitIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFullScreenIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ca2b071cc9d641$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $31ca2b071cc9d641$var$_react.default.createElement($31ca2b071cc9d641$var$_fullscreenExit.default, Object.assign({
        LEGACY_fallbackIcon: $31ca2b071cc9d641$var$_fullScreen.default
    }, props));
$31ca2b071cc9d641$var$FullscreenExitIcon.Name = 'FullscreenExitIconMigration';
var $31ca2b071cc9d641$var$_default = module.exports.default = $31ca2b071cc9d641$var$FullscreenExitIcon;

});
parcelRegister("g5bVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16bf7b47fe54b9591579ece4deccf414>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb565e37400efb63$var$_react = $bb565e37400efb63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb565e37400efb63$var$_baseNew = $bb565e37400efb63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bb565e37400efb63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FullscreenExit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for return screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb565e37400efb63$var$FullscreenExitIcon = (props)=>/*#__PURE__*/ $bb565e37400efb63$var$_react.default.createElement($bb565e37400efb63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.25 1v3c0 .69-.56 1.25-1.25 1.25H1M10.75 15v-3c0-.69.56-1.25 1.25-1.25h3m0-5.5h-3c-.69 0-1.25-.56-1.25-1.25V1M1 10.75h3c.69 0 1.25.56 1.25 1.25v3"/>`
    }, props));
$bb565e37400efb63$var$FullscreenExitIcon.displayName = 'FullscreenExitIcon';
var $bb565e37400efb63$var$_default = module.exports.default = $bb565e37400efb63$var$FullscreenExitIcon;

});

parcelRegister("aU3Qy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f021e30f8edd1a3$var$_react = $7f021e30f8edd1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7f021e30f8edd1a3$var$_fullscreenExit = $7f021e30f8edd1a3$var$_interopRequireDefault((parcelRequire("g5bVM")));
function $7f021e30f8edd1a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f021e30f8edd1a3$var$MediaServicesFullScreenIcon = (props)=>/*#__PURE__*/ $7f021e30f8edd1a3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 8h3a1 1 0 0 1 0 2h-3a2 2 0 0 1-2-2V5a1 1 0 0 1 2 0zm-8 2H5a1 1 0 1 1 0-2h3V5a1 1 0 1 1 2 0v3a2 2 0 0 1-2 2m8 4h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3a2 2 0 0 1 2-2m-8 2H5a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0z"/></svg>`
    }, props, {
        newIcon: $7f021e30f8edd1a3$var$_fullscreenExit.default
    }));
$7f021e30f8edd1a3$var$MediaServicesFullScreenIcon.displayName = 'MediaServicesFullScreenIcon';
var $7f021e30f8edd1a3$var$_default = module.exports.default = $7f021e30f8edd1a3$var$MediaServicesFullScreenIcon;

});


parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});

parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e8917d3a5aac4b99b0f55b24958842a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7ed6beb9fac025198bce90a008b6791>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 1.75c2 0 5.75 2.125 5.75 6.25s-4.24 6.24-4.24 6.24m-2.51.01c-2 0-5.75-2.125-5.75-6.25s4.26-6.26 4.26-6.26m.24 3.76V1.25H2m7.75 9.23v4.25H14"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("j2iKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b2e8bb6e01e7e0a7a6c4696ef5279cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
    }, props));
$ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;

});

parcelRegister("7K2Ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d16755660d37c6c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9d16755660d37c6c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    minimize: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.minimize-aria-label",
        "defaultMessage": "Minimize {gadgetName}"
    },
    expand: {
        "id": "dashboard-internal-common.gadget.toolbar.expand",
        "defaultMessage": "Expand"
    },
    expandAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.expand-aria-label",
        "defaultMessage": "Expand {gadgetName}"
    },
    maximize: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize",
        "defaultMessage": "Maximize"
    },
    maximizeAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.maximize-aria-label",
        "defaultMessage": "Maximize {gadgetName}"
    },
    refresh: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh",
        "defaultMessage": "Refresh"
    },
    refreshAriaLabel: {
        "id": "dashboard-internal-common.gadget.toolbar.refresh-aria-label",
        "defaultMessage": "Refresh {gadgetName}"
    },
    singleColumn: {
        "id": "dashboard-internal-common.gadget.toolbar.single-column",
        "defaultMessage": "Single column"
    }
});

});


parcelRegister("iIi7d", function(module, exports) {

$parcel$export(module.exports, "LastRefreshed", () => $64481a9700f86c7d$export$66aab1cf9cd737cc);

var $5uXOq = parcelRequire("5uXOq");

var $jOrGg = parcelRequire("jOrGg");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $9OXo1 = parcelRequire("9OXo1");

var $8hIHC = parcelRequire("8hIHC");
const $64481a9700f86c7d$export$66aab1cf9cd737cc = ({ lastRefreshed: lastRefreshed, updateInterval: updateInterval })=>{
    const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = (0, $5uXOq.useState)('');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { locale: locale } = (0, $9OXo1.useTenantContext)();
    (0, $5uXOq.useEffect)(()=>{
        setLastRefreshedTimeAgo(formatMessage((0, $8hIHC.default).justNow));
        const refreshInterval = setInterval(()=>lastRefreshed != null && setLastRefreshedTimeAgo(formatMessage((0, $8hIHC.default).timeAgo, {
                timeAgo: (0, $1p96B.formatDistanceStrictWithLocale)(lastRefreshed, new Date(), locale)
            })), updateInterval);
        return ()=>clearInterval(refreshInterval);
    }, [
        formatMessage,
        lastRefreshed,
        locale,
        updateInterval
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        alignItems: "center",
        xcss: $64481a9700f86c7d$var$lastRefreshedWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
        LEGACY_size: "small",
        label: formatMessage((0, $8hIHC.default).lastRefreshedIcon)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        color: "color.text.subtle"
    }, lastRefreshedTimeAgo));
};
const $64481a9700f86c7d$var$lastRefreshedWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    color: 'color.text.subtle',
    gap: 'space.050'
});

});
parcelRegister("8hIHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afac6d64be9e0b6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3afac6d64be9e0b6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    justNow: {
        "id": "dashboard-internal-common.last-refreshed.just-now",
        "defaultMessage": "Just now"
    },
    timeAgo: {
        "id": "dashboard-internal-common.last-refreshed.time-ago",
        "defaultMessage": "{timeAgo} ago"
    },
    lastRefreshedIcon: {
        "id": "dashboard-internal-common.last-refreshed.last-refreshed-icon",
        "defaultMessage": "Last refreshed"
    }
});

});



parcelRegister("32zIt", function(module, exports) {

$parcel$export(module.exports, "HeaderReadOnly", () => $69498a7fcd5bdf10$export$a00d46171b6c3f6a);

var $5uXOq = parcelRequire("5uXOq");

var $1ywCO = parcelRequire("1ywCO");

var $JIPqS = parcelRequire("JIPqS");

var $bOnpg = parcelRequire("bOnpg");

var $gYYRR = parcelRequire("gYYRR");

var $dZymr = parcelRequire("dZymr");

var $1i27D = parcelRequire("1i27D");

var $2PcTT = parcelRequire("2PcTT");

var $lWWbJ = parcelRequire("lWWbJ");

var $9jsHG = parcelRequire("9jsHG");

var $aNPat = parcelRequire("aNPat");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");


var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $2zwcE = parcelRequire("2zwcE");

var $kC29b = parcelRequire("kC29b");
const $69498a7fcd5bdf10$export$a00d46171b6c3f6a = ({ data: data, isEditLinkEnabled: isEditLinkEnabled, banners: banners })=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { isAnonymous: isAnonymous } = tenantContext;
    const { id: id, title: title, systemDashboard: systemDashboard } = data;
    const { headerItems: headerItems, toolItems: toolItems } = (0, $2PcTT.useConnectMenuItems)(id);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const editRoute = (0, $6jY6G.useRouteByName)(systemDashboard ? 'system-dashboard-edit' : 'dashboard-edit');
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.edit-button',
            actionSubjectId: (0, $JIPqS.DASHBOARD_VIEW_SOURCENAME)
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.Header), {
        banners: banners
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.HeaderTitle), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1i27D.HeaderActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZymr.ConnectHeader), {
        items: headerItems
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9jsHG.FavoriteButton), {
        dashboardId: id,
        dashboardName: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zwcE.HeaderCopyLinkButton), {
        dashboardId: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWWbJ.DashboardRefreshButton), null), isEditLinkEnabled && (editRoute && (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNPat.RouteLinkButton), {
        to: editRoute,
        params: {
            dashboardId: id
        },
        onClick: onClickHandler,
        testId: "dashboard-view.ui.header-readonly.dashboard-edit-button",
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($1ywCO)))
    }, formatMessage((0, $kC29b.default).edit)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNPat.RouteLinkButtonOld), {
        to: editRoute ?? undefined,
        params: {
            dashboardId: id
        },
        prefetch: "hover",
        onClick: onClickHandler,
        testId: "dashboard-view.ui.header-readonly.dashboard-edit-button",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ywCO))), {
            label: "",
            LEGACY_size: "small",
            color: "currentColor"
        })
    }, formatMessage((0, $kC29b.default).edit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYYRR.ActionDropdown), {
        data: data,
        connectToolMenuItems: toolItems
    })));
};

});
parcelRegister("1ywCO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f1499f88a5a9b0ec5069c962ed12d1a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122246161208ff48$var$_react = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $122246161208ff48$var$_edit = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $122246161208ff48$var$_editFilled = $122246161208ff48$var$_interopRequireDefault((parcelRequire("avBcG")));
function $122246161208ff48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $122246161208ff48$var$EditIcon = (props)=>/*#__PURE__*/ $122246161208ff48$var$_react.default.createElement($122246161208ff48$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $122246161208ff48$var$_editFilled.default
    }, props));
$122246161208ff48$var$EditIcon.Name = 'EditIconMigration';
var $122246161208ff48$var$_default = module.exports.default = $122246161208ff48$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df0e46d6520ed0b12c088820aa4dca0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("avBcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a69a877f42e31b8$var$_react = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7a69a877f42e31b8$var$_edit = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $7a69a877f42e31b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a69a877f42e31b8$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7a69a877f42e31b8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $7a69a877f42e31b8$var$_edit.default
    }));
$7a69a877f42e31b8$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $7a69a877f42e31b8$var$_default = module.exports.default = $7a69a877f42e31b8$var$EditFilledIcon;

});


parcelRegister("gYYRR", function(module, exports) {

$parcel$export(module.exports, "ActionDropdown", () => $255b9987b473f48f$export$d5503927a7d116d);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $fP8bU = parcelRequire("fP8bU");

var $9UCCQ = parcelRequire("9UCCQ");

var $JIPqS = parcelRequire("JIPqS");

var $koVbs = parcelRequire("koVbs");

var $e9QkH = parcelRequire("e9QkH");

var $9OXo1 = parcelRequire("9OXo1");

var $b8ziP = parcelRequire("b8ziP");

var $edp7U = parcelRequire("edp7U");

var $dFiez = parcelRequire("dFiez");

var $2h3Nr = parcelRequire("2h3Nr");

var $fb7AH = parcelRequire("fb7AH");

var $fqLvm = parcelRequire("fqLvm");

var $2IJzF = parcelRequire("2IJzF");

var $8AXqQ = parcelRequire("8AXqQ");

var $2EGKG = parcelRequire("2EGKG");

var $x5bVw = parcelRequire("x5bVw");
const $255b9987b473f48f$export$d5503927a7d116d = ({ data: data, connectToolMenuItems: connectToolMenuItems })=>{
    const { isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $b8ziP.useDropdownItemOnClickHandler)();
    const dropdownTriggerButton = (0, $5uXOq.useRef)(null);
    const [, { on: modalCopyOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_COPY);
    const [, { on: modalAutomaticRefreshOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).AUTOMATIC_REFRESH);
    const [, { on: modalRenameAndShareOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const [, { on: modalDeleteOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_DELETE);
    const [, { on: modalCreateOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_CREATE);
    // This is a hack to focus the trigger button after a modal is closed.
    const onModalCloseCallback = (0, $5uXOq.useCallback)(()=>{
        setTimeout(()=>{
            if (dropdownTriggerButton.current) dropdownTriggerButton.current.focus();
        }, 1);
    }, [
        dropdownTriggerButton
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!data) return null;
    const dashboardId = data.id;
    const isDashboardOwner = atlassianAccountId === data.owner;
    const viewAsWallboardUrl = `/jira/dashboards/wallboard?dashboardId=${dashboardId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EGKG.RenameOrShareModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqLvm.CopyModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2h3Nr.AutomaticRefreshModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AXqQ.DeleteModal), {
        id: dashboardId,
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fb7AH.ConfigureWallboardModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2IJzF.CreateModal), {
        onModalCloseCallback: onModalCloseCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fP8bU))), {
                    label: formatMessage((0, $dFiez.default).moreActions),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                // To utilise this `ref` for a custom trigger button, only `triggerRef` needs to be the value passed in.
                // However, we've defined a function instead so we can save the ref locally
                // and focus it when modal closes
                ref: (buttonRef)=>{
                    // This is the default call if only `triggerRef` gets passed in. We still call it.
                    if (typeof triggerRef === 'function') triggerRef(buttonRef);
                    // This is a hack so we can focus this button after a modal is closed.
                    if (dropdownTriggerButton.current === null) dropdownTriggerButton.current = buttonRef;
                }
            }),
        shouldFlip: true,
        placement: "bottom-end",
        appearance: "tall",
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dropdown-menu",
        defaultOpen: (0, $edp7U.getIsDropdownDefaultOpen)('action-dropdown'),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: data.title
    }, data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.rename-and-share",
        onClick: modalRenameAndShareOpen
    }, formatMessage(data.systemDashboard ? (0, $dFiez.default).share : (0, $dFiez.default).renameOrShare)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.copy",
        onClick: modalCopyOpen
    }, formatMessage((0, $dFiez.default).copy)), data.writable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.automatic-refresh",
        onClick: modalAutomaticRefreshOpen
    }, formatMessage((0, $dFiez.default).automaticRefresh)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard",
        href: viewAsWallboardUrl,
        onClick: (e)=>dropdownItemClickHandler(e, viewAsWallboardUrl, 'dashboard.view-as-wallboard-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $dFiez.default).wallboard)), isDashboardOwner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.delete",
        onClick: modalDeleteOpen
    }, formatMessage((0, $dFiez.default).moveToTrash)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $x5bVw.WallboardSlideshow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.create",
        onClick: modalCreateOpen
    }, formatMessage((0, $dFiez.default).create)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.find",
        href: "/jira/dashboards"
    }, formatMessage((0, $dFiez.default).find))), connectToolMenuItems && connectToolMenuItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        testId: "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.dashboard-connect-menu-items",
        hasSeparator: true
    }, connectToolMenuItems.map(({ id: id, title: title, url: url, styleClass: styleClass })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            key: id,
            href: url,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            id: id,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass
        }, title)))) : null));
};

});
parcelRegister("fP8bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a891fd110ee4182af0e750dcafdf7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b851f9035a4ffaf9$var$_react = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b851f9035a4ffaf9$var$_showMoreHorizontal = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $b851f9035a4ffaf9$var$_more = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("6qrUW")));
function $b851f9035a4ffaf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b851f9035a4ffaf9$var$_react.default.createElement($b851f9035a4ffaf9$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b851f9035a4ffaf9$var$_more.default
    }, props));
$b851f9035a4ffaf9$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $b851f9035a4ffaf9$var$_default = module.exports.default = $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon;

});
parcelRegister("6qrUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4adad3971ebc70ba$var$_react = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4adad3971ebc70ba$var$_showMoreHorizontal = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("8U6zd")));
function $4adad3971ebc70ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4adad3971ebc70ba$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $4adad3971ebc70ba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $4adad3971ebc70ba$var$_showMoreHorizontal.default
    }));
$4adad3971ebc70ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $4adad3971ebc70ba$var$_default = module.exports.default = $4adad3971ebc70ba$var$EditorMoreIcon;

});


parcelRegister("b8ziP", function(module, exports) {

$parcel$export(module.exports, "useDropdownItemOnClickHandler", () => $7f06fd4fc0d36f11$export$b9ed61ea9e46f071);


var $lVJAU = parcelRequire("lVJAU");

var $bOnpg = parcelRequire("bOnpg");

var $cdUgf = parcelRequire("cdUgf");
const $7f06fd4fc0d36f11$export$b9ed61ea9e46f071 = ()=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const dropdownItemClickHandler = (e, url, actionSubject)=>{
        if (actionSubject) fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubject: actionSubject,
            action: 'clicked',
            actionSubjectId: 'dashboard'
        });
        if (!(0, $cdUgf.clickedWithShortcutKeys)(e)) {
            e.preventDefault();
            push(url);
        }
    };
    return {
        dropdownItemClickHandler: dropdownItemClickHandler
    };
};

});

parcelRegister("edp7U", function(module, exports) {

$parcel$export(module.exports, "getIsDropdownDefaultOpen", () => $dad419d0b39d4c21$export$638abbdcabd86e67);
/**
 * NOTE - this is to assist with VR tests so we can easily di the value for the
 * dropdowns to be opened.
 * @param _ name of your component
 * @returns false in production code
 */ const $dad419d0b39d4c21$export$638abbdcabd86e67 = (_)=>false;

});

parcelRegister("dFiez", function(module, exports) {

$parcel$export(module.exports, "default", () => $172a2c76e18069ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $172a2c76e18069ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.more-actions",
        "defaultMessage": "More dashboard actions"
    },
    copy: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.copy",
        "defaultMessage": "Copy"
    },
    automaticRefresh: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.automatic-refresh",
        "defaultMessage": "Configure automatic refresh"
    },
    renameOrShare: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.rename-or-share",
        "defaultMessage": "Rename or share"
    },
    share: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.share",
        "defaultMessage": "Share dashboard"
    },
    moveToTrash: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.move-to-trash",
        "defaultMessage": "Move to trash"
    },
    find: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.find",
        "defaultMessage": "View all dashboards"
    },
    create: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.create",
        "defaultMessage": "Create a dashboard"
    },
    wallboard: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard",
        "defaultMessage": "View as wallboard"
    }
});

});

parcelRegister("2h3Nr", function(module, exports) {

$parcel$export(module.exports, "AutomaticRefreshModal", () => $de8465027ccce40b$export$47f35766b426b3bc);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $kxZPA = parcelRequire("kxZPA");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $de8465027ccce40b$var$LazyDashboardModal = (0, $kxZPA.lazy)(()=>(parcelRequire("f9y6M")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/automatic-refresh-modal/main.tsx"
});
const $de8465027ccce40b$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $de8465027ccce40b$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$de8465027ccce40b$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $de8465027ccce40b$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$de8465027ccce40b$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $de8465027ccce40b$export$47f35766b426b3bc = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).AUTOMATIC_REFRESH);
    const onFailed = (err)=>{
        const error = err || new Error('automatic refresh modal configuration failed.');
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $de8465027ccce40b$var$sendSuccessExperience,
            sendFailedExperience: $de8465027ccce40b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$de8465027ccce40b$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    const onClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de8465027ccce40b$var$LazyDashboardModal, {
        id: id,
        onClose: onClose,
        onSuccess: $de8465027ccce40b$var$sendSuccessExperience,
        onCancel: onCancel,
        onFailed: onFailed
    }))) : null;
};

});
parcelRegister("iLC4C", function(module, exports) {

$parcel$export(module.exports, "handleFetchErrorAsExperience", () => $10506a1bb5cb99af$export$8b2399c5090eddc3);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");
const $10506a1bb5cb99af$export$65e55894e6e38a89 = 'client network error';
const $10506a1bb5cb99af$export$796b9e0e5da90309 = 'unauthenticated (401)';
const $10506a1bb5cb99af$export$8b2399c5090eddc3 = ({ error: error, sendSuccessExperience: sendSuccessExperience, sendFailedExperience: sendFailedExperience, logErrorEvent: logErrorEvent })=>{
    if ((0, $fZneA.isClientFetchError)(error)) {
        sendSuccessExperience();
        logErrorEvent($10506a1bb5cb99af$export$65e55894e6e38a89);
    } else if (error instanceof (0, $jJZqs.default) && error.constructor === (0, $jJZqs.default)) {
        const errorCode = Number(error.message.substring(error.message.length - 3));
        if (errorCode === 304) // 304 response cached
        sendSuccessExperience();
        else if (errorCode === 401) // 401 user unauthenticated, neither success nor fail
        logErrorEvent($10506a1bb5cb99af$export$796b9e0e5da90309);
        else {
            sendFailedExperience();
            logErrorEvent(`${errorCode} status code response`);
        }
    } else {
        // in the case of Error, SyntaxError and ValidationError(400);
        sendFailedExperience();
        logErrorEvent();
    }
};

});

parcelRegister("89bLT", function(module, exports) {

$parcel$export(module.exports, "logErrorEventFunc", () => $98efc897ec5a605f$export$e315c4152a211ba8);

var $jcw0u = parcelRequire("jcw0u");
const $98efc897ec5a605f$export$e315c4152a211ba8 = (error, eventId)=>(reason)=>{
        if (error != null) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: eventId,
                packageName: 'jiraDashboardInternalCommon'
            },
            attributes: {
                reason: reason
            }
        });
    };

});

parcelRegister("f9y6M", function(module, exports) {

let $b082277b31741638$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b082277b31741638$var$load("6Fl1t").then(()=>parcelRequire('eIgK0'));

});


parcelRegister("fb7AH", function(module, exports) {

$parcel$export(module.exports, "ConfigureWallboardModal", () => $c591fac53db599f8$export$cf7e06d150dcce6d);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c591fac53db599f8$var$LazyDashboardModal = (0, $kxZPA.lazy)(()=>(parcelRequire("ftVpm")), {
    moduleId: "./src/packages/global-pages/dashboard/internal-common/src/ui/dashboard-content/header/action-dropdown/modals/configure-wallboard-modal/modal/index.tsx"
});
const $c591fac53db599f8$export$cf7e06d150dcce6d = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).CONFIGURE_WALLBOARD);
    const onModalClose = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "configure-wallboard-modal",
        packageName: "dashboard",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c591fac53db599f8$var$LazyDashboardModal, {
        onClose: onModalClose
    }))) : null;
};

});
parcelRegister("ftVpm", function(module, exports) {

let $b456187c119e0ad1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b456187c119e0ad1$var$load("1ftQg").then(()=>parcelRequire('iFntg'));

});


parcelRegister("fqLvm", function(module, exports) {

$parcel$export(module.exports, "CopyModal", () => $6aa3f9a2fe12b1cd$export$4a7ddad8989462fb);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $34Vv8 = parcelRequire("34Vv8");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $kxZPA = parcelRequire("kxZPA");

var $lVJAU = parcelRequire("lVJAU");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

const $6aa3f9a2fe12b1cd$var$LazyDashboardModal = (0, $34Vv8.default)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazy)(()=>(parcelRequire("dxWhV")).then(({ CopyDashboardModal: CopyDashboardModal })=>CopyDashboardModal), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
}));
const $6aa3f9a2fe12b1cd$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $6aa3f9a2fe12b1cd$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$6aa3f9a2fe12b1cd$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $6aa3f9a2fe12b1cd$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$6aa3f9a2fe12b1cd$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $6aa3f9a2fe12b1cd$export$bdd968b8df213d5c = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_COPY);
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (_, response)=>{
        $6aa3f9a2fe12b1cd$var$sendSuccessExperience();
        close();
        if (response.view != null) push(response.view);
        else onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('copy dashboard modal initialisation failed'),
            sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
            sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $6aa3f9a2fe12b1cd$var$sendSuccessExperience,
            sendFailedExperience: $6aa3f9a2fe12b1cd$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.COPY_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$6aa3f9a2fe12b1cd$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$var$LazyDashboardModal, {
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onFailed: onFailed,
        onCancel: onCancel,
        id: id
    })) : null;
};
const $6aa3f9a2fe12b1cd$export$4a7ddad8989462fb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.COPY_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6aa3f9a2fe12b1cd$export$bdd968b8df213d5c, props));

});
parcelRegister("dxWhV", function(module, exports) {

let $028b8a9ddf4f0b99$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $028b8a9ddf4f0b99$var$load("h2MrD"),
    $028b8a9ddf4f0b99$var$load("bYT2S"),
    $028b8a9ddf4f0b99$var$load("5k9P8")
]).then(()=>parcelRequire('a7HF6'));

});


parcelRegister("2IJzF", function(module, exports) {

$parcel$export(module.exports, "CreateModal", () => $cdded0b8b2569776$export$204e9f8d79be983e);

var $5uXOq = parcelRequire("5uXOq");

var $j55bS = parcelRequire("j55bS");

var $jgE05 = parcelRequire("jgE05");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $e9QkH = parcelRequire("e9QkH");

var $lVJAU = parcelRequire("lVJAU");
const $cdded0b8b2569776$export$e85d11db57ff5836 = ({ onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_CREATE);
    const { clear: clear } = (0, $gh1hi.useDashboardResource)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = (_, operationResult)=>{
        clear();
        push(`/jira/dashboards/${operationResult.id}/edit`);
        close();
    };
    const onCancel = ()=>{
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgE05.default), {
        onSuccess: onSuccess,
        onCancel: onCancel
    })) : null;
};
const $cdded0b8b2569776$export$204e9f8d79be983e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.CREATE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.CREATE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdded0b8b2569776$export$e85d11db57ff5836, props));

});

parcelRegister("8AXqQ", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $f85fc38ca5cf0b6c$export$73392e09138fecd6);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $j55bS = parcelRequire("j55bS");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $gh1hi = parcelRequire("gh1hi");

var $e9QkH = parcelRequire("e9QkH");

var $kxZPA = parcelRequire("kxZPA");

var $lVJAU = parcelRequire("lVJAU");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f85fc38ca5cf0b6c$var$LazyDeleteModal = (0, $kxZPA.lazy)(()=>(parcelRequire("l6hVW")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
});
const $f85fc38ca5cf0b6c$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $f85fc38ca5cf0b6c$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$f85fc38ca5cf0b6c$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $f85fc38ca5cf0b6c$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$f85fc38ca5cf0b6c$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $f85fc38ca5cf0b6c$export$daf5ee5ed602db71 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_DELETE);
    const { clear: clear } = (0, $gh1hi.useDashboardResource)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onSuccess = ()=>{
        (0, $hh0bW.default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: true
        });
        clear();
        close();
        push('/jira/dashboards');
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('delete dashboard modal initialisation failed'),
            sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
            sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $f85fc38ca5cf0b6c$var$sendSuccessExperience,
            sendFailedExperience: $f85fc38ca5cf0b6c$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.DELETE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$f85fc38ca5cf0b6c$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dashboards-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$var$LazyDeleteModal, {
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onInitiateFailed: onInitiateFailed,
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $f85fc38ca5cf0b6c$export$73392e09138fecd6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.DELETE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f85fc38ca5cf0b6c$export$daf5ee5ed602db71, props));

});
parcelRegister("l6hVW", function(module, exports) {

let $f5c811bd24acce14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5c811bd24acce14$var$load("2CgxW").then(()=>parcelRequire('6ee1k'));

});


parcelRegister("2EGKG", function(module, exports) {

$parcel$export(module.exports, "RenameOrShareModal", () => $952ac229700a831b$export$a113d771e12d2a12);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $j55bS = parcelRequire("j55bS");

var $hh0bW = parcelRequire("hh0bW");

var $JIPqS = parcelRequire("JIPqS");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $e9QkH = parcelRequire("e9QkH");

var $kxZPA = parcelRequire("kxZPA");

var $3TUxF = parcelRequire("3TUxF");

var $iLC4C = parcelRequire("iLC4C");

var $89bLT = parcelRequire("89bLT");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $952ac229700a831b$var$LazyRenameOrShareModal = (0, $kxZPA.lazy)(()=>(parcelRequire("a3eyw")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
});
const $952ac229700a831b$var$expAttributes = {
    analyticsSource: 'dashboard',
    experience: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
    application: null,
    edition: null,
    additionalAttributes: {
        isCancel: false
    }
};
const $952ac229700a831b$var$sendSuccessExperience = ()=>(0, $hh0bW.default)({
        ...$952ac229700a831b$var$expAttributes,
        wasExperienceSuccesful: true
    });
const $952ac229700a831b$var$sendFailedExperience = ()=>(0, $hh0bW.default)({
        ...$952ac229700a831b$var$expAttributes,
        wasExperienceSuccesful: false
    });
const $952ac229700a831b$export$4f6c2201df28de83 = ({ id: id, onModalCloseCallback: onModalCloseCallback })=>{
    const [isOpen, { off: close }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).DASHBOARD_RENAME_OR_SHARE);
    const onEditDashboard = (0, $3TUxF.useEditDashboard)();
    const onSuccess = (_, response)=>{
        onEditDashboard(response);
        $952ac229700a831b$var$sendSuccessExperience();
        close();
        onModalCloseCallback?.();
    };
    const onInitiateFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error || new Error('rename or share dashboard modal initialisation failed'),
            sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
            sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onFailed = (error)=>{
        (0, $iLC4C.handleFetchErrorAsExperience)({
            error: error,
            sendSuccessExperience: $952ac229700a831b$var$sendSuccessExperience,
            sendFailedExperience: $952ac229700a831b$var$sendFailedExperience,
            logErrorEvent: (0, $89bLT.logErrorEventFunc)(error, (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD))
        });
        close();
        onModalCloseCallback?.();
    };
    const onCancel = ()=>{
        (0, $hh0bW.default)({
            ...$952ac229700a831b$var$expAttributes,
            wasExperienceSuccesful: true,
            additionalAttributes: {
                isCancel: true
            }
        });
        close();
        onModalCloseCallback?.();
    };
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "rename-or-share-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j55bS.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$var$LazyRenameOrShareModal, {
        onInitiateFailed: onInitiateFailed,
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: onSuccess,
        onCancel: onCancel,
        onFailed: onFailed,
        id: id
    })) : null;
};
const $952ac229700a831b$export$a113d771e12d2a12 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE),
        packageName: "dashboard",
        fallback: "flag",
        attributes: {
            task: (0, $JIPqS.RENAME_OR_SHARE_DASHBOARD_EXPERIENCE)
        },
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($952ac229700a831b$export$4f6c2201df28de83, props));

});
parcelRegister("3TUxF", function(module, exports) {

$parcel$export(module.exports, "useEditDashboard", () => $481cf9cc3e288e09$export$a7520122589f9056);

var $5uXOq = parcelRequire("5uXOq");

var $gh1hi = parcelRequire("gh1hi");
const $481cf9cc3e288e09$export$a7520122589f9056 = ()=>{
    const { update: update } = (0, $gh1hi.useDashboardResource)();
    return (0, $5uXOq.useCallback)((dashboardData)=>{
        if (!dashboardData) return;
        update((currentData)=>currentData && {
                ...currentData,
                title: dashboardData.name
            });
    }, [
        update
    ]);
};

});

parcelRegister("a3eyw", function(module, exports) {

let $751579b0d527af23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $751579b0d527af23$var$load("h2MrD"),
    $751579b0d527af23$var$load("bYT2S"),
    $751579b0d527af23$var$load("XUjPB")
]).then(()=>parcelRequire('fZpfn'));

});


parcelRegister("x5bVw", function(module, exports) {

$parcel$export(module.exports, "WallboardSlideshow", () => $e8bb3a64b8086b53$export$db3bf5ee6d309e34);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $9UCCQ = parcelRequire("9UCCQ");

var $JIPqS = parcelRequire("JIPqS");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");


var $e9QkH = parcelRequire("e9QkH");

var $9OXo1 = parcelRequire("9OXo1");

var $bOnpg = parcelRequire("bOnpg");

var $b8ziP = parcelRequire("b8ziP");

var $drb8j = parcelRequire("drb8j");
const $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL = '/';
const $e8bb3a64b8086b53$export$11aea547bd3c125e = async ()=>{
    try {
        const response = await fetch('/rest/wallboard/latest/slideshow/url', {
            method: 'GET'
        });
        if (!response.ok) throw new Error(`Error server response: ${response.status}`);
        return response.text();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // if error, then the link would be grayed out
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'viewWallboardSlideshow',
                packageName: 'jiraDashboardInternalCommon'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
    }
};
const $e8bb3a64b8086b53$export$db3bf5ee6d309e34 = ()=>{
    const { isAnonymous: isAnonymous } = (0, $9OXo1.useTenantContext)();
    const [wallboardSlideshowUrl, setWallboardSlideshowUrl] = (0, $5uXOq.useState)(undefined);
    const [, { on: modalWallboardOpen }] = (0, $e9QkH.useSwitchModals)((0, $JIPqS.MODAL_ID).CONFIGURE_WALLBOARD);
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const configureWallboardSlideShowClickHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            actionSubjectId: 'dashboard',
            actionSubject: 'wallboard-slideshow.configure',
            action: 'clicked'
        });
        // Wrapping modalWallboardOpen() inside setTimeout
        // for the focus to be on the dropdown button before opening
        // the modal as part of accessibility ticket DAG-903
        setTimeout(()=>{
            modalWallboardOpen();
        }, 1);
    }, [
        fireAnalytics,
        modalWallboardOpen
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dropdownItemClickHandler: dropdownItemClickHandler } = (0, $b8ziP.useDropdownItemOnClickHandler)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isAnonymous && wallboardSlideshowUrl === undefined) $e8bb3a64b8086b53$export$11aea547bd3c125e().then((url)=>{
            setWallboardSlideshowUrl(url || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL);
        });
    }, [
        isAnonymous,
        wallboardSlideshowUrl
    ]);
    const isViewWallboardSlideshowEnabled = wallboardSlideshowUrl !== $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL && !isAnonymous;
    // `wallboardSlideShowUrl` can be undefined and is generated through a fetch call which may be fail,
    // so we have `EMPTY_WALLBOARD_URL` as a fallback
    const wallboardSlideshowUrlWithFallback = wallboardSlideshowUrl || $e8bb3a64b8086b53$var$EMPTY_WALLBOARD_URL;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        isDisabled: !isViewWallboardSlideshowEnabled,
        href: wallboardSlideshowUrlWithFallback,
        onClick: (e)=>dropdownItemClickHandler(e, wallboardSlideshowUrlWithFallback, 'dashboard.view-wallboard-slideshow-item'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $drb8j.default).wallboardSlideshow)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.action-dropdown.wallboard-slideshow.configure-wallboard",
        onClick: configureWallboardSlideShowClickHandler
    }, formatMessage((0, $drb8j.default).wallboardSetup)));
};

});
parcelRegister("drb8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd6bbd173094bd4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3bd6bbd173094bd4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    wallboardSlideshow: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-slideshow",
        "defaultMessage": "View wallboard slide show"
    },
    wallboardSetup: {
        "id": "dashboard-internal-common.dashboard-content.header.action-dropdown.wallboard-slideshow.wallboard-setup",
        "defaultMessage": "Configure wallboard slide show"
    }
});

});



parcelRegister("dZymr", function(module, exports) {

$parcel$export(module.exports, "ConnectHeader", () => $fa1518cc236818d0$export$a7c3d2bbc29ad451);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");

var $5ILhZ = parcelRequire("5ILhZ");

var $hrlU6 = parcelRequire("hrlU6");

var $edp7U = parcelRequire("edp7U");
const $fa1518cc236818d0$export$965e85c1e0261738 = ({ item: item })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: item.id,
        appearance: "subtle",
        onClick: onWebItemClick,
        ref: webItemRef
    }, item.title);
};
const $fa1518cc236818d0$var$DropdownPressableItem = ({ item: item })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = ()=>{
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        id: item.id,
        onClick: onWebItemClick,
        ref: (ref)=>{
            if (ref) webItemRef.current = ref;
        },
        backgroundColor: "color.background.neutral.subtle"
    }, item.title);
};
const $fa1518cc236818d0$export$275428e5ee6cc209 = ({ items: items })=>{
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: false,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle",
                spacing: "default",
                ...triggerProps,
                ref: triggerRef
            }, "+", items.length),
        shouldFlip: true,
        placement: "bottom-end",
        testId: "dashboard-internal-common.ui.dashboard-content.header.connect-header.dropdown-menu",
        defaultOpen: (0, $edp7U.getIsDropdownDefaultOpen)('connect-header')
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$var$DropdownPressableItem, {
            item: item
        }))));
};
const $fa1518cc236818d0$export$a7c3d2bbc29ad451 = ({ items: items })=>{
    if (!items) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$var$ConnectHeaderWrapper, null, items.slice(0, 4).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$965e85c1e0261738, {
            item: item,
            key: item.id
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa1518cc236818d0$export$275428e5ee6cc209, {
        items: items.slice(4)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fa1518cc236818d0$var$ConnectHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1hbsidpf _1u711b66 _y2qtidpf _fl8b1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1i27D", function(module, exports) {

$parcel$export(module.exports, "HeaderTitle", () => $f69e2b51e1f910f6$export$edb76fdb8665f52);
$parcel$export(module.exports, "HeaderActions", () => $f69e2b51e1f910f6$export$223875819fd7cf93);
$parcel$export(module.exports, "Header", () => $f69e2b51e1f910f6$export$8b251419efc915eb);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $cS37j = parcelRequire("cS37j");

var $kSvVK = parcelRequire("kSvVK");
const $f69e2b51e1f910f6$export$edb76fdb8665f52 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), {
        medium: 4,
        testId: "dashboard-internal-common.ui.dashboard-content.header.header-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), null, children));
const $f69e2b51e1f910f6$export$223875819fd7cf93 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), {
        medium: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSvVK.ActionWrapper), null, children)));
const $f69e2b51e1f910f6$export$8b251419efc915eb = ({ banners: banners, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("header", {
        "data-testid": "dashboard-internal-common.ui.dashboard-content.header.dashboard-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: "fluid",
        spacing: "compact"
    }, children), banners && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSvVK.BannersWrapper), null, banners));

});
parcelRegister("kSvVK", function(module, exports) {

$parcel$export(module.exports, "ActionWrapper", () => $3989dffa8d1c8135$export$3122aab815c89f9a);
$parcel$export(module.exports, "BannersWrapper", () => $3989dffa8d1c8135$export$ab656bce1543f51a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3989dffa8d1c8135$export$3122aab815c89f9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bahesu3 _19pk1ejb _2hwxidpf _otyrpxbi _18u0idpf _xlknidpf _dgz5idpf _18sqidpf _wrjxidpf _11hyu2gc _19kautpp _412c1v6z _1sjdutpp",
            __cmplp.className
        ])
    });
});
const $3989dffa8d1c8135$export$ab656bce1543f51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _zum8idpf _10361ejb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2PcTT", function(module, exports) {

$parcel$export(module.exports, "useConnectMenuItems", () => $fdeff8836b607085$export$58f1b171f06c90ef);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $fdeff8836b607085$export$58f1b171f06c90ef = (dashboardId)=>{
    const [connectMenuItems, setConnectMenuItems] = (0, $5uXOq.useState)({
        headerItems: [],
        toolItems: []
    });
    (0, $5uXOq.useEffect)(()=>{
        // TODO - remove this as types say it should not be necessary
        if (dashboardId == null) return;
        (async ()=>{
            const resourceUrl = `/rest/dashboards/1.0/connect/menuItems/${dashboardId}`;
            try {
                const response = await (0, $7f4tk.default)(resourceUrl);
                setConnectMenuItems(response);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'fetchConnectMenuItems',
                        packageName: 'jiraDashboardInternalCommon',
                        teamName: 'endeavour'
                    }
                });
            }
        })();
    }, [
        dashboardId
    ]);
    return connectMenuItems;
};

});

parcelRegister("lWWbJ", function(module, exports) {

$parcel$export(module.exports, "DashboardRefreshButton", () => $451889f81da240b7$export$2d7dab182c84b535);

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $jOrGg = parcelRequire("jOrGg");

var $JIPqS = parcelRequire("JIPqS");

var $koVbs = parcelRequire("koVbs");


var $bOnpg = parcelRequire("bOnpg");

var $iyrll = parcelRequire("iyrll");
const $451889f81da240b7$export$2d7dab182c84b535 = ()=>{
    const onRefresh = (0, $iyrll.useDashboardRefresh)();
    const [isLoadingBufferVisible, setIsLoadingBufferVisible] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    const label = formatMessage({
        id: 'spa-apps.dashboard.gadget.refresh',
        defaultMessage: 'Refresh',
        description: 'Refresh all gadgets'
    });
    const showLoadingSpinner = ()=>{
        setIsLoadingBufferVisible(true);
        setTimeout(()=>{
            setIsLoadingBufferVisible(false);
        }, (0, $JIPqS.DASHBOARD_REFRESH_LOAD_BUFFER_MS));
    };
    const onClickHandlerRefresh = (0, $5uXOq.useCallback)(()=>{
        onRefresh();
        showLoadingSpinner();
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.refresh-button',
            actionSubjectId: (0, $JIPqS.DASHBOARD_VIEW_SOURCENAME)
        });
    }, [
        fireAnalytics,
        onRefresh
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        spacing: "default",
        onClick: onClickHandlerRefresh,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
            label: "",
            LEGACY_size: "small"
        }),
        testId: "dashboard-internal-common.ui.dashboard-refresh-button.dashboard-refresh-button",
        isLoading: isLoadingBufferVisible
    }, label);
};

});

parcelRegister("9jsHG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $74ae53576ce577d5$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $hcObS = parcelRequire("hcObS");

var $hLZZY = parcelRequire("hLZZY");

var $eXQym = parcelRequire("eXQym");
const $74ae53576ce577d5$export$8d5dab2ad1e19ea0 = ({ dashboardId: dashboardId, dashboardName: dashboardName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.FavoriteButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hLZZY.default), {
        baseUrl: "",
        itemId: dashboardId,
        itemType: (0, $eXQym.DASHBOARDS_ITEM_TYPE),
        favoriteItemName: dashboardName
    }));

});
parcelRegister("hLZZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a968ac170a325ff4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4041n = parcelRequire("4041n");


var $fH2dG = parcelRequire("fH2dG");
class $a968ac170a325ff4$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fH2dG.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("fH2dG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $e0f2aac973023e83$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $1WPu2 = parcelRequire("1WPu2");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $e0f2aac973023e83$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $e0f2aac973023e83$export$8d5dab2ad1e19ea0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$e0f2aac973023e83$var$isProduction && !(0, $eXQym.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $eXQym.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $1WPu2.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("aNPat", function(module, exports) {

$parcel$export(module.exports, "RouteLinkButtonOld", () => $bacdc7ee50699d04$export$c74dddf61fcdf9b0);
$parcel$export(module.exports, "RouteLinkButton", () => $bacdc7ee50699d04$export$64b500ddabb836a3);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $1GGwS = parcelRequire("1GGwS");

var $9VXkC = parcelRequire("9VXkC");
var $hDzhb = parcelRequire("hDzhb");
const $bacdc7ee50699d04$export$c74dddf61fcdf9b0 = ({ children: children, to: to, params: params, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        component: (0, $hDzhb.default),
        ...rest,
        ...to && {
            // Link would not update when 'to' prop changes, so we need to force an update with key
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key: to.name,
            // href prop is required to be passed to the Button component for Button to render as an anchor tag
            // instead of a button tag. Remove this line and related code after this issue is fixed for AK Button.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            href: (0, $9VXkC.generatePath)(to.path, params),
            to: to,
            params: params
        }
    }, children);
const $bacdc7ee50699d04$export$64b500ddabb836a3 = ({ to: to, params: params, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...rest,
        key: to.name,
        href: (0, $9VXkC.generatePath)(to.path, params)
    }, children);

});

parcelRegister("2zwcE", function(module, exports) {

$parcel$export(module.exports, "HeaderCopyLinkButton", () => $35982a17a8499e02$export$23cf9002699304df);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $5T44u = parcelRequire("5T44u");

var $bOnpg = parcelRequire("bOnpg");

const $35982a17a8499e02$var$DASHBOARD_COPY_BUTTON_SPOTLIGHT = 'dashboardCopyLinkButton';
const $35982a17a8499e02$export$23cf9002699304df = ({ dashboardId: dashboardId })=>{
    const fireAnalytics = (0, $bOnpg.useDashboardAnalytics)();
    (0, $5uXOq.useEffect)(()=>{
        if (false) return;
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'viewed',
            actionSubject: 'dashboard.copy-link-button',
            actionSubjectId: 'dashboard'
        });
    }, [
        fireAnalytics
    ]);
    const onCopyLinkHandler = (0, $5uXOq.useCallback)(()=>{
        fireAnalytics({
            eventType: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'dashboard.copy-link-button',
            actionSubjectId: 'dashboard'
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $35982a17a8499e02$var$DASHBOARD_COPY_BUTTON_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5T44u.CopyLinkButton), {
        dashboardId: dashboardId,
        onCopyClick: onCopyLinkHandler
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $35982a17a8499e02$var$DASHBOARD_COPY_BUTTON_SPOTLIGHT
    }));
};

});

parcelRegister("kC29b", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb02b27ed9289820$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bb02b27ed9289820$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    edit: {
        "id": "dashboard-view.header-readonly.edit",
        "defaultMessage": "Edit"
    }
});

});


parcelRegister("kiq64", function(module, exports) {

$parcel$export(module.exports, "UnconfiguredGadgetFallback", () => $b259a1068774e356$export$f3ce61fc49906b8e);

var $5uXOq = parcelRequire("5uXOq");

var $k2tiP = parcelRequire("k2tiP");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $JIPqS = parcelRequire("JIPqS");

var $ii3gE = parcelRequire("ii3gE");

var $i0rkS = parcelRequire("i0rkS");

var $5TsWX = parcelRequire("5TsWX");

var $koVbs = parcelRequire("koVbs");

var $bVDE5 = parcelRequire("bVDE5");

var $8r3Qk = parcelRequire("8r3Qk");
const $b259a1068774e356$export$f3ce61fc49906b8e = ({ id: id, hasEditPermissions: hasEditPermissions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { broadcastMessage: broadcastMessageBusListener }] = (0, $i0rkS.useMessageBus)();
    const [{ currentPageId: currentPageId }] = (0, $bVDE5.useSpaStateTransition)();
    const reportGadgetMetrics = (0, $5uXOq.useCallback)((eventType)=>{
        broadcastMessageBusListener((0, $JIPqS.GADGET_METRICS_TYPE).REPORT, {
            eventType: eventType,
            contentType: 'Unconfigured',
            source: (0, $5TsWX.FALLBACK_GADGET_SOURCE)
        }, {
            gadgetId: id,
            pageId: currentPageId
        });
    }, [
        broadcastMessageBusListener,
        id,
        currentPageId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        reportGadgetMetrics((0, $5TsWX.GADGET_RENDER_CONTAINER_EVENT));
    }, [
        reportGadgetMetrics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ii3gE.GadgetFallback), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            spacing: "spacious",
            label: formatMessage((0, $8r3Qk.default).settingsIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.accent.gray"
    }, formatMessage((0, $8r3Qk.default).mainMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        weight: "semibold",
        color: "color.text.accent.gray"
    }, formatMessage(hasEditPermissions ? (0, $8r3Qk.default).instructionsWithEditPermissions : (0, $8r3Qk.default).instructionsWithoutEditPermissions))));
};

});
parcelRegister("8r3Qk", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd16ba272620eaba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd16ba272620eaba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mainMessage: {
        "id": "dashboard-view.unconfigured-gadget-fallback.main-message",
        "defaultMessage": "This gadget hasn't been configured yet."
    },
    instructionsWithEditPermissions: {
        "id": "dashboard-view.unconfigured-gadget-fallback.instructions-with-edit-permissions",
        "defaultMessage": "To configure this gadget, click the \u2018Edit\u2019 button situated at the top of your dashboard."
    },
    instructionsWithoutEditPermissions: {
        "id": "dashboard-view.unconfigured-gadget-fallback.instructions-without-edit-permissions",
        "defaultMessage": "To configure this gadget, you need permission to edit this dashboard."
    },
    settingsIconLabel: {
        "id": "dashboard-view.unconfigured-gadget-fallback.settings-icon-label",
        "defaultMessage": "Settings"
    }
});

});




//# sourceMappingURL=async-dashboard-view.181ad0bd.js.map
